import { Console } from "console";
import { BrowserMultiFormatReader } from "@zxing/library";
import az_AZ from "antd/es/locale/az_AZ";
import bg_BG from "antd/es/locale/bg_BG";
import ca_ES from "antd/es/locale/ca_ES";
import cs_CZ from "antd/es/locale/cs_CZ";
import da_DK from "antd/es/locale/da_DK";
import de_DE from "antd/es/locale/de_DE";
import el_GR from "antd/es/locale/el_GR";
import en_GB from "antd/es/locale/en_GB";
import en_US from "antd/es/locale/en_US";
import es_ES from "antd/es/locale/es_ES";
import et_EE from "antd/es/locale/et_EE";
import fi_FI from "antd/es/locale/fi_FI";
import fr_FR from "antd/es/locale/fr_FR";
import hr_HR from "antd/es/locale/hr_HR";
import hu_HU from "antd/es/locale/hu_HU";
import hy_AM from "antd/es/locale/hy_AM";
import is_IS from "antd/es/locale/is_IS";
import it_IT from "antd/es/locale/it_IT";
import ka_GE from "antd/es/locale/ka_GE";
import kk_KZ from "antd/es/locale/kk_KZ";
import lt_LT from "antd/es/locale/lt_LT";
import lv_LV from "antd/es/locale/lv_LV";
import mk_MK from "antd/es/locale/mk_MK";
import nb_NO from "antd/es/locale/nb_NO";
import nl_NL from "antd/es/locale/nl_NL";
import pl_PL from "antd/es/locale/pl_PL";
import pt_PT from "antd/es/locale/pt_PT";
import ro_RO from "antd/es/locale/ro_RO";
import ru_RU from "antd/es/locale/ru_RU";
import sk_SK from "antd/es/locale/sk_SK";
import sl_SI from "antd/es/locale/sl_SI";
import sr_RS from "antd/es/locale/sr_RS";
import sv_SE from "antd/es/locale/sv_SE";
import tr_TR from "antd/es/locale/tr_TR";
import uk_UA from "antd/es/locale/uk_UA";
import axios from "axios";
import { Guid } from "guid-typescript";
import _ from "lodash";
import { isInteger, isSafeNumber, parse as losslessParse } from "lossless-json";
import moment from "moment";
import querystringify from "querystringify";
import { store } from "react-notifications-component";
import Swal from "sweetalert2";
import { clearTimeout, setTimeout } from "worker-timers";
import LocalStorageService from "../../auth/local-storage-service";
import { IChangePasswordDto } from "../../models/dto/change-password.dto";
import { ICreateUserWithPasswordDto } from "../../models/dto/create-user-with-password";
import { ICreateUserDto } from "../../models/dto/createuser";
import { IImportMappedExcelColumnMapDefinition, IImportMappedExcelParameter } from "../../models/dto/excel";
import { IForgotPasswordDto } from "../../models/dto/forgotpassword.dto";
import { IIyzicoAddressDto, IIyzicoCheckoutFormDto } from "../../models/dto/iyzico.dto";
import { IResetPasswordWithTokenDto } from "../../models/dto/reset-password-with-token";
import { IRestResult } from "../../models/dto/rest-result.dto";
import { ISignupDto } from "../../models/dto/signup.dto";
import { IStripePayment } from "../../models/dto/stripe-payment";
import {
  IStripeCaptureDto,
  IStripeChargePaymentMethodDto,
  IStripeConnectedAccountDto,
  IStripeConnectedAccountOnboardingDto,
  IStripeConnectedAccountPayout,
  IStripeConnectedAccountWithdraw,
  IStripeCreateConnectedAccountDto,
  IStripeDeletePaymentMethodDto,
  IStripePaymentDto,
  IStripeRefundDto,
  IStripeUpdateCustomerDto
} from "../../models/dto/stripe.dto";
import { IUpdateUserStartingScreen } from "../../models/dto/update-user-starting-screen.dto";
import { IUpdateUsernameDto } from "../../models/dto/update-username.dto";
import { IUserRoleDto } from "../../models/dto/userrole.dto";
import { ITaskDataParameters, getDictionaryValueByKey } from "../../models/dto/workflow-task.dto";
import { EAccountStatus } from "../../models/enum/auth";
import { ELanguage } from "../../models/enum/language";
// Type-only import (erased at compile time, so no runtime import cycle): the inline
// overlay master wrapper publishes a handle of this shape through InlineOverlayNavContext;
// the withInlineOverlayNav HOC injects it as `screen.props.inlineOverlayNav` for screens
// rendered inside the overlay, driving openAs="currentOverlay" navigation (KOA-8559).
import type { IInlineOverlayNav } from "../../routes/master-screen-wrapper";
import { translationService } from "../../services/_singletons";
import { CacheService } from "../../services/cache-service";
import ServerFilesService from "../../services/files-download-service";
import HelperService from "../../services/helper-service";
import { IyzicoService } from "../../services/iyzico-service";
import KuikaCoreWasmBridgeService from "../../services/kuika-core-wasm-bridge-service";
import { LanguageService } from "../../services/language-service";
import NotificationService from "../../services/notification-service";
import OfflineDbPersistenceService from "../../services/offline-db-persistence-service";
import OfflineSyncService from "../../services/offline-sync-service";
import { StripeService } from "../../services/stripe-service";
import { UserService } from "../../services/user-service";
import { WorkflowService } from "../../services/workflow-service";
import { KNavigator } from "../hoc/with-history";
import { OTP_ALGORITHM, OTP_DIGITS, OTP_PERIOD, OTP_SECRET_KEY } from "../json/otp.json";
import { DateFormatValidator } from "./date-format-validator";
import { KuikaAppManager } from "./kuika-app-manager";
import { KMainFunctions } from "./main-functions";



declare let window: Window & { [key: string]: any };
declare let google: any;
let TOKEN = "";
let USER = "";
let enteredPassword = "";

let watchPositionId: number | null = null;
let watchPositionData: {
  latitude: number;
  longitude: number;
  accuracy: number;
} | null = null;

interface IBarcodeDetectorResult {
  rawValue: string;
  format: string;
}
interface IBarcodeDetector {
  detect(source: HTMLVideoElement): Promise<IBarcodeDetectorResult[]>;
}
interface IBarcodeDetectorCtor {
  new (opts: { formats: string[] }): IBarcodeDetector;
}

interface IBarcodeOverlayHandles {
  overlay: HTMLDivElement;
  video: HTMLVideoElement;
  label: HTMLParagraphElement;
  cancelBtn: HTMLButtonElement;
}

// Info passed to lossless-json's onDuplicateKey callback (KOA-17775 response parsing).
interface IDuplicateKeyInfo {
  key: string;
  position: number;
  oldValue: unknown;
  newValue: unknown;
}

export class ReactSystemFunctions {
  // Static bags storage for global access across the app
  private static bags: { [key: string]: any } = {};

  private static translateCache = new WeakMap<
    object,
    {
      byName: Map<string, { idProp: Map<string, string>; propOnly: Map<string, string> }>;
      byShortName: Map<string, { idProp: Map<string, string>; propOnly: Map<string, string> }>;
    }
  >();

  private static getTranslateCache(languages: any[]) {
    let cache = ReactSystemFunctions.translateCache.get(languages);
    if (cache) return cache;

    type PhraseMaps = { idProp: Map<string, string>; propOnly: Map<string, string> };
    const byName = new Map<string, PhraseMaps>();
    const byShortName = new Map<string, PhraseMaps>();

    for (const lang of languages) {
      const idPropMap = new Map<string, string>();
      const propOnlyMap = new Map<string, string>();

      if (lang.LanguagePhrases) {
        for (const phrase of lang.LanguagePhrases) {
          if (phrase.Value) {
            if (phrase.Id) {
              idPropMap.set(`${phrase.Id}\0${phrase.PropertyName}`, phrase.Value);
            }
            if (phrase.PropertyName) {
              propOnlyMap.set(phrase.PropertyName, phrase.Value);
            }
          }
        }
      }

      const combined: PhraseMaps = { idProp: idPropMap, propOnly: propOnlyMap };
      if (lang.Name) byName.set(lang.Name, combined);
      if (lang.ShortName) byShortName.set(lang.ShortName, combined);
    }

    cache = { byName, byShortName };
    ReactSystemFunctions.translateCache.set(languages, cache);
    return cache;
  }

  public static convertToTypeByName(data: any, targetTypeName: string): any {
    if ((data == null || data == undefined) && targetTypeName == "boolean") {
      return false;
    }
    if (data == null) return null;
    targetTypeName = targetTypeName.toLowerCase();
    if (targetTypeName === "string" || targetTypeName === "string?") {
      if (data !== undefined && data !== null) {
        if (this.isValidDateWithFormat(data)) {
          const momentDate = moment(data);
          if (momentDate.isValid()) {
            const mlValue = localStorage.getItem("ml") || "";
            const userLocale = mlValue ? mlValue.split("_")[0] : "";
            moment.locale(userLocale);
            const hasTimeComponent =
              typeof data === "string"
                ? data.includes(":")
                : momentDate.hour() !== 0 || momentDate.minute() !== 0 || momentDate.second() !== 0;

            return momentDate.format(
              hasTimeComponent
                ? `${moment.localeData().longDateFormat("L")} ${moment.localeData().longDateFormat("LT")}`
                : moment.localeData().longDateFormat("L")
            );
          }
          return data.toString();
        }
      }

      return data?.toString();
    }
    if (targetTypeName === "guid" || targetTypeName === "guid?") {
      if (data !== undefined && data !== null && Guid.isGuid(data)) {
        return data.toString();
      }
      return null;
    }
    if (targetTypeName === "boolean" || targetTypeName === "boolean?")
      return !!(data && data.toString && data.toString().toLowerCase() === "true");
    if (targetTypeName === "date" || targetTypeName === "date?") return this.getDate(data);
    if (targetTypeName === "number" || targetTypeName === "number?") {
      // Preserve large integer identifiers that would lose precision via parseFloat (KOA-17775).
      const preserved: string | null = this.preserveUnsafeInteger(data);
      if (preserved !== null) return preserved;
      const value: number = parseFloat(data);
      return Number.isNaN(value) ? null : value;
    }
    if (targetTypeName.includes("[]")) {
      if (Array.isArray(data)) return data;
      return data !== undefined && data !== null ? [...data.split(",")] : [];
    }
    return data;
  }

  static getDate = (data: string) => {
    if (data !== undefined && data !== null && data !== "") {
      const date = moment(data);

      if (date.hour() === 0 && date.minute() === 0 && date.second() === 0 && date.millisecond() === 0) {
        const utcOffset = date.utcOffset() === 0 ? date.utcOffset() : date.utcOffset() / 60;
        date.add(utcOffset, "hours");
      }

      return date;
    }

    return null;
  };

  public static getDynamicInputDataType(screen: any, componentId: string): string | null {
    const dynamicInputRef = screen[`${componentId}_kuikaTextInputRef`];
    if (
      dynamicInputRef &&
      dynamicInputRef.current &&
      dynamicInputRef.current.props &&
      dynamicInputRef.current.props.dataType
    ) {
      return dynamicInputRef.current.props.dataType;
    }

    return null;
  }

  public static getValueWithDynamicType(screen: any, componentId: string, targetTypeName: string, value: any): any {
    const rawValue = value;

    const dynamicDataType = this.getDynamicInputDataType(screen, `${componentId}_value`);

    const _dynamicDataType = (() => {
      if (
        targetTypeName?.toLowerCase() === "guid" ||
        targetTypeName?.toLowerCase() === "guid?" ||
        targetTypeName?.includes("[]")
      ) {
        return null;
      }
      switch (dynamicDataType) {
        case "String":
          return "string";
        case "Number":
          return "number";
        case "Boolean":
          return "boolean";
        case "DateTimeOffset":
          return "date";
        default:
          return null;
      }
    })();

    if (_dynamicDataType) {
      return this.convertToTypeByName(rawValue, _dynamicDataType);
    }

    if (targetTypeName) {
      return this.convertToTypeByName(rawValue, targetTypeName);
    }

    return rawValue;
  }

  private static toCamelCase = (str: string): string => {
    return str.replace(/^([A-Z])|[\s-](\w)/g, (match, p1, p2) => {
      if (p2) {
        return p2.toUpperCase();
      }

      return p1.toLowerCase();
    });
  };

  private static parseHashUrl(url: string): { pathname: string; hash: string } {
    const hashIndex = url.indexOf("#");
    if (hashIndex === -1) {
      return { pathname: url, hash: "" };
    }
    return {
      pathname: url.substring(0, hashIndex),
      hash: url.substring(hashIndex)
    };
  }

  private static getValueFromPath = (data: object, path: string, index?: number): any => {
    if (!path || !data) return data;

    // Split path and filter based on [selected] marker
    const fields: string[] = path
      .split(".")
      .filter((field: string, idx: number, array: string[]) => {
        const theFieldIndexContainingSelected = array.findIndex((x) => x.includes("[selected]"));

        if (theFieldIndexContainingSelected > -1) {
          return idx > theFieldIndexContainingSelected;
        }

        return true;
      })
      .map((x) => ReactSystemFunctions.toCamelCase(x));

    const value = fields.reduce((prev: any, curr: string) => {
      if (!prev) return "";
      let result = null;

      if (curr.endsWith("[first]")) {
        const field: string = curr.replace("[first]", "");
        result = prev?.[field]?.at?.(0);
      } else if (curr.endsWith("[last]")) {
        const field: string = curr.replace("[last]", "");
        result = prev?.[field]?.at?.(-1);
      } else if (curr.endsWith("[selected]")) {
        const field: string = curr.replace("[selected]", "");
        result = prev?.[field]?.at?.(index ?? 0);
      } else {
        const field: string = curr;
        result = prev?.[field];
      }

      return result;
    }, data);

    return value;
  };

  // public static async listMyTasks(that: any, showPool: any, page: any, pageSize: any, searchKey: any) {
  //   const user = that.props?.context?.userInfo?.username;
  //   if (user === undefined) {
  //     return [];
  //   }
  //   const request = {
  //     user,
  //     app: window.kuika.info.applicationName,
  //     searchKey,
  //     showPool,
  //     page,
  //     pageSize
  //   };
  //   const tasks = await WorkflowService.ListMyTasks(request);
  //   return tasks;
  // }

  // public static async listMyRequests(
  //   that: any,
  //   showCompleted: any,
  //   page: any,
  //   pageSize: any,
  //   processName: any,
  //   searchKey: any
  // ) {
  //   const user = that.props?.context?.userInfo?.username;
  //   if (user === undefined) {
  //     return [];
  //   }
  //   const request = {
  //     user,
  //     app: window.kuika.info.applicationName,
  //     searchKey,
  //     processName,
  //     showCompleted,
  //     page,
  //     pageSize
  //   };
  //   const tasks = await WorkflowService.ListMyRequests(request);
  //   return tasks;
  // }

  // public static async getTaskDetail(stepInstance: string) {
  //   const history = await WorkflowService.GetTaskDetail(stepInstance.toString());
  //   return history;
  // }

  // public static async showHistory(processInstance: string) {
  //   const history = await WorkflowService.ShowWorkflowHistory(processInstance);
  //   return history;
  // }

  // Authentication
  // signup({a0}, {a1}, {a2}, {a3})

  public static async signup(
    _screen: any,
    username: string,
    password: string,
    firstName: string,
    lastName: string,
    confirmEmail?: boolean,
    dontSendEmail?: boolean,
    phoneNumber?: string,
    language?: string
  ) {
    const credientials = {
      username,
      password,
      firstName,
      lastName,
      VerifyEMailAddress: confirmEmail || false,
      dontSendEmail: dontSendEmail || false,
      phoneNumber: phoneNumber || "",
      language: language || ""
    } as ISignupDto;
    LocalStorageService.clearToken();
    window.userInfo = undefined;
    const res = await UserService.SignUp(credientials);
    USER = username;
    enteredPassword = password;
    if (res?.data?.status !== undefined) {
      LocalStorageService.setLoginStatus(res.data.status);
      LocalStorageService.setVerificationUserName(
        res.data.status === EAccountStatus.TwoFactorAuthentication ? username : ""
      );
    }
    return res;
  }

  public static async isVerificationCodeValid(_screen: any, verificationCode: string) {
    TOKEN = verificationCode;
    const loginStatus = LocalStorageService.getLoginStatus();
    if (OTP_SECRET_KEY) {
      const userName = USER || LocalStorageService.getVerificationUserName();
      const otp = await this.generateOTP(userName || "");
      if (otp === verificationCode) {
        return true;
      }
    }
    if (loginStatus === EAccountStatus.TwoFactorAuthentication.toString()) return;

    const res = await UserService.VerifyVerificationCode({
      username: USER,
      verificationCode
    });
    if (KMainFunctions.IsResStatus2XX(res)) {
      LocalStorageService.setVerificationStatus("true");
      return true;
    }
    LocalStorageService.setVerificationStatus("false");
    return false;
  }

  public static async setPasswordWithVerificationCode(
    _screen: any,
    userName: string,
    verificationCode: string,
    newPassword: string,
    language?: string
  ) {
    const res = await UserService.ResetPasswordWithToken({
      UserName: userName,
      newPassword,
      token: verificationCode,
      dontSendEmail: false,
      language: language || ""
    });
    if (KMainFunctions.IsResStatus2XX(res)) {
      LocalStorageService.setResetPasswordStatus(EAccountStatus.Valid);
      return true;
    }

    LocalStorageService.setResetPasswordStatus(EAccountStatus.ForceResetPassword);
    return false;
  }

  public static async encryptedSignin(username: string, password: string) {
    USER = username;
    TOKEN = password;
    enteredPassword = password;
    return this.signin(undefined, username, password, true);
  }

  public static async signin(
    _screen: any,
    username: string,
    password: string,
    isEncrypted: boolean = false
  ): Promise<any> {
    let loginFunction = UserService.Login;
    if (!isEncrypted) {
      USER = username;
      enteredPassword = password;
      TOKEN = password;
    } else {
      loginFunction = UserService.EncryptedLogin;
    }

    await loginFunction({
      username,
      password
    }).then(
      (res) => {
        LocalStorageService.setLoginStatus(res.data?.status?.toString());
        LocalStorageService.setVerificationUserName(
          res.data?.status === EAccountStatus.TwoFactorAuthentication ? username : ""
        );
        return res;
      },
      (error) => {
        if (
          error.message === "Your password has expired" ||
          error.message === "Şifrenizin süresi doldu" ||
          error.message === "Votre mot de passe a expiré"
        ) {
          KMainFunctions.displayWarningNotification(error.message);
          LocalStorageService.setLoginStatus("1");
        }

        if (error.response?.data?.message) {
          alert(error.response.data.message);
          window.location.reload();
        }
      }
    );
    return {};
  }

  public static async SigninWithDelegation(toUserName: string): Promise<any> {
    await UserService.ReLoginWithDelegation({
      ToUserName: toUserName
    }).then(
      (res) => {
        LocalStorageService.setLoginStatus(res.data?.status?.toString());
        return res;
      },
      (error) => {
        if (
          error.message === "Your password has expired" ||
          error.message === "Şifrenizin süresi doldu" ||
          error.message === "Votre mot de passe a expiré"
        ) {
          KMainFunctions.displayWarningNotification(error.message);
          LocalStorageService.setLoginStatus("1");
        }

        if (error.response?.data?.message) {
          alert(error.response.data.message);
          window.location.reload();
        }
      }
    );
    return {};
  }

  public static async ReturnToUserSessionFromDelegation(): Promise<any> {
    await UserService.ReturnToUserSessionFromDelegation().then(
      (res) => {
        LocalStorageService.setLoginStatus(res.data?.status?.toString());
        return res;
      },
      (error) => {
        if (
          error.message === "Your password has expired" ||
          error.message === "Şifrenizin süresi doldu" ||
          error.message === "Votre mot de passe a expiré"
        ) {
          KMainFunctions.displayWarningNotification(error.message);
          LocalStorageService.setLoginStatus("1");
        }

        if (error.response?.data?.message) {
          alert(error.response.data.message);
          window.location.reload();
        }
      }
    );
    return {};
  }

  public static async signinWithVerificationCode(): Promise<any> {
    await UserService.LoginWithVerificationCode({
      username: USER,
      verificationCode: TOKEN
    }).then(
      (res) => {
        if (res.data?.status) LocalStorageService.setLoginStatus(res.data?.status?.toString());
        return res;
      },
      (error) => {
        if (error.response?.data?.message) {
          alert(error.response.data.message);
          window.location.reload();
        }
      }
    );
    return {};
  }

  public static async goToNextScreenAfterSignup(screen: any) {
    const status = LocalStorageService.getLoginStatus();
    if (status == EAccountStatus.ShouldActivated.toString()) {
      screen.props.navigator.goToVerificationCodeScreen();
    } else if (status == EAccountStatus.Valid.toString()) {
      await this.signin(this, USER, enteredPassword);
      this.goToNextScreenAfterLogin(screen);
    }
    return true;
  }

  public static goToNextScreenAfterLogin(screen: any) {
    const status = LocalStorageService.getLoginStatus();
    const uriParams = querystringify.parse(window.location.search) as {
      redirectUri?: string;
    };
    if (status == EAccountStatus.ForceResetPassword.toString()) {
      screen.props.navigator.goToResetPasswordScreen();
    } else if (
      status == EAccountStatus.ShouldActivated.toString() ||
      status == EAccountStatus.TwoFactorAuthentication.toString()
    ) {
      screen.props.navigator.goToVerificationCodeScreen();
    } else if (status == EAccountStatus.Valid.toString() && Object.keys(uriParams).length === 0) {
      screen.props.navigator.gotoStartingScreen();
    } else if (status == EAccountStatus.Valid.toString() && Object.keys(uriParams).length > 0) {
      screen.props.navigator.gotoUrl(uriParams.redirectUri);
    }
    return true;
  }

  public static goToSignInActivity(screen: any) {
    if (LocalStorageService.getResetPasswordStatus() === EAccountStatus.ForceResetPassword.toString()) {
      LocalStorageService.setResetPasswordStatus("");
      return;
    }

    if (LocalStorageService.getResetPasswordStatus() == EAccountStatus.Valid.toString()) {
      LocalStorageService.setResetPasswordStatus("");
      HelperService.gotoLogin();
    } else {
      LocalStorageService.setResetPasswordStatus("");
      LocalStorageService.clearToken();
      window.userInfo = undefined;
      screen.props.navigator.gotoStartingScreen("/");
    }
  }

  public static async goToNextScreenAfterVerifyCode(screen: any) {
    const status = LocalStorageService.getLoginStatus();
    const verificationStatus = LocalStorageService.getVerificationStatus();
    if (status == EAccountStatus.ShouldActivated.toString()) {
      await this.signin(this, USER, enteredPassword);
      this.goToNextScreenAfterLogin(screen);
    } else if (status == EAccountStatus.TwoFactorAuthentication.toString()) {
      await this.signinWithVerificationCode();
      this.goToNextScreenAfterLogin(screen);
    } else if (verificationStatus === "true") {
      screen.props.navigator.goToResetPasswordScreen();
    }
    return true;
  }

  public static goToVerificationCodeActivity(screen: {
    props: { navigator: { goToVerificationCodeScreen: () => void } };
  }) {
    const email = LocalStorageService.getForgotPasswordEmail();
    if (email) screen.props.navigator.goToVerificationCodeScreen();
  }

  public static async forgotPassword(
    _screen: any,
    username: string,
    dontSendEmail?: boolean,
    language?: string
  ): Promise<any> {
    USER = username;
    const credientials = {
      email: username,
      dontSendEmail: dontSendEmail || false,
      language: language || ""
    } as IForgotPasswordDto;

    await UserService.ForgotPassword(credientials);
  }

  public static async createUser(
    username: string,
    firstName: string,
    lastName: string,
    dontSendEmail?: boolean,
    phoneNumber?: string,
    language?: string
  ): Promise<any> {
    const credientials = {
      username,
      firstName,
      lastName,
      dontSendEmail: dontSendEmail || false,
      phoneNumber: phoneNumber || "",
      language: language || ""
    } as ICreateUserDto;

    return UserService.CreateUser(credientials);
  }

  public static async createUserWithPassword(
    username: string,
    password: string,
    firstName: string,
    lastName: string,
    dontSendEmail?: boolean,
    phoneNumber?: string,
    language?: string
  ): Promise<string> {
    const credientials = {
      username,
      password,
      firstName,
      lastName,
      dontSendEmail: dontSendEmail || false,
      phoneNumber: phoneNumber || "",
      language: language || ""
    } as ICreateUserWithPasswordDto;

    return UserService.CreateUserWithPassword(credientials);
  }

  public static async resetPassword(
    _screen: any,
    newpassword: string,
    dontSendEmail?: boolean,
    language?: string
  ): Promise<void> {
    const credientials = {
      newPassword: newpassword,
      token: TOKEN,
      UserName: USER,
      dontSendEmail: dontSendEmail || false,
      language: language || ""
    } as IResetPasswordWithTokenDto;
    enteredPassword = newpassword;
    const res = await UserService.ResetPassword(credientials);

    if (KMainFunctions.IsResStatus2XX(res)) {
      LocalStorageService.setResetPasswordStatus(EAccountStatus.Valid);
    } else {
      LocalStorageService.setResetPasswordStatus(EAccountStatus.ForceResetPassword);
    }
  }

  public static async addUserToRole(roleName: string, userName: string) {
    const credientials = {
      roleName,
      userName
    } as IUserRoleDto;

    const res = await UserService.AddUserToRole(credientials);
    if (KMainFunctions.IsResStatus2XX(res) && res.data) return res.data;
    return null;
  }

  public static async removeUserFromRole(roleName: string, userName: string) {
    const credientials = {
      roleName,
      userName
    } as IUserRoleDto;

    const res = await UserService.RemoveUserFromRole(credientials);
    if (KMainFunctions.IsResStatus2XX(res) && res.data) return res.data;
    return null;
  }

  public static async enableUser(userName: string): Promise<any> {
    let data = (await UserService.EnableUser(userName)).data;
    return data;
  }

  public static async disableUser(userName: string): Promise<any> {
    let data = (await UserService.DisableUser(userName)).data;
    return data;
  }

  // signin: _signin,
  // signup: _signup,
  // createUser: _createUser,
  // getMyUsername: _getMyUsername,
  // sendResetPasswordMail: _sendResetPasswordMail,
  // resetPassword: _resetPassword,
  // changePassword: _changePassword,
  // logout: _logout,
  // hasRole: _hasRole,
  // hasOneOfRoles: _hasOneOfRoles,

  public static sendResetPasswordMail(_val: string) {
    console.log("TODO!");
  }

  // Convertion
  public static dateAddYears(date: any, yearsToAdd: any) {
    const d = moment(date);
    d.add(yearsToAdd, "years");
    return d;
  }

  public static dateAddDays(date: any, daysToAdd: any) {
    const d = moment(date);
    d.add(daysToAdd, "days");
    return d;
  }

  public static dateAddMinutes(date: any, minutesToAdd: any) {
    const d = moment(date);
    d.add(minutesToAdd, "minutes");
    return d;
  }

  public static dateAddHours(date: any, hoursToAdd: any) {
    const d = moment(date);
    d.add(hoursToAdd, "hours");
    return d;
  }

  public static dateDiffInMinutes(date1: any, date2: any) {
    const a = moment(date1);
    const b = moment(date2);

    return b.diff(a, "minutes");
  }

  public static dateDiffInHours(date1: any, date2: any) {
    const a = moment(date1);
    const b = moment(date2);

    return b.diff(a, "hours");
  }

  public static dateDiffInDays(date1: any, date2: any) {
    const a = moment(date1);
    const b = moment(date2);

    return b.diff(a, "days");
  }

  public static value(
    screen: any,
    val: any,
    varName?: string,
    actionName?: string,
    pkFieldName?: string,
    targetField?: string
  ) {
    if (
      actionName &&
      actionName.length > 0 &&
      pkFieldName &&
      pkFieldName.length > 0 &&
      targetField &&
      targetField.length > 0 &&
      pkFieldName !== targetField
    ) {
      if (
        varName != undefined &&
        screen[`${val}_kuikaSelectBoxRef`] != undefined &&
        screen[`${val}_kuikaSelectBoxRef`] != null &&
        screen[`${val}_kuikaSelectBoxRef`].current != undefined &&
        screen[`${val}_kuikaSelectBoxRef`].current != null &&
        screen[`${val}_kuikaSelectBoxRef`].current.getAllData != undefined
      ) {
        const selectBoxOptionsProp = screen[`${val}_kuikaSelectBoxRef`].current.getAllData();
        if (selectBoxOptionsProp && selectBoxOptionsProp.find) {
          const result = selectBoxOptionsProp.find(
            (x: { [x: string]: any }) => x[pkFieldName] == screen.props.form.getFieldValue(val)
          );
          if (result && result[targetField] !== undefined) return result[targetField];
        }
      } else {
        if (Array.isArray(screen.props.form.getFieldValue(val))) {
          const result = screen.state[actionName]?.filter((x: { [x: string]: any }) =>
            screen.props.form.getFieldValue?.(val)?.includes?.(x?.[pkFieldName])
          );
          if (result && result.length > 0 && result?.[0] && result?.[0]?.[targetField] !== undefined) {
            return result?.map?.((x: { [x: string]: any }) => x?.[targetField]);
          }
        }
        const result = screen.state[actionName]?.find(
          (x: { [x: string]: any }) => x[pkFieldName] == screen.props.form.getFieldValue(val)
        );
        if (result && result[targetField] !== undefined) return result[targetField];
      }
    }
    if (
      varName != undefined &&
      screen[`${val}_kuikaMultiSelectRef`] != undefined &&
      screen[`${val}_kuikaMultiSelectRef`] != null &&
      screen[`${val}_kuikaMultiSelectRef`].current != undefined &&
      screen[`${val}_kuikaMultiSelectRef`].current != null &&
      screen[`${val}_kuikaMultiSelectRef`].current.getAllData != undefined
    ) {
      const selectBoxOptionsProp = screen[`${val}_kuikaMultiSelectRef`].current.getAllData();
      if (selectBoxOptionsProp && selectBoxOptionsProp.find) {
        const result = selectBoxOptionsProp?.filter((x: { [x: string]: any }) =>
          screen.props.form.getFieldValue?.(val)?.includes?.(x?.[pkFieldName])
        );
        if (result && result.length > 0 && result?.[0] && result?.[0]?.[targetField] !== undefined) {
          return result?.map?.((x: { [x: string]: any }) => x?.[targetField]);
        }
      }
    }

    if (
      varName != undefined &&
      screen[`${val}_kuikaNoneRef`] != undefined &&
      screen[`${val}_kuikaNoneRef`] != null &&
      screen[`${val}_kuikaNoneRef`].current != undefined &&
      screen[`${val}_kuikaNoneRef`].current != null
    ) {
      const bigFileUploadRef = screen[`${val}_kuikaNoneRef`].current;
      if (varName == "fileId") return bigFileUploadRef.getLastFileId?.() ?? "";
      if (varName == "fileName") return bigFileUploadRef.getLastFileName?.() ?? "";
      if (varName == "fileIds") return bigFileUploadRef.getFileIds?.() ?? [];
      if (varName == "fileNames") return bigFileUploadRef.getFileNames?.() ?? [];
    }

    if (
      varName != undefined &&
      screen[`${val}_kuikaRecaptchaRef`] != undefined &&
      screen[`${val}_kuikaRecaptchaRef`] != null &&
      screen[`${val}_kuikaRecaptchaRef`].current != undefined &&
      screen[`${val}_kuikaRecaptchaRef`].current != null
    ) {
      if (varName == "token") return screen[`${val}_kuikaRecaptchaRef`].current.state.token;
    }

    if (
      varName != undefined &&
      screen[`${val}_kuikaTableRef`] != undefined &&
      screen[`${val}_kuikaTableRef`] != null &&
      screen[`${val}_kuikaTableRef`].current != undefined &&
      screen[`${val}_kuikaTableRef`].current != null &&
      screen[`${val}_kuikaTableRef`].current.getSelectedRowData != undefined
    ) {
      const currentTableRef = screen[`${val}_kuikaTableRef`].current;

      // Table-level properties belong to the table component itself, not to row data.
      // Resolve them directly from the table ref before nested-table parent row lookup,
      // which only contains column fields and would return undefined for these.
      if (varName.charAt(0) === ".") varName = varName.substr(1);
      if (varName === "k_rowIndex") {
        return currentTableRef.getSelectedIndex();
      }
      if (varName === "k_columnIndex") {
        return currentTableRef.getSelectedColumnIndex();
      }
      if (varName === "selectedValues") {
        return currentTableRef.getSelectedValues();
      }
      if (varName === "dataSource") {
        return currentTableRef.getDataSource();
      }

      const parentTableId = currentTableRef?.getParentTableIdIfExist();
      const newVal = val.replace(currentTableRef?.props?.id, parentTableId);
      const parentTableRef = this.getParentOfBaseTableElementRef(screen, newVal);

      if (parentTableRef?.current) {
        const dataSourcePath = currentTableRef.props?.dataSourceOriginal?.match(
          /\[datafield:((?:(?!\[datafield:).)*)\]/
        );
        const dataSourcePathValue = dataSourcePath ? dataSourcePath[1] : "";

        const nestedTableRowIdx = parentTableRef.current.getNestedTableSelectedIndex(
          document.getElementById(parentTableId),
          currentTableRef?.props?.id
        );

        if (
          nestedTableRowIdx !== undefined &&
          parentTableRef.current.getSelectedRowData()[dataSourcePathValue] !== undefined &&
          parentTableRef.current.getSelectedRowData()[dataSourcePathValue][nestedTableRowIdx] !== undefined
        ) {
          return parentTableRef.current.getSelectedRowData()[dataSourcePathValue][nestedTableRowIdx][varName];
        }
      }
      const rowData = screen[`${val}_kuikaTableRef`].current.getSelectedRowData();
      if (!rowData) return undefined;
      if (_.isEmpty(varName)) return rowData;
      // Use path resolving for nested fields with modifiers like [first], [last], [selected]
      return varName.includes(".") || varName.includes("[")
        ? ReactSystemFunctions.getValueFromPath(
            rowData,
            varName,
            screen[`${val}_kuikaTableRef`].current.getSelectedIndex()
          )
        : rowData[varName];
    }

    if (
      varName != undefined &&
      screen[`${val}_kuikaKanbanBoardRef`] != undefined &&
      screen[`${val}_kuikaKanbanBoardRef`] != null &&
      screen[`${val}_kuikaKanbanBoardRef`].current != undefined &&
      screen[`${val}_kuikaKanbanBoardRef`].current != null
    ) {
      if (varName === "laneId" || targetField === "k_laneId") {
        return screen[`${val}_kuikaKanbanBoardRef`].current.getLaneId();
      }

      if (varName === "laneTitle" || targetField === "k_laneTitle") {
        return screen[`${val}_kuikaKanbanBoardRef`].current.getLaneTitle();
      }

      if (varName === "laneLabel" || targetField === "k_laneLabel") {
        return screen[`${val}_kuikaKanbanBoardRef`].current.getLaneLabel();
      }

      if (varName === "laneDroppable" || targetField === "k_laneDroppable") {
        return screen[`${val}_kuikaKanbanBoardRef`].current.getLaneDroppable();
      }

      if (varName === "laneIndex" || targetField === "k_laneIndex") {
        return screen[`${val}_kuikaKanbanBoardRef`].current.getLaneIndex();
      }

      if (varName === "laneTargetIndex" || targetField === "k_laneTargetIndex") {
        return screen[`${val}_kuikaKanbanBoardRef`].current.getLaneTargetIndex();
      }

      if (varName === "cardId" || targetField === "k_cardId") {
        return screen[`${val}_kuikaKanbanBoardRef`].current.getCardId();
      }

      if (varName === "cardLaneId" || targetField === "k_cardLaneId") {
        return screen[`${val}_kuikaKanbanBoardRef`].current.getCardLaneId();
      }

      if (varName === "cardTargetLaneId" || targetField === "k_cardTargetLaneId") {
        return screen[`${val}_kuikaKanbanBoardRef`].current.getCardTargetLaneId();
      }

      if (varName === "cardTitle" || targetField === "k_cardTitle") {
        return screen[`${val}_kuikaKanbanBoardRef`].current.getCardTitle();
      }

      if (varName === "cardLabel" || targetField === "k_cardLabel") {
        return screen[`${val}_kuikaKanbanBoardRef`].current.getCardLabel();
      }

      if (varName === "cardSubTitle" || targetField === "k_cardSubTitle") {
        return screen[`${val}_kuikaKanbanBoardRef`].current.getCardSubTitle();
      }

      if (varName === "cardDescription" || targetField === "k_cardDescription") {
        return screen[`${val}_kuikaKanbanBoardRef`].current.getCardDescription();
      }

      if (varName === "cardEscalationText" || targetField === "k_cardEscalationText") {
        return screen[`${val}_kuikaKanbanBoardRef`].current.getCardEscalationText();
      }

      if (varName === "cardDraggable" || targetField === "k_cardDraggable") {
        return screen[`${val}_kuikaKanbanBoardRef`].current.getCardDraggable();
      }

      if (varName === "cardIndex" || targetField === "k_cardIndex") {
        return screen[`${val}_kuikaKanbanBoardRef`].current.getCardIndex();
      }

      if (varName === "cardTargetIndex" || targetField === "k_cardTargetIndex") {
        return screen[`${val}_kuikaKanbanBoardRef`].current.getCardTargetIndex();
      }

      if (varName.charAt(0) === ".") varName = varName.substr(1);

      const keys = varName.split(".");

      // if selected card/lane data requested
      if (keys.length > 1) {
        let value = keys.reduce(
          (obj, key) => obj[key?.replaceAll("?", "")],
          screen[`${val}_kuikaKanbanBoardRef`].current
        );

        return value;
      }

      return (
        screen[`${val}_kuikaKanbanBoardRef`].current.getSelectedData() &&
        screen[`${val}_kuikaKanbanBoardRef`].current.getSelectedData()[varName]
      );
    }

    if (
      varName != undefined &&
      screen[`${val}_kuikaNodeTreeRef`] != undefined &&
      screen[`${val}_kuikaNodeTreeRef`] != null &&
      screen[`${val}_kuikaNodeTreeRef`].current != undefined &&
      screen[`${val}_kuikaNodeTreeRef`].current != null
    ) {
      if (varName.charAt(0) === ".") varName = varName.substr(1);

      const keys = varName.split(".");

      if (keys.length > 1) {
        let value = keys.reduce((obj, key) => obj[key?.replaceAll("?", "")], screen[`${val}_kuikaNodeTreeRef`].current);

        return value;
      }

      return (
        screen[`${val}_kuikaNodeTreeRef`].current.getSelectedData() &&
        screen[`${val}_kuikaNodeTreeRef`].current.getSelectedData()[varName]
      );
    }

    if (
      varName != undefined &&
      screen[`${val}_kuikaGalleryViewRef`] != undefined &&
      screen[`${val}_kuikaGalleryViewRef`] != null &&
      screen[`${val}_kuikaGalleryViewRef`].current != undefined &&
      screen[`${val}_kuikaGalleryViewRef`].current != null &&
      screen[`${val}_kuikaGalleryViewRef`].current.getSelectedRowData != undefined
    ) {
      const currentGalleryRef = screen[`${val}_kuikaGalleryViewRef`].current;

      const parentTableId = currentGalleryRef?.getParentTableIdIfExist?.();
      const newVal = val.replace(currentGalleryRef?.props?.id, parentTableId);

      const parentTableRef = this.getParentOfBaseTableElementRef(screen, newVal);

      if (parentTableRef?.current) {
        const dataSourcePath = currentGalleryRef.props?.dataSourceOriginal?.match(
          /\[datafield:((?:(?!\[datafield:).)*)\]/
        );
        const dataSourcePathValue = dataSourcePath ? dataSourcePath[1] : "";

        const nestedTableRowIdx = parentTableRef.current.getNestedTableSelectedIndex(
          document.getElementById(parentTableId),
          currentGalleryRef?.props?.id
        );

        if (
          nestedTableRowIdx !== undefined &&
          parentTableRef.current.getSelectedRowData()[dataSourcePathValue] !== undefined &&
          parentTableRef.current.getSelectedRowData()[dataSourcePathValue][nestedTableRowIdx] !== undefined
        ) {
          return parentTableRef.current.getSelectedRowData()[dataSourcePathValue][nestedTableRowIdx][varName];
        }
      }

      if (varName.charAt(0) === ".") varName = varName.substr(1);

      if (varName === "k_rowIndex") {
        return screen[`${val}_kuikaGalleryViewRef`].current.getSelectedIndex();
      }

      const rowData = screen[`${val}_kuikaGalleryViewRef`].current.getSelectedRowData();
      if (!rowData) return undefined;
      if (_.isEmpty(varName)) return rowData;
      // Use path resolving for nested fields with modifiers like [first], [last], [selected]
      return varName.includes(".") || varName.includes("[")
        ? ReactSystemFunctions.getValueFromPath(
            rowData,
            varName,
            screen[`${val}_kuikaGalleryViewRef`].current.getSelectedIndex()
          )
        : rowData[varName];
    }
    if (
      varName != undefined &&
      screen[`${val}_kuikaCarouselRef`] != undefined &&
      screen[`${val}_kuikaCarouselRef`] != null &&
      screen[`${val}_kuikaCarouselRef`].current != undefined &&
      screen[`${val}_kuikaCarouselRef`].current != null &&
      screen[`${val}_kuikaCarouselRef`].current.getSelectedRowData != undefined
    ) {
      const currentCarouselRef = screen[`${val}_kuikaCarouselRef`].current;

      const parentTableId = currentCarouselRef?.getParentTableIdIfExist?.();
      const newVal = val.replace(currentCarouselRef?.props?.id, parentTableId);

      const parentTableRef = this.getParentOfBaseTableElementRef(screen, newVal);

      if (parentTableRef?.current) {
        const dataSourcePath = currentCarouselRef.props?.dataSourceOriginal?.match(
          /\[datafield:((?:(?!\[datafield:).)*)\]/
        );
        const dataSourcePathValue = dataSourcePath ? dataSourcePath[1] : "";

        const nestedTableRowIdx = parentTableRef.current.getNestedTableSelectedIndex(
          document.getElementById(parentTableId),
          currentCarouselRef?.props?.id
        );

        if (
          nestedTableRowIdx !== undefined &&
          parentTableRef.current.getSelectedRowData()[dataSourcePathValue] !== undefined &&
          parentTableRef.current.getSelectedRowData()[dataSourcePathValue][nestedTableRowIdx] !== undefined
        ) {
          return parentTableRef.current.getSelectedRowData()[dataSourcePathValue][nestedTableRowIdx][varName];
        }
      }

      if (varName.charAt(0) === ".") varName = varName.substr(1);

      if (varName === "k_rowIndex") {
        return screen[`${val}_kuikaCarouselRef`].current.getSelectedIndex();
      }

      const rowData = screen[`${val}_kuikaCarouselRef`].current.getCarouselCurrentData();
      if (!rowData) return undefined;
      if (_.isEmpty(varName)) return rowData;
      // Use path resolving for nested fields with modifiers like [first], [last], [selected]
      return varName.includes(".") || varName.includes("[")
        ? ReactSystemFunctions.getValueFromPath(
            rowData,
            varName,
            screen[`${val}_kuikaCarouselRef`].current.getSelectedIndex()
          )
        : rowData[varName];
    }
    if (
      varName != undefined &&
      screen[`${val}_kuikaFlexGridRef`] != undefined &&
      screen[`${val}_kuikaFlexGridRef`] != null &&
      screen[`${val}_kuikaFlexGridRef`].current != undefined &&
      screen[`${val}_kuikaFlexGridRef`].current != null &&
      screen[`${val}_kuikaFlexGridRef`].current.getSelectedRowData != undefined
    ) {
      const currentFlexGridRef = screen[`${val}_kuikaFlexGridRef`].current;

      const parentTableId = currentFlexGridRef?.getParentTableIdIfExist?.();
      const newVal = val.replace(currentFlexGridRef?.props?.id, parentTableId);

      const parentTableRef = this.getParentOfBaseTableElementRef(screen, newVal);

      if (parentTableRef?.current) {
        const dataSourcePath = currentFlexGridRef.props?.dataSourceOriginal?.match(
          /\[datafield:((?:(?!\[datafield:).)*)\]/
        );
        const dataSourcePathValue = dataSourcePath ? dataSourcePath[1] : "";

        const nestedTableRowIdx = parentTableRef.current.getNestedTableSelectedIndex(
          document.getElementById(parentTableId),
          currentFlexGridRef?.props?.id
        );

        if (
          nestedTableRowIdx !== undefined &&
          parentTableRef.current.getSelectedRowData()[dataSourcePathValue] !== undefined &&
          parentTableRef.current.getSelectedRowData()[dataSourcePathValue][nestedTableRowIdx] !== undefined
        ) {
          return parentTableRef.current.getSelectedRowData()[dataSourcePathValue][nestedTableRowIdx][varName];
        }
      }

      if (varName.charAt(0) === ".") varName = varName.substr(1);

      if (varName === "k_rowIndex") {
        return screen[`${val}_kuikaFlexGridRef`].current.getSelectedIndex();
      }

      const rowData = screen[`${val}_kuikaFlexGridRef`].current.getSelectedRowData();
      if (!rowData) return undefined;
      if (_.isEmpty(varName)) return rowData;
      // Use path resolving for nested fields with modifiers like [first], [last], [selected]
      return varName.includes(".") || varName.includes("[")
        ? ReactSystemFunctions.getValueFromPath(
            rowData,
            varName,
            screen[`${val}_kuikaFlexGridRef`].current.getSelectedIndex()
          )
        : rowData[varName];
    }
    if (
      varName != undefined &&
      screen[`${val}_kuikaHorizontalTableRef`] != undefined &&
      screen[`${val}_kuikaHorizontalTableRef`] != null &&
      screen[`${val}_kuikaHorizontalTableRef`].current != undefined &&
      screen[`${val}_kuikaHorizontalTableRef`].current != null &&
      screen[`${val}_kuikaHorizontalTableRef`].current.getSelectedRowData != undefined
    ) {
      const currentHorizontalTableRef = screen[`${val}_kuikaHorizontalTableRef`].current;

      const parentTableId = currentHorizontalTableRef?.getParentTableIdIfExist?.();
      const newVal = val.replace(currentHorizontalTableRef?.props?.id, parentTableId);

      const parentTableRef = this.getParentOfBaseTableElementRef(screen, newVal);

      if (parentTableRef?.current) {
        const dataSourcePath = currentHorizontalTableRef.props?.dataSourceOriginal?.match(
          /\[datafield:((?:(?!\[datafield:).)*)\]/
        );
        const dataSourcePathValue = dataSourcePath ? dataSourcePath[1] : "";

        const nestedTableRowIdx = parentTableRef.current.getNestedTableSelectedIndex(
          document.getElementById(parentTableId),
          currentHorizontalTableRef?.props?.id
        );

        if (
          nestedTableRowIdx !== undefined &&
          parentTableRef.current.getSelectedRowData()[dataSourcePathValue] !== undefined &&
          parentTableRef.current.getSelectedRowData()[dataSourcePathValue][nestedTableRowIdx] !== undefined
        ) {
          return parentTableRef.current.getSelectedRowData()[dataSourcePathValue][nestedTableRowIdx][varName];
        }
      }

      if (varName.charAt(0) === ".") varName = varName.substr(1);

      if (varName === "k_rowIndex") {
        return screen[`${val}_kuikaHorizontalTableRef`].current.getSelectedIndex();
      }

      const rowData = screen[`${val}_kuikaHorizontalTableRef`].current.getSelectedRowData();
      if (!rowData) return undefined;
      if (_.isEmpty(varName)) return rowData;
      // Use path resolving for nested fields with modifiers like [first], [last], [selected]
      return varName.includes(".") || varName.includes("[")
        ? ReactSystemFunctions.getValueFromPath(
            rowData,
            varName,
            screen[`${val}_kuikaHorizontalTableRef`].current.getSelectedIndex()
          )
        : rowData[varName];
    }
    if (
      varName != undefined &&
      screen[`${val}_kuikaMarqueeRef`] != undefined &&
      screen[`${val}_kuikaMarqueeRef`] != null &&
      screen[`${val}_kuikaMarqueeRef`].current != undefined &&
      screen[`${val}_kuikaMarqueeRef`].current != null &&
      screen[`${val}_kuikaMarqueeRef`].current.getSelectedRowData != undefined
    ) {
      if (varName.charAt(0) === ".") varName = varName.substr(1);

      if (varName === "k_rowIndex") {
        return screen[`${val}_kuikaMarqueeRef`].current.getSelectedIndex();
      }

      const rowData = screen[`${val}_kuikaMarqueeRef`].current.getSelectedRowData();
      if (!rowData) return undefined;
      // Use path resolving for nested fields with modifiers like [first], [last], [selected]
      return varName.includes(".") || varName.includes("[")
        ? ReactSystemFunctions.getValueFromPath(
            rowData,
            varName,
            screen[`${val}_kuikaMarqueeRef`].current.getSelectedIndex()
          )
        : rowData[varName];
    }
    if (
      varName != undefined &&
      screen[`${val}_kuikaPaginationRef`] != undefined &&
      screen[`${val}_kuikaPaginationRef`] != null
    ) {
      if (
        screen[`${val}_kuikaPaginationRef`].current != undefined &&
        screen[`${val}_kuikaPaginationRef`].current != null &&
        screen[`${val}_kuikaPaginationRef`].current.getCurrentData != undefined
      ) {
        if (varName.charAt(0) === ".") varName = varName.substr(1);
        return (
          screen[`${val}_kuikaPaginationRef`].current.getCurrentData() &&
          screen[`${val}_kuikaPaginationRef`].current.getCurrentData()[varName]
        );
      }
      if (varName === "current") return 1;
      return 10;
    }
    if (
      varName != undefined &&
      screen[`${val}_kuikaSelectBoxRef`] != undefined &&
      screen[`${val}_kuikaSelectBoxRef`] != null &&
      screen[`${val}_kuikaSelectBoxRef`].current != undefined &&
      screen[`${val}_kuikaSelectBoxRef`].current != null &&
      screen[`${val}_kuikaSelectBoxRef`].current.getSearchValue != undefined
    ) {
      if (targetField && targetField.charAt(0) === ".") targetField = targetField.substr(1);
      if (targetField === "k_searchValue") {
        return screen[`${val}_kuikaSelectBoxRef`].current.getSearchValue();
      }
    } else if (
      varName != undefined &&
      screen[`${val}_kuikaMultiSelectRef`] != undefined &&
      screen[`${val}_kuikaMultiSelectRef`] != null &&
      screen[`${val}_kuikaMultiSelectRef`].current != undefined &&
      screen[`${val}_kuikaMultiSelectRef`].current != null &&
      screen[`${val}_kuikaMultiSelectRef`].current.getSearchValue != undefined
    ) {
      if (targetField && targetField.charAt(0) === ".") targetField = targetField.substr(1);
      if (targetField === "k_searchValue") {
        return screen[`${val}_kuikaMultiSelectRef`].current.getSearchValue();
      }
    } else if (
      varName != undefined &&
      screen[`${val}_kuikaAutoCompleteRef`] != undefined &&
      screen[`${val}_kuikaAutoCompleteRef`] != null &&
      screen[`${val}_kuikaAutoCompleteRef`].current != undefined &&
      screen[`${val}_kuikaAutoCompleteRef`].current != null &&
      screen[`${val}_kuikaAutoCompleteRef`].current.getSearchValue != undefined
    ) {
      if (targetField && targetField.charAt(0) === ".") targetField = targetField.substr(1);
      if (targetField === "k_searchValue") {
        return screen[`${val}_kuikaAutoCompleteRef`].current.getSearchValue();
      }
    } else if (
      varName != undefined &&
      screen[`${val}_kuikaGoogleMapsRef`] != undefined &&
      screen[`${val}_kuikaGoogleMapsRef`] != null &&
      screen[`${val}_kuikaGoogleMapsRef`].current != undefined &&
      screen[`${val}_kuikaGoogleMapsRef`].current != null &&
      screen[`${val}_kuikaGoogleMapsRef`].current.getLatValue != undefined
    ) {
      if (targetField && targetField.charAt(0) === ".") targetField = targetField.substr(1);
      if (varName === "Latitude") {
        return screen[`${val}_kuikaGoogleMapsRef`].current.getLatValue();
      }
      if (varName === "Longitude") {
        return screen[`${val}_kuikaGoogleMapsRef`].current.getLngValue();
      }
      if (varName.charAt(0) === ".") varName = varName.substr(1);
      return (
        screen[`${val}_kuikaGoogleMapsRef`].current.getSelectedRowData() &&
        screen[`${val}_kuikaGoogleMapsRef`].current.getSelectedRowData()[varName]
      );
    } else if (
      varName != undefined &&
      screen[`${val}_kuikaChatRef`] != undefined &&
      screen[`${val}_kuikaChatRef`] != null &&
      screen[`${val}_kuikaChatRef`].current != undefined &&
      screen[`${val}_kuikaChatRef`].current != null &&
      screen[`${val}_kuikaChatRef`].current.getMessage != undefined &&
      screen[`${val}_kuikaChatRef`].current.getCurrentlyEditingMessageId != undefined
    ) {
      if (varName === "message" || targetField === "k_message") {
        return screen[`${val}_kuikaChatRef`].current.getMessage();
      }

      if (varName === "currentlyEditingMessageId" || targetField === "k_currentlyEditingMessageId") {
        return screen[`${val}_kuikaChatRef`].current.getCurrentlyEditingMessageId();
      }

      if (varName === "messageIdToBeDeleted" || targetField === "k_messageIdToBeDeleted") {
        return screen[`${val}_kuikaChatRef`].current.messageIdToBeDeleted;
      }
    } else if (
      varName != undefined &&
      screen[`${val}_kuikaPlacesAutocompleteInputRef`] != undefined &&
      screen[`${val}_kuikaPlacesAutocompleteInputRef`] != null &&
      screen[`${val}_kuikaPlacesAutocompleteInputRef`].current != undefined &&
      screen[`${val}_kuikaPlacesAutocompleteInputRef`].current != null &&
      screen[`${val}_kuikaPlacesAutocompleteInputRef`].current.getLatitude != undefined
    ) {
      if (varName === "Latitude" || targetField === "k_latitude") {
        return screen[`${val}_kuikaPlacesAutocompleteInputRef`].current.getLatitude();
      }
      if (varName === "Longitude" || targetField === "k_longitude") {
        return screen[`${val}_kuikaPlacesAutocompleteInputRef`].current.getLongitude();
      }
      if (varName === "Address" || targetField === "k_address") {
        return screen[`${val}_kuikaPlacesAutocompleteInputRef`].current.getAddress();
      }
    } else if (
      varName != undefined &&
      screen[`${val}_kuikaLocationPickerComponentRef`] &&
      screen[`${val}_kuikaLocationPickerComponentRef`] != undefined &&
      screen[`${val}_kuikaLocationPickerComponentRef`] != null &&
      screen[`${val}_kuikaLocationPickerComponentRef`].current != undefined &&
      screen[`${val}_kuikaLocationPickerComponentRef`].current != null &&
      screen[`${val}_kuikaLocationPickerComponentRef`].current.getLatitude != undefined
    ) {
      if (varName === "Latitude" || targetField === "k_latitude") {
        return screen[`${val}_kuikaLocationPickerComponentRef`].current.getLatitude();
      }
      if (varName === "Longitude" || targetField === "k_longitude") {
        return screen[`${val}_kuikaLocationPickerComponentRef`].current.getLongitude();
      }
    } else if (
      varName != undefined &&
      screen[`${val}_kuikaStepperComponentRef`] &&
      screen[`${val}_kuikaStepperComponentRef`] != undefined &&
      screen[`${val}_kuikaStepperComponentRef`] != null &&
      screen[`${val}_kuikaStepperComponentRef`].current != undefined &&
      screen[`${val}_kuikaStepperComponentRef`].current != null &&
      screen[`${val}_kuikaStepperComponentRef`].current.getIndex != undefined
    ) {
      let index = screen[`${val}_kuikaStepperComponentRef`].current.getIndex();
      if (index === null || index === undefined || index < 0) return;

      return index + 1;
    } else if (
      screen[`${val}_kuikaWebViewRef`] &&
      screen[`${val}_kuikaWebViewRef`] != undefined &&
      screen[`${val}_kuikaWebViewRef`] != null &&
      screen[`${val}_kuikaWebViewRef`].current != undefined &&
      screen[`${val}_kuikaWebViewRef`].current != null &&
      screen[`${val}_kuikaWebViewRef`].current.getUrl != undefined
    ) {
      if (varName === "url" || targetField === "k_url") {
        return screen[`${val}_kuikaWebViewRef`].current.getUrl();
      }
    } else if (
      screen?.[`${val}_kuikaCalendarRef`]?.current != undefined &&
      screen?.[`${val}_kuikaCalendarRef`]?.current != null
    ) {
      if (varName === "panel" || varName === "k_panel" || targetField === "k_panel") {
        return screen[`${val}_kuikaCalendarRef`].current?.getPanel?.();
      }

      if (varName === "currentDate" || varName === "k_currentDate" || targetField === "k_currentDate") {
        return screen[`${val}_kuikaCalendarRef`].current?.getCurrentDate?.();
      }

      if (varName === "currentDay" || varName === "k_currentDay" || targetField === "k_currentDay") {
        return screen[`${val}_kuikaCalendarRef`].current.getCurrentDay?.();
      }

      if (varName === "currentMonth" || varName === "k_currentMonth" || targetField === "k_currentMonth") {
        return screen[`${val}_kuikaCalendarRef`].current.getCurrentMonth?.();
      }

      if (varName === "currentYear" || varName === "k_currentYear" || targetField === "k_currentYear") {
        return screen[`${val}_kuikaCalendarRef`].current.getCurrentYear?.();
      }

      if (
        varName === "currentRangeStart" ||
        varName === "k_currentRangeStart" ||
        targetField === "k_currentRangeStart"
      ) {
        return screen[`${val}_kuikaCalendarRef`].current.getCurrentRangeStart?.();
      }

      if (varName === "currentRangeEnd" || varName === "k_currentRangeEnd" || targetField === "k_currentRangeEnd") {
        return screen[`${val}_kuikaCalendarRef`].current.getCurrentRangeEnd?.();
      }

      if (
        varName === "k_eventId" ||
        varName === "k_currentEvent.k_eventId" ||
        targetField === "k_eventId" ||
        targetField === "k_currentEvent.k_eventId"
      ) {
        return screen[`${val}_kuikaCalendarRef`].current.getCurrentEvent?.()?.id;
      }

      if (
        varName === "k_eventTitle" ||
        varName === "k_currentEvent.k_eventTitle" ||
        targetField === "k_eventTitle" ||
        targetField === "k_currentEvent.k_eventTitle"
      ) {
        return screen[`${val}_kuikaCalendarRef`].current.getCurrentEvent?.()?.title;
      }

      if (
        varName === "k_eventStartDate" ||
        varName === "k_currentEvent.k_eventStartDate" ||
        targetField === "k_eventStartDate" ||
        targetField === "k_currentEvent.k_eventStartDate"
      ) {
        return screen[`${val}_kuikaCalendarRef`].current.getCurrentEvent?.()?.start;
      }

      if (
        varName === "k_eventEndDate" ||
        varName === "k_currentEvent.k_eventEndDate" ||
        targetField === "k_eventEndDate" ||
        targetField === "k_currentEvent.k_eventEndDate"
      ) {
        return screen[`${val}_kuikaCalendarRef`].current.getCurrentEvent?.()?.end;
      }

      if (
        varName === "k_eventColor" ||
        varName === "k_currentEvent.k_eventColor" ||
        targetField === "k_eventColor" ||
        targetField === "k_currentEvent.k_eventColor"
      ) {
        return screen[`${val}_kuikaCalendarRef`].current.getCurrentEvent?.()?.backgroundColor;
      }

      return screen[`${val}_kuikaCalendarRef`].current.getCurrentEvent?.()?.[varName?.toLowerCase()];
    } else if (
      screen[`${val}_kuikaStopwatchRef`] &&
      screen[`${val}_kuikaStopwatchRef`] != undefined &&
      screen[`${val}_kuikaStopwatchRef`] != null &&
      screen[`${val}_kuikaStopwatchRef`].current != undefined &&
      screen[`${val}_kuikaStopwatchRef`].current != null &&
      screen[`${val}_kuikaStopwatchRef`].current.getValue != undefined
    ) {
      return screen[`${val}_kuikaStopwatchRef`].current.getValue();
    } else if (
      screen[`${val}_kuikaTreeRef`] &&
      screen[`${val}_kuikaTreeRef`] != undefined &&
      screen[`${val}_kuikaTreeRef`] != null &&
      screen[`${val}_kuikaTreeRef`].current != undefined &&
      screen[`${val}_kuikaTreeRef`].current != null
    ) {
      if (varName === "checkedKeys" && screen[`${val}_kuikaTreeRef`].current.getCheckedKeys != undefined) {
        return screen[`${val}_kuikaTreeRef`].current.getCheckedKeys();
      }
      if (screen[`${val}_kuikaTreeRef`].current.getSelectedData != undefined) {
        const selectedData = screen[`${val}_kuikaTreeRef`].current.getSelectedData();
        if (targetField && selectedData) {
          return selectedData[targetField];
        }
        if (varName && selectedData) {
          return selectedData[varName];
        }
        if (!varName && screen[`${val}_kuikaTreeRef`].current.getSelectedKey != undefined) {
          return screen[`${val}_kuikaTreeRef`].current.getSelectedKey();
        }
      }
    } else if (
      screen[`${val}_kuikaDirectoryRef`] &&
      screen[`${val}_kuikaDirectoryRef`] != undefined &&
      screen[`${val}_kuikaDirectoryRef`] != null &&
      screen[`${val}_kuikaDirectoryRef`].current != undefined &&
      screen[`${val}_kuikaDirectoryRef`].current != null
    ) {
      const varNameLower = varName?.toLowerCase();
      if (varNameLower === "nodeid") return screen[`${val}_kuikaDirectoryRef`].current.getSelectedNodeId();
      if (varNameLower === "nodename") return screen[`${val}_kuikaDirectoryRef`].current.getSelectedNodeName();
      if (varNameLower === "isnodebranch") return screen[`${val}_kuikaDirectoryRef`].current.getSelectedNodeIsBranch();
      if (varNameLower === "selecteddocumentid")
        return screen[`${val}_kuikaDirectoryRef`].current.getSelectedDocumentId();
      if (varNameLower === "selectedfolderid") return screen[`${val}_kuikaDirectoryRef`].current.getSelectedFolderId();
      if (varNameLower === "selecteddocumentname")
        return screen[`${val}_kuikaDirectoryRef`].current.getSelectedDocumentName?.();
      if (varNameLower === "selectedfoldername")
        return screen[`${val}_kuikaDirectoryRef`].current.getSelectedFolderName?.();
      if (varNameLower === "selectednodename") return screen[`${val}_kuikaDirectoryRef`].current.getSelectedNodeName();
      if (varNameLower === "containedfolderid")
        return screen[`${val}_kuikaDirectoryRef`].current.getContainerFolderId?.();
      if (varNameLower === "selectedversionid")
        return screen[`${val}_kuikaDirectoryRef`].current.getSelectedVersionId?.();
      if (varNameLower === "selectednodetype")
        return screen[`${val}_kuikaDirectoryRef`].current.getSelectedNodeType?.();
      if (varNameLower === "selectedvirtualfolder")
        return screen[`${val}_kuikaDirectoryRef`].current.getSelectedVirtualFolder?.();
      if (varNameLower === "selectedlanguage")
        return screen[`${val}_kuikaDirectoryRef`].current.getSelectedLanguage?.();
      if (varNameLower === "selectedisdraft") return screen[`${val}_kuikaDirectoryRef`].current.getSelectedIsDraft?.();
      if (varNameLower === "selectedmimetype")
        return screen[`${val}_kuikaDirectoryRef`].current.getSelectedMimeType?.();
    } else if (screen[`${val}_kuikaDocumentRef`] && screen[`${val}_kuikaDocumentRef`].current) {
      const varNameLower = varName?.toLowerCase();
      if (varNameLower === "versionid") return screen[`${val}_kuikaDocumentRef`].current.getVersionId?.();
      if (varNameLower === "mode") return screen[`${val}_kuikaDocumentRef`].current.getMode?.();
    } else if (screen[`${val}_kuikaDocumentCompareRef`] && screen[`${val}_kuikaDocumentCompareRef`].current) {
      const varNameLower = varName?.toLowerCase();
      if (varNameLower === "leftversionid")
        return screen[`${val}_kuikaDocumentCompareRef`].current.getLeftVersionId?.();
      if (varNameLower === "rightversionid")
        return screen[`${val}_kuikaDocumentCompareRef`].current.getRightVersionId?.();
    } else if (screen[`${val}_kuikaDocumentUploaderRef`] && screen[`${val}_kuikaDocumentUploaderRef`].current) {
      const varNameLower = varName?.toLowerCase();
      if (varNameLower === "currentdocumentid")
        return screen[`${val}_kuikaDocumentUploaderRef`].current.getCurrentDocumentId?.();
      if (varNameLower === "currentversionid")
        return screen[`${val}_kuikaDocumentUploaderRef`].current.getCurrentVersionId?.();
      if (varNameLower === "currentfilename")
        return screen[`${val}_kuikaDocumentUploaderRef`].current.getCurrentFileName?.();
      if (varNameLower === "currentmimetype")
        return screen[`${val}_kuikaDocumentUploaderRef`].current.getCurrentMimeType?.();
    } else if (varName === undefined) return val;

    const formVal = screen.props.form.getFieldValue(val);
    if (formVal == undefined && varName == "checked")
      return screen.props.form.getFieldValue(val.replace("_value", "_checked"));
    if (val.endsWith("_value") && varName == "checked") return formVal ?? false;
    if (formVal != null && val.endsWith("_value") && varName !== "value") {
      // Multiple value component
      return formVal[varName];
    }
    if (formVal != null && val.endsWith("_selectedkey") && varName == "selectedKey") {
      // Menu Component Case!
      return formVal[varName];
    }

    return formVal;
  }

  public static isFieldVisible(id: string): boolean {
    let element = document.querySelector(`[id~='${id}']`);
    if (!element) {
      element = document.querySelector(`[data-id~='${id}']`);
    }
    if (!element) return false;

    const style = window.getComputedStyle(element);
    return (
      style.display !== "none" &&
      style.visibility !== "hidden" &&
      style.opacity !== "0" &&
      parseFloat(style.opacity || "1") > 0.1
    );
  }

  public static dateIsWeekDay = (date: string | number | Date) => {
    if (!date) return false;
    return moment(date).isoWeekday() <= 5;
  };

  public static dateGetDay = (val1, val2) => {
    if (!val1 || !val2) return 0;
    if (typeof val1 === "string" && moment(val1).isValid()) {
      return moment(val1).date();
    }
    return moment(val2).date();
  };

  public static dateGetMonth = (val1, val2) => {
    if (!val1 || !val2) return 0;
    if (typeof val1 === "string" && moment(val1).isValid()) {
      return moment(val1).month() + 1;
    }
    return moment(val2).month() + 1;
  };

  public static dateGetYear = (val1, val2) => {
    if (!val1 || !val2) return 0;
    if (typeof val1 === "string" && moment(val1).isValid()) {
      return moment(val1).year();
    }
    return moment(val2).year();
  };

  public static toString = (_screen: any, val: any) => {
    if (val === null || val === undefined) return ""; // false değeri için böyle kalmalı
    if (Array.isArray(val)) {
      const returnValue: any[] = [];
      for (let i = 0; i < val.length; i++) {
        const vi: any = val[i];
        returnValue.push(vi.toString());
      }
      return returnValue;
    }
    return val.toString();
  };

  public static toBoolean = (_screen: any, val: any) => {
    if (!val) return false;
    if (val instanceof Boolean) return val.valueOf();
    // Backend booleans arrive as C#-style capitalized strings ("True"). A primitive
    // string is never `instanceof String`, so the check must be typeof-based —
    // otherwise "True" skips the lowercase and falls through to false (KOA-17620).
    if (typeof val === "string" || val instanceof String) {
      val = val.toString().toLowerCase();
    }
    switch (val) {
      case true:
      case "true":
      case "on":
      case "yes":
      case "1":
      case 1:
        return true;
      default:
        return false;
    }
  };

  public static toDecimal = (_screen: any, val: any) => {
    if (!val) return val;

    if (val instanceof Date) {
      return val.getTime();
    }

    if (val instanceof moment) {
      return val.valueOf();
    }

    if ((parseFloat(val).toString() === "NaN") === true) {
      return val;
    }

    return parseFloat(val);
  };

  public static toDate(_screen: any, value: any) {
    if (!value) return null;

    if (value instanceof moment) return value;

    const dateFormat = this.getFormat(value);
    if (dateFormat === null) return null;
    return moment(value, dateFormat);
  }

  private static getDateFormat() {
    return {
      kuika_hhmm: "HH:mm",
      kuika_hhmmss: "HH:mm:ss",
      kuika_ddmmyyyy: "DD.MM.YYYY",
      kuika_ddmmyyyyhh: "DD.MM.YYYY HH",
      kuika_ddmmyyyyhhmm: "DD.MM.YYYY HH:mm",
      kuika_ddmmyyyyhhmmss: "DD.MM.YYYY HH:mm:ss",
      kuika_ddmmyyyymmddhhmmss: "YYYY-MM-DD HH:mm:ss",
      iso_int: "YYYY-MM-DD",
      short_date: "DD/MM/YYYY",
      iso_date_time: "YYYY-MM-DDTHH:mm:ss",
      iso_date_time_utc: "YYYY-MM-DDTHH:mm:ssZ"
    };
  }

  private static getFormat(d: moment.MomentInput) {
    const dateFormats = this.getDateFormat();
    for (const prop in dateFormats) {
      if (moment(d, dateFormats[prop], true).isValid()) {
        return dateFormats[prop];
      }
    }
    return null;
  }

  private static isValidDateWithFormat(value: any): boolean {
    return DateFormatValidator.isValid(value);
  }

  /**
   * KOA-17775 — large-integer precision guard for string → number coercion.
   *
   * A JavaScript `number` is an IEEE-754 double and is exact only up to
   * Number.MAX_SAFE_INTEGER (2^53 − 1 = 9007199254740991). A backend int64 or
   * large numeric identifier that arrives as a string (e.g. "9600017533270597")
   * silently loses precision the instant it is coerced with parseInt/parseFloat/
   * Number — it snaps to the nearest representable double (9600017533270596,
   * i.e. off by one). The C#/int64 backend holds the value fine; the corruption
   * is entirely in the generated TypeScript layer.
   *
   * When the input is an integer-shaped string whose magnitude is outside the
   * safe range, we keep the exact digits as a string so the JSON request body
   * carries the precise value (the customer confirmed their backend accepts the
   * string form). Values inside the safe range — the overwhelmingly common case
   * — are NOT touched; they still parse to a plain number, so there is no
   * behavioural change and no BigInt contagion anywhere in the app.
   *
   * Returns the normalized digit string for an out-of-range integer string, or
   * null for every other input (signalling the caller to parse as usual).
   */
  private static preserveUnsafeInteger(val: unknown): string | null {
    if (typeof val !== "string") return null;
    const trimmed: string = val.trim();
    if (!/^[+-]?\d+$/.test(trimmed)) return null;
    if (Number.isSafeInteger(Number(trimmed))) return null;
    // Out of safe range: normalize to a canonical integer string (drop a leading
    // "+", strip leading zeros) without ever constructing a lossy number.
    const negative: boolean = trimmed.charAt(0) === "-";
    const digits: string = trimmed.replace(/^[+-]/, "").replace(/^0+(?=\d)/, "");
    if (digits === "0") return "0";
    return negative ? `-${digits}` : digits;
  }

  /**
   * KOA-17775 — inbound counterpart of preserveUnsafeInteger. Custom number parser
   * for lossless-json: a value the browser can hold exactly stays a plain `number`
   * (identical to JSON.parse); a large integer beyond the safe range is kept as its
   * exact digit string so it is not rounded; an out-of-range non-integer (huge
   * float) falls back to parseFloat, matching JSON.parse's lossy behaviour rather
   * than introducing a new string type where precision was never recoverable anyway.
   */
  private static parseResponseNumber(value: string): number | string {
    if (isSafeNumber(value)) return parseFloat(value);
    if (isInteger(value)) return value;
    return parseFloat(value);
  }

  // lossless-json throws on duplicate keys by default; JSON.parse keeps the last
  // occurrence. Match JSON.parse so we never reject a body axios would have accepted.
  private static keepLatestDuplicateKey(info: IDuplicateKeyInfo): unknown {
    return info.newValue;
  }

  /**
   * KOA-17775 — precision-preserving replacement for the JSON.parse that axios's
   * default transformResponse runs on API responses. Native JSON.parse rounds any
   * integer beyond Number.MAX_SAFE_INTEGER (e.g. a backend int64 9600017533270597
   * → 9600017533270596), corrupting the value before any binding/display code runs.
   *
   * Fast path: native JSON.parse is C++-fast and lossless for any value below
   * 10^15, so only a run of 16+ digits can carry a value at risk — when none is
   * present we parse natively and pay nothing. Otherwise we parse with lossless-json
   * and keep out-of-range integers as exact strings (see parseResponseNumber).
   *
   * Leniency MUST match axios's default transformResponse, which only parses a
   * non-empty string and silently swallows parse errors. An empty body (a 401/204
   * with no content) or a non-JSON body is returned unchanged — otherwise
   * JSON.parse("") throws "Unexpected end of JSON input" and, because this runs
   * inside transformResponse, that throw also derails axios's 401 →
   * token-refresh/redirect handling.
   */
  public static parseJsonPreservingBigIntegers(text: string): unknown {
    if (typeof text !== "string" || text.length === 0) {
      return text;
    }
    try {
      if (!/\d{16,}/.test(text)) {
        return JSON.parse(text);
      }
      return losslessParse(text, undefined, {
        parseNumber: ReactSystemFunctions.parseResponseNumber,
        onDuplicateKey: ReactSystemFunctions.keepLatestDuplicateKey
      });
    } catch {
      try {
        return JSON.parse(text);
      } catch {
        return text;
      }
    }
  }

  public static toInteger = (screen: any, val: any, varName?: string) => {
    if (val === null || val === undefined) return val;
    if (varName && varName.length) {
      return this.toInteger(screen, this.value(screen, val, varName));
    }
    if (val === "") return val;
    if (val === true) return 1;
    if (val === false) return 0;
    if (val === "true") return 1;
    if (val === "false") return 0;
    if (val === "True") return 1;
    if (val === "False") return 0;
    const preserved: string | null = this.preserveUnsafeInteger(val);
    if (preserved !== null) return preserved;
    if ((parseInt(val, 10).toString() === "NaN") === true) {
      return val;
    }
    return parseInt(val, 10);
  };

  /**
   * Int64 converter. JavaScript has no dedicated long type, so an int64 shares
   * runtime semantics with toInteger: a safe-range value becomes a plain number,
   * an out-of-range value is preserved as its exact digit string (KOA-17775).
   * Defined here because the generator maps Int64 → `toLong` (see
   * ClientDTOGeneratorBase.GetConversionFunctionName); without it, generated code
   * for any int64-typed field would throw "toLong is not a function".
   */
  public static toLong = (screen: any, val: any, varName?: string) => {
    return this.toInteger(screen, val, varName);
  };

  public static toDouble = (screen: any, val: any, varName?: string) => {
    if (val === null || val === undefined) return val;
    if (varName && varName.length) {
      return this.toDouble(screen, this.value(screen, val, varName));
    }
    if (val === "") return val;
    if (val === true) return 1;
    if (val === false) return 0;
    if (val === "true") return 1;
    if (val === "false") return 0;
    if (val === "True") return 1;
    if (val === "False") return 0;
    if ((parseFloat(val).toString() === "NaN") === true) {
      return val;
    }
    return parseFloat(val);
  };

  /**
   * Float converter — alias of toDouble (Float maps to a JS double at runtime).
   * The generator maps Float → `toFloat` (ClientDTOGeneratorBase), so this must
   * exist or generated code for any float-typed field throws "toFloat is not a
   * function" (latent broken reference, fixed alongside KOA-17775). Floating
   * point is inherently approximate, so no large-integer preservation applies.
   */
  public static toFloat = (screen: any, val: any, varName?: string) => {
    return this.toDouble(screen, val, varName);
  };

  public static toGuid(_screen: any, val: string) {
    if (!val) return null;
    if (!Guid.isGuid(val)) return null;

    return Guid.parse(val);
  }

  public static async navigateToTask(
    screen: any,
    _callback: any,
    StepKey: string,
    fromScreen: string,
    toScreen: string,
    _toUrl: string,
    openAs: string | null,
    navigationKuikaId: string | null,
    _title: string | null,
    _placement: string | null,
    _closable: string | null,
    _width: string | null,
    _height: string | null,
    executePageInitActionsAfterClose: boolean,
    disableSmartExecutePageInit: boolean
  ) {
    var isCallerMicroApp = window.location.hash !== "";
    const stepInfo = (await WorkflowService.GetNavigationParameters(StepKey, isCallerMicroApp)).data;

    if (stepInfo?.canNavigateToTask === false) {
      this.notify(screen, "You are not authorized to claim this task.", "warning", "bottom-right", 3, null, null, null);
      return;
    }

    const screenName =
      stepInfo.screenToNavigate?.length > 0
        ? stepInfo.screenToNavigate
        : (await WorkflowService.GetStepScreen(stepInfo.processId, stepInfo.stepId, stepInfo.appId)).data;

    if (screenName !== "") {
      let calculatedScreenName = screenName;
      let baseUrl = KuikaAppManager.GetFrontEndUrl();
      const urlHasHash = window.location.hash !== "";
      const hasMicroAppScreen = stepInfo.microAppContainingScreen && stepInfo.microAppContainingScreen !== "";
      const webViewUrl = stepInfo.webViewUrl;
      const screenExistsInApp = this.doesScreenExist(screenName);

      if (hasMicroAppScreen) {
        calculatedScreenName = `${stepInfo.microAppContainingScreen}#/${screenName}`;
        if (urlHasHash) {
          const indexOfHash = window.location.href.indexOf(`/${stepInfo.microAppContainingScreen}#`);
          baseUrl = window.location.href.substring(0, indexOfHash);
        }
      } else if (!screenExistsInApp && webViewUrl && webViewUrl !== "") {
        const isSameOriginWithVDir = this.isSameOriginAndVirtualDir(webViewUrl, window.location.href);
        if (!isSameOriginWithVDir) {
          window.open(webViewUrl, "_blank");
          return;
        }
      }
      if (openAs === "newTab" || openAs === "newWindow") {
        window.open(`${baseUrl}/${calculatedScreenName}?workflowStepInstanceId=${StepKey}`, "_blank");
        return;
      }
      if (openAs === "currentPage") {
        if (urlHasHash) {
          const { history } = screen.props.navigator;
          history.push({
            pathname: screenName,
            search: `workflowStepInstanceId=${StepKey}`,
            state: {
              screenInputs: {}
            }
          });
        } else {
          const newPath = `${baseUrl}/${calculatedScreenName}?workflowStepInstanceId=${StepKey}`;
          window.location.assign(newPath);
        }
        return;
      }

      KuikaAppManager.prepareForNavigation();
      KuikaAppManager.addToPageInputVariables(screenName, "workflowStepInstanceId", StepKey);
      screen.setState({ wfScreenName: screenName });
      return this.navigate(
        screen,
        _callback,
        fromScreen,
        screenName,
        _toUrl,
        openAs,
        navigationKuikaId,
        _title,
        _placement,
        _closable,
        _width,
        _height,
        executePageInitActionsAfterClose,
        disableSmartExecutePageInit
      );
    }
    if (stepInfo.webViewUrl && stepInfo.webViewUrl !== "") {
      window.location.replace(stepInfo.webViewUrl);
    }
  }

  public static async loadWorkflowStepInstanceParameters(screen: any, StepKey: string) {
    const stepdata = (await WorkflowService.GetTaskInstanceParameters(StepKey)).data;
    if (stepdata) {
      if (stepdata.showMessage) {
        this.notify(this, stepdata.message, "warning", "bottom-right", 3, null, null, null);
      }
      if (stepdata.redirect) {
        screen.props.navigator.gotoStartingScreen();
      }
      return stepdata;
    }
    return undefined;
  }

  public static getProcessParameterValue(form: any, screenName, diId, propertyName) {
    if (form) {
      const value = form.getFieldValue(`${screenName}_${diId}_${propertyName}`);
      if (value && value !== "") return value;
      return "";
    }
    return "";
  }

  public static getStepDataValue(bag: ITaskDataParameters, key: string) {
    if (bag !== undefined) {
      if (key == "StepInstanceId") return bag.workflowStepInstanceId;
      if (key == "ProcessInstanceId") return bag.processInstance;
      if (key == "showResumeProcessButton") return bag.showResumeProcessButton;
      if (bag.stepData && bag.stepData.length > 0) {
        const data = bag.stepData.find((b) => b.key === key);
        if (data !== undefined) return data.value;
      }
    }
    return "";
  }

  public static postWebKitMessage(scope: any, messageBody) {
    if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.iosKuikaListener)
      window.webkit.messageHandlers.iosKuikaListener.postMessage(messageBody);
    // {"actionType":"CLOSE_WEBVIEW"}
    else if (window.AndroidKuikaListener) window.AndroidKuikaListener.postMessage(JSON.stringify(messageBody));
    else if (window.parent !== window) {
      // iframe case
      window.parent.postMessage({ source: "kuika", ...messageBody }, "*");
    } else {
      // web component/same window
      window.dispatchEvent(new CustomEvent("kuika-event", { detail: messageBody }));
    }
  }

  // obsolete
  // public static getStepScreenId = (processId, stepId): string => {
  //   const cnf = ProcessConfig.processScreens as IProcessConfigData[];
  //   const screenConfig = cnf.find((s) => s.processId == processId && s.stepId === stepId);
  //   if (screenConfig !== undefined) return screenConfig.screenId;
  //   return undefined;
  // };

  public static getScreenNameById = (screenId: string): string => {
    const screenList = this.getScreenList();
    const screenName = getDictionaryValueByKey(screenList, screenId);
    return screenName;
  };

  public static getScreenNameByActiveUserRoles = (): string => {
    const roleStartingScreenIdList = this.getRoleStartingScreenIdList();
    const userRoles = window?.userInfo?.roles;
    let result = "";
    userRoles?.forEach((role: { name: string }) => {
      const screenId = getDictionaryValueByKey(roleStartingScreenIdList, role?.name);
      if (screenId !== undefined) {
        const startingScreenName = this.getScreenNameById(screenId);
        if (startingScreenName !== undefined && startingScreenName !== "") {
          result = startingScreenName;
        }
      }
    });
    return result;
  };

  public static getScreenList = () => {
    return [ { key: "75aa238e-44fc-4d4b-a19f-025d4e540242", value: "TeklifHareketleriStoklar"}, { key: "44e667c5-9bf9-42c5-9d65-0b58c3b66e31", value: "Marketing_Dashboard_With_Left_Menu"}, { key: "8c2606ff-af59-4244-82ae-20dc6c3a3705", value: "AnaSayfa"}, { key: "f57a9c37-3d73-4a57-96ef-2136b5268034", value: "Sales_Dashboard_With_Left_Menu"}, { key: "d59c918c-a9e7-4043-9b7a-21946d6b9687", value: "PlasiyerTeklifIskontoEkle"}, { key: "dbf266ff-287a-48e3-8d84-27b16c810774", value: "ProoductDetail"}, { key: "b805f4f4-abb2-4e0c-9d13-27cb0bdde411", value: "PlasiyerTeklifPage"}, { key: "02ea62ea-bc14-42cd-acad-2c6645788bfc", value: "Blank"}, { key: "e6d16d7c-f164-4449-a8fc-4885cf70fc48", value: "Resimler"}, { key: "cdb10c6f-5131-4dab-bd3e-4b75aa837d30", value: "ExceldenAktar"}, { key: "95b43939-6522-439e-bf90-4c1dd7e527f5", value: "SiparisDurumlari"}, { key: "287a6649-d13e-4f0a-90e5-53bdcef1d83d", value: "SiparisSepetOzet"}, { key: "e5f2c361-fe06-4fef-a275-5a61e7d3a64b", value: "KullaniciSecme"}, { key: "f2cbbc41-6609-46ed-b7f8-6751fb3945d1", value: "CariHesap"}, { key: "ccfb8b46-eec3-4d7c-9be1-6a86b3b2d97a", value: "PlasiyerSiparisDetay"}, { key: "1d760eba-78ef-43bb-a9fb-6f0bd26f328c", value: "Profil"}, { key: "23b8652e-e3bd-4c28-87f6-79b8fa57b4a8", value: "TeklifDurumlari"}, { key: "8f6052ac-9303-46b4-95d1-8340b3af9ded", value: "PlasiyerHome"}, { key: "546c6738-9c1d-424f-9e69-87729c93ff9e", value: "Signin"}, { key: "1c83107c-d98f-4bad-87d4-8813749b2e09", value: "SepetModal"}, { key: "92045f8e-bd71-43c3-ae90-8948f5848f66", value: "VerificationCode"}, { key: "7372cde2-daee-4ede-ae32-89cd3ffa9d39", value: "KalemNot"}, { key: "f6429a8e-ce2d-4dc7-85d3-990b0bbffb7d", value: "YeniUrunler"}, { key: "2c3c1670-172a-4f57-8079-99f8537dd98a", value: "LeftMenu"}, { key: "b1aaf526-bbe5-4070-b6ad-9a738496aca1", value: "SiparisOlustur"}, { key: "3ffb3d1a-5307-4ed7-98d7-9c491154cd3b", value: "SiparisLoglari"}, { key: "53f8f4eb-7855-4aaf-816f-a0e4e7522303", value: "Test"}, { key: "71b1cf58-33c0-4641-a4dd-a8fae60299e6", value: "BildirimOzeti"}, { key: "64e8e1f3-53b5-4fd5-94f3-aadf48d137b9", value: "TeklifHareketleri"}, { key: "9ed6e175-939d-41c9-a578-add5cee81e8e", value: "YaslandirmaRapor"}, { key: "750eac05-9655-4307-be0d-aebfae7a500a", value: "TeklifOlustur"}, { key: "885a99d7-7487-43c1-b422-c0b93411e9e6", value: "ResetPassword"}, { key: "27872d47-b1cb-40fc-bcbb-c0fe90bf3a53", value: "BakiyeSiparisleri"}, { key: "7dd0cee6-fe66-4b8c-9d9c-c384d37cc0b0", value: "PlasiyerTeklifDetay"}, { key: "acbaf272-6c68-4bfb-bb64-c4fa369262c9", value: "TeklifDetay"}, { key: "4a214f38-4fe4-4a6d-a7eb-c63da959869c", value: "Signup"}, { key: "8a9bda3b-ced0-481a-81f0-d2749b879ff1", value: "ExceldenSepeteEkleModal"}, { key: "09f59b94-d032-4160-8e53-d90dd5bf001c", value: "ForgotPassword"}, { key: "b82472d3-fdd2-416a-85c8-e47a02a44c97", value: "KapatilmamisFaturalar"}, { key: "24ebf2a6-d811-4d1f-9d94-e532fd968786", value: "ExcelModal"}, { key: "3254b312-73b0-4b80-82c1-e693236f2ab2", value: "Arama"}, { key: "e754c8e8-8a80-4c10-962c-ea1f6ae3773c", value: "PlasiyerIskontoEkle"}, { key: "97d4a64e-b286-42f0-aa05-f4303aff6cd7", value: "SiparisDetay"},];
  };

  public static getRoleStartingScreenIdList = () => {
    return [ { key: "Plasiyer", value: "8f6052ac-9303-46b4-95d1-8340b3af9ded"},];
  };

  private static doesScreenExist = (screenName: string): boolean => {
    if (!screenName) return false;
    const screens = this.getScreenList() || [];
    return screens.some((s: { key?: string; value?: string }) => {
      const keyMatch = s?.key?.toLowerCase() === screenName.toLowerCase();
      const valueMatch = s?.value?.toLowerCase() === screenName.toLowerCase();
      return keyMatch || valueMatch;
    });
  };

  private static originWithVirtualDirectory = (rawUrl: string): string | null => {
    try {
      const parsed = new URL(rawUrl, window.location.href);
      const segments = parsed.pathname.split("/").filter(Boolean);
      const virtualDir = segments.length > 0 ? `/${segments[0]}` : "";
      return `${parsed.origin}${virtualDir}`.toLowerCase();
    } catch (err) {
      return null;
    }
  };

  private static isSameOriginAndVirtualDir = (targetUrl: string, currentUrl: string): boolean => {
    const target = this.originWithVirtualDirectory(targetUrl);
    const current = this.originWithVirtualDirectory(currentUrl);
    return !!target && !!current && target === current;
  };

  // Navigation
  // 0: {name: "fromScreenId", Typename: "String", cardinality: 1, isMandatory: false, ownerClassName: null, …}
  // 1: {name: "toScreenId", Typename: "String", cardinality: 1, isMandatory: false, ownerClassName: null, …}
  // 2: {name: "toUrl", Typename: "String", cardinality: 1, isMandatory: false, ownerClassName: null, …}
  // 3: {name: "openAs", Typename: "String", cardinality: 1, isMandatory: false, ownerClassName: null, …}
  // 4: {name: "navigationKuikaId", Typename: "String", cardinality: 1, isMandatory: false, ownerClassName: null, …}
  public static navigate(
    screen: any,
    _callback: any,
    fromScreen: string,
    toScreen: string,
    _toUrl: string,
    openAs: string | null,
    navigationKuikaId: string | null,
    _title: string | null,
    _placement: string | null,
    _closable: string | null,
    _width: string | null,
    _height: string | null,
    executePageInitActionsAfterClose: boolean,
    disableSmartExecutePageInit: boolean = false
  ): string {
    const { history } = screen.props.navigator;

    let screenInputsQuery = "";
    if (window.kuika?.navigationScreenInputs && !_.isEmpty(window.kuika?.navigationScreenInputs)) {
      screenInputsQuery = querystringify.stringify(window.kuika?.navigationScreenInputs, true);
    }

    if (!window.kuika) window.kuika = {};

    if ((screen.props.navigator as any)?.history?.location?.search?.includes("redirectOnMobile=true")) {
      this.postWebKitMessage(null, {
        actionType: "NAVIGATE",
        openAs: `${openAs}`,
        width: `${_width}`,
        height: `${_height}`,
        placement: `${_placement}`,
        toScreen: `${toScreen}`,
        triggerPageInit: `${executePageInitActionsAfterClose}`,
        disableSmartExecutePageInit: `${disableSmartExecutePageInit}`,
        screenInputs: `${screenInputsQuery}`
      });
      return "";
    }

    // KOA-8559 "Open in Current Overlay": when this navigate is triggered from a screen
    // rendered INSIDE an open drawer/modal/floatingPanel, render the target screen inside
    // that same overlay (swap the inline-mounted master's child, keeping the overlay open
    // and the master chrome mounted) instead of routing the page behind it. The handle is
    // read from the triggering screen's props (injected by withInlineOverlayNav from the
    // overlay's InlineOverlayNavContext), so it is present ONLY for screens actually inside
    // the overlay — a trigger on the page behind (or a maskless FloatPanel background) has
    // no handle. When there's no handle, or the target is not one of that overlay master's
    // children, we degrade to a normal currentPage navigate.
    let effectiveOpenAs: string | null = openAs;
    if (effectiveOpenAs === "currentOverlay") {
      const inlineOverlayNav: IInlineOverlayNav | null | undefined = screen?.props?.inlineOverlayNav;
      const canSwapInOverlay: boolean =
        !!inlineOverlayNav && typeof inlineOverlayNav.canRender === "function" && inlineOverlayNav.canRender(toScreen);
      if (canSwapInOverlay && inlineOverlayNav) {
        const overlayInputs: Record<string, unknown> = { ...(window.kuika?.navigationScreenInputs ?? {}) };
        inlineOverlayNav.push(toScreen, overlayInputs);
        return "";
      }
      effectiveOpenAs = "currentPage";
    }

    switch (effectiveOpenAs) {
      case "currentPage":
        history.push({
          pathname: toScreen,
          search: screenInputsQuery,
          state: {
            screenInputs: {
              // TODO
            }
          }
        });

        if (fromScreen === toScreen || toScreen === window.kuika?.navigationComponentMasterScreen) {
          // Persist any pending debounced offline write BEFORE the hard reload.
          // Otherwise the auto-save timeout scheduled by the preceding save action
          // is destroyed by the reload and the offline write is lost (the save
          // appears not to complete). flushPendingWrites is a no-op when nothing
          // is pending (e.g. online navigations).
          void KuikaCoreWasmBridgeService.getInstance()
            .flushPendingWrites()
            .catch(() => undefined)
            .finally(() => window.location.reload());
        }
        // delete window.kuika?.navigationComponentMasterScreen;

        window.kuika.pageInitCallers ??= {};
        window.kuika.pageInitCallers[fromScreen] = executePageInitActionsAfterClose;

        if (typeof screen?.props?.onClose === "function") {
          screen.props.onClose();
        }

        break;

      case "newTab":
      case "newWindow":
        HelperService.redirectToPath(`/${toScreen}${screenInputsQuery}`, {
          openInNewTab: true
        });
        break;

      default:
        window.kuika.disableSmartExecutePageInit ??= {};
        window.kuika.disableSmartExecutePageInit[fromScreen] = disableSmartExecutePageInit ?? false;
        if (!window.kuika?.navigationComponentMasterScreen) window.kuika.navigationComponentMasterScreen = fromScreen;
        else if (
          window.kuika.navigationComponentMasterScreen &&
          fromScreen !== window.kuika.navigationComponentMasterScreen
        ) {
          window.kuika.navigationComponentMasterScreen = fromScreen;
        }
        const obj = {};
        obj[`NavVisible${navigationKuikaId}`] = true;
        screen.setState(obj);
        break;
    }

    return "";
  }

  // GoBack
  public static goBack(
    screen: { props: { onClose: () => void; navigator: KNavigator } },
    triggerParentAppGoBack: boolean = false
  ) {
    if (screen?.props?.onClose) {
      KuikaAppManager.hideSpinner(screen);
      screen.props.onClose();
      return;
    }

    if (triggerParentAppGoBack && this.getIsMicroApp() && window.parentScreen) {
      const parentScreen = window.parentScreen;
      ReactSystemFunctions.goBack(parentScreen);
      return;
    }

    if (screen.props.navigator.goBack) {
      if ((screen.props.navigator as any)?.history?.location?.search?.includes("redirectOnMobile=true")) {
        this.postWebKitMessage(null, { actionType: "GO_BACK" });
      } else {
        const isWebView = window.location !== window.parent.location;
        if (isWebView) {
          const hasHistory = (screen.props.navigator as any)?.history?.action === "PUSH";
          const parentWindow = window.parent;

          if (parentWindow) {
            const antDrawerWrapperBody = parentWindow.document.querySelector(".ant-drawer-wrapper-body");
            const antModal = parentWindow.document.querySelector(".ant-modal-root");

            if (antModal) {
              const antModalClose: any = antModal.querySelector(".ant-modal-close");

              if (antModalClose) {
                hasHistory ? screen.props.navigator.goBack() : antModalClose.click();
              }
            } else if (antDrawerWrapperBody) {
              const antDrawerClose: any = antDrawerWrapperBody.querySelector(".ant-drawer-close");

              if (antDrawerClose) {
                hasHistory ? screen.props.navigator.goBack() : antDrawerClose.click();
              }
            } else {
              screen.props.navigator.goBack();
            }
          }
        } else {
          screen.props.navigator.goBack();
        }
      }
    }
  }

  public static getMyUsername(): string {
    return window?.userInfo?.username;
  }

  public static getMyUserId(): string | undefined {
    return window?.userInfo?.id;
  }

  public static getMyFirstName(): string {
    return window?.userInfo?.firstName;
  }

  public static getMyLastName(): string {
    return window?.userInfo?.lastName;
  }

  public static getMyFullName(): string {
    const f = window?.userInfo?.firstName;
    const l = window?.userInfo?.lastName;
    return f && l ? `${f} ${l}` : f || l;
  }

  public static getMyPhoneNumber(): string {
    return window?.userInfo?.phoneNumber;
  }

  public static getMyRoleNames(): string {
    return window?.userInfo?.roleNames;
  }

  public static getIsMicroApp(): boolean {
    return KuikaAppManager.IsWebComponent();
  }

  public static async logout(): Promise<void> {
    const urlParams = new URLSearchParams(window.location.search);
    const redirectOnMobileValue = urlParams.get("redirectOnMobile");

    if (redirectOnMobileValue === "true") {
      this.postWebKitMessage(null, { actionType: "LOGOUT" });
      return;
    }

    await UserService.Logout();
  }

  public static async signinwithMSAL(): Promise<void> {
    sessionStorage.setItem("msalRedirectionStarted", "loaded");
    HelperService.gotoLogin();
  }

  // Notification
  // sendPushNotificationToUsername: _sendPushNotificationToUsername,
  // sendPushNotificationToApp: _sendPushNotificationToApp,
  public static notify(
    screen: any,
    message: string,
    type: "success" | "danger" | "info" | "default" | "warning" | "custom",
    position:
      | "top-left"
      | "top-right"
      | "top-center"
      | "bottom-left"
      | "bottom-right"
      | "bottom-center"
      | "top"
      | "bottom",
    duration: number,
    backgroundColor: string | null,
    textColor: string | null,
    fontSize: number | null
  ): boolean | undefined {
    if (message === undefined || message === null) message = "";
    if (typeof message === "object") message = JSON.stringify(message);
    else if (typeof message !== "string" && (message as any).toString) message = (message as any).toString();
    if (message) {
      // todo message = ReactSystemFunctions.translateCustomActions(screen.ml, "{actionID}", screen.this.defaultML, message);

      if (duration === null || duration === undefined || duration < 0) {
        switch (type) {
          case "success": {
            duration = KMainFunctions.NOTIFY_ACTION_DEFAULT_SUCCESS_DURATION;
            break;
          }
          case "danger": {
            duration = KMainFunctions.NOTIFY_ACTION_DEFAULT_ERROR_DURATION;
            break;
          }
          case "info": {
            duration = KMainFunctions.NOTIFY_ACTION_DEFAULT_INFO_DURATION;
            break;
          }
          case "warning": {
            duration = KMainFunctions.NOTIFY_ACTION_DEFAULT_WARNING_DURATION;
            break;
          }
          case "default":
          default: {
            duration = KMainFunctions.NOTIFY_ACTION_DEFAULT_DEFAULT_DURATION;
            break;
          }
        }
      }
      if (position === "top") position = "top-center";
      if (position === "bottom") position = "bottom-center";

      const instanceId = Guid.create().toString();

      let customStyle: string | undefined;

      if (type === "custom") {
        type = "default";

        const style = document.getElementById("dynamic_style");

        customStyle = `
          .custom-notification-${instanceId} {
            background-color: ${backgroundColor} !important;
            border-left: unset !important;

            .notification__close {
              opacity: 0 !important;
            }

            .notification__message {
              color: ${textColor} !important;
              font-size: ${fontSize}px !important;
            }
          }
        `
          .replace(" ", "")
          .trim()
          .replace(/(\r\n|\n|\r)/gm, "");

        style.innerHTML += customStyle;
      }

      setTimeout(() => {
        if (duration < 0) duration = 0;
        if (position === "top") position = "top-center";
        if (position === "bottom") position = "bottom-center";
        if (type === "custom") {
          type = "default";

          setTimeout(
            () => {
              const style = document.getElementById("dynamic_style");
              style.innerHTML = style.innerHTML.replace(customStyle, "");
            },
            duration * 1000 + 1000
          );
        }

        store.addNotification({
          title: "",
          message: message.replace(/&nbsp;/g, ""),
          type,
          container: position,
          animationIn: [`custom-notification-${instanceId}`, "animated", "flipInX"],
          animationOut: [`custom-notification-${instanceId}`, "animated", "fadeOut"],
          dismiss: {
            duration: duration * 1000,
            pauseOnHover: true,
            showIcon: true
          }
        });
      }, 150);
      return true;
    }
  }

  // Device

  public static printCurrentScreen() {}

  public static getPhotoFromGallery = () =>
    new Promise((resolve, reject) => {
      let listener = false;
      const input = document.createElement("input");
      input.classList.add("kuika-take-photo-gallery");
      input.setAttribute("type", "file");
      input.setAttribute("name", "kuika_photo_take");
      input.style.display = "none";
      input.accept = "image/*,application/pdf";
      listener = true;

      window.addEventListener("focus", () => {
        setTimeout(() => {
          if (listener) {
            listener = false;
            let files = Array.from(input.files);
            if (files.length === 0) {
              resolve("");
            }
          }
        }, 1000);
      });

      input.onchange = () => {
        let files = Array.from(input.files);
        if (files.length === 0) {
          resolve("");
        }

        const [file] = files;

        const reader = new FileReader();
        reader.addEventListener("load", (e) => {
          resolve(e.target.result);
        });
        reader.addEventListener("error", (e) => {
          reject(e.target.error);
        });

        reader.readAsDataURL(file);
      };

      input.click();
    });

  public static getPhotosFromGallery = (
    editPhoto: boolean,
    quality: string
  ): Promise<{
    data: {
      dataBase64: string;
      name: string;
      size: number;
      fileExtension: string;
    }[];
  }> => {
    return new Promise((resolve) => {
      const input = document.createElement("input");
      input.type = "file";
      input.multiple = true;
      input.accept = "image/*";

      const processImage = async (
        file: File
      ): Promise<{
        dataBase64: string;
        name: string;
        size: number;
        fileExtension: string;
      }> => {
        return new Promise((processResolve) => {
          const img = new Image();
          const reader = new FileReader();

          reader.onload = (e) => {
            img.src = e.target.result as string;
            img.onload = () => {
              if (quality === "default" || quality === "original") {
                processResolve({
                  dataBase64: e.target.result as string,
                  name: file.name,
                  size: file.size,
                  fileExtension: KMainFunctions.getExtensionByMimeType(file.name, file.type)
                });
                return;
              }

              let maxLength = 400;
              let maxSize = 102410;

              if (quality === "low") {
                maxLength = 400;
                maxSize = 102410;
              } else if (quality === "medium") {
                maxLength = 800;
                maxSize = 204820;
              } else if (quality === "high") {
                maxLength = 1200;
                maxSize = 409640;
              }

              const canvas = document.createElement("canvas");
              let width = img.width;
              let height = img.height;

              if (width > maxLength || height > maxLength) {
                if (width > height) {
                  height = Math.round((height * maxLength) / width);
                  width = maxLength;
                } else {
                  width = Math.round((width * maxLength) / height);
                  height = maxLength;
                }
              }

              canvas.width = width;
              canvas.height = height;
              const ctx = canvas.getContext("2d", {
                willReadFrequently: true,
                alpha: true
              });
              if (ctx) {
                ctx.clearRect(0, 0, width, height);
                ctx.imageSmoothingQuality = "high";
                ctx.drawImage(img, 0, 0, width, height);
              }

              let compressionQuality = 1.0;
              let dataUrl: string;
              do {
                dataUrl = canvas.toDataURL(file.type || "image/jpeg", compressionQuality);
                const size = Math.round((dataUrl.length - 22) * 0.75);
                if (size > maxSize) {
                  compressionQuality -= 0.1;
                } else {
                  break;
                }
              } while (compressionQuality >= 0.1);

              processResolve({
                dataBase64: dataUrl,
                name: file.name,
                size: Math.round((dataUrl.length - 22) * 0.75),
                fileExtension: KMainFunctions.getExtensionByMimeType(file.name, file.type)
              });
            };
          };
          reader.readAsDataURL(file);
        });
      };

      input.onchange = async () => {
        try {
          const files = Array.from(input.files);
          const filePromises = files.map(processImage);

          const results = await Promise.all(filePromises);
          resolve({ data: results.filter((result) => result !== null) });
        } catch (error) {
          resolve({ data: [] });
        }
      };

      input.oncancel = () => {
        resolve({ data: [] });
      };

      input.click();
    });
  };

  public static uploadFile = () => {
    return new Promise((resolve) => {
      let input = document.createElement("input");
      input.type = "file";
      input.multiple = false;
      input.accept = "*";

      input.onchange = () => {
        let files = Array.from(input.files);
        if (files.length === 0) {
          resolve("");
        }

        const [file] = files;

        const reader = new FileReader();
        reader.addEventListener("load", (e) => {
          resolve(e.target.result);
        });
        reader.addEventListener("error", (e) => {
          KMainFunctions.exceptionHandler(e);
          resolve({});
        });
        reader.readAsDataURL(file);
      };

      input.oncancel = () => {
        resolve({});
      };

      input.click();
    });
  };

  public static uploadFileWithInfo = (fileType?: string) => {
    return new Promise((resolve) => {
      let input = document.createElement("input");
      input.type = "file";
      input.multiple = false;

      input.accept = fileType || "*";

      input.onchange = () => {
        let files = Array.from(input.files);
        if (files.length === 0) {
          resolve({
            data: {}
          });
        }

        const [file] = files;
        var resultObj = {
          data: {}
        } as any;
        resultObj.data.name = file.name;
        resultObj.data.type = file.type;
        resultObj.data.size = file.size;
        const reader = new FileReader();
        reader.addEventListener("load", (e) => {
          resultObj.data.data = e.target.result;
          resolve(resultObj);
        });
        reader.addEventListener("error", (e) => {
          KMainFunctions.exceptionHandler(e);
          resolve({});
        });
        reader.readAsDataURL(file);
      };

      input.oncancel = () => {
        resolve({});
      };

      input.click();
    });
  };

  public static uploadFilesWithInfo = (fileType?: string) => {
    return new Promise((resolve) => {
      let input = document.createElement("input");
      input.type = "file";
      input.multiple = true;

      input.accept = fileType || "*";

      input.onchange = () => {
        let files = Array.from(input.files);
        if (files.length === 0) {
          resolve({
            data: []
          });
          return;
        }

        const results: any[] = [];
        let loadedCount = 0;

        files.forEach((file) => {
          const resultObj: any = {
            name: file.name,
            type: file.type,
            size: file.size,
            data: null
          };
          const reader = new FileReader();
          reader.addEventListener("load", (e) => {
            resultObj.data = e.target.result;
            results.push(resultObj);
            loadedCount++;
            if (loadedCount === files.length) {
              resolve({ data: results });
            }
          });
          reader.addEventListener("error", (e) => {
            KMainFunctions.exceptionHandler(e);
            loadedCount++;
            if (loadedCount === files.length) {
              resolve({ data: results });
            }
          });
          reader.readAsDataURL(file);
        });
      };

      input.oncancel = () => {
        resolve({ data: [] });
      };

      input.click();
    });
  };

  public static takePhotoKuikaFunction = (comp: {
    props: { showPhotoTake: () => void; hidePhotoTake: () => void };
    forceUpdate: () => void;
  }) =>
    new Promise((resolve, _reject) => {
      comp.props.showPhotoTake();
      let isListenerAttached: boolean = false;
      let hasCameraMounted: boolean = false;
      let hasDelivered: boolean = false;
      const mountDeadline: number = Date.now() + 10000;
      const deliverPhoto = (imgNode: HTMLImageElement): void => {
        if (hasDelivered) {
          return;
        }
        hasDelivered = true;
        comp.props.hidePhotoTake();
        comp.forceUpdate();
        resolve(imgNode.src);
      };
      const onPhotoLoaded = (event: Event): void => {
        deliverPhoto(event.target as HTMLImageElement);
      };
      // Attach the load listener as soon as the camera mounts instead of a
      // single 350ms shot — on slow devices the camera can mount later, which
      // previously left the action hanging forever (KOA-17786). The same
      // interval also picks up a photo whose load event fired before the
      // listener attached, detects the camera being closed without a photo,
      // and a mount deadline keeps the action from hanging when the camera
      // never renders at all.
      const watchInterval = setInterval(() => {
        const cameraRoot: Element | undefined = document.getElementsByClassName("react-html5-camera-photo")[0];
        if (cameraRoot) {
          hasCameraMounted = true;
          const imgNode: HTMLImageElement | undefined = cameraRoot.getElementsByTagName("img")[0];
          if (imgNode && !isListenerAttached) {
            imgNode.addEventListener("load", onPhotoLoaded);
            isListenerAttached = true;
          }
          if (imgNode && imgNode.complete && imgNode.src.startsWith("data:")) {
            deliverPhoto(imgNode);
          }
          return;
        }
        if (hasCameraMounted || Date.now() > mountDeadline) {
          clearInterval(watchInterval);
          resolve("");
        }
      }, 100);
    });

  // openInBrowser: _openInBrowser,
  public static openInBrowser(val: unknown, openAs: "current" | "newtab") {
    if (typeof val !== "string") {
      KMainFunctions.displayErrorNotification("Invalid URL");
      return;
    }

    let url: string = val;

    if (!url.startsWith("http://") && !url.startsWith("https://")) {
      url = `https://${url}`;
    }

    if (!KMainFunctions.getIsValidHttpUrl(url)) {
      KMainFunctions.displayErrorNotification(`Invalid URL: "${url}"`);
      return;
    }

    if (openAs === "newtab") {
      setTimeout(() => window.open(url, "_blank").focus(), 100);
    } else {
      setTimeout(() => window.open(url, "_self").focus(), 100);
    }
  }

  public static openInWebView(val: string) {
    let url: string = val;
    if (url === undefined || url === null || url === "") {
      window.open("", "_blank").focus();
      return;
    }

    if (!url.startsWith("http://") && !url.startsWith("https://")) {
      url = `https://${url}`;
    }

    setTimeout(() => window.open(url, "_blank").focus(), 100);
  }

  public static async printPdf(base64: string, screen: any) {
    const hash = window.location.hash || "";
    const isCallerMicroApp = hash !== "";
    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

    let base64WithoutPrefix = base64;
    if (base64.startsWith("data:application/pdf;base64,")) {
      base64WithoutPrefix = base64.substring("data:application/pdf;base64,".length);
    }

    const byteCharacters = atob(base64WithoutPrefix);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: "application/pdf" });
    const blobUrl = URL.createObjectURL(blob);

    if (isMobile) {
      window.open(blobUrl, "_blank");
      return;
    }

    if (isCallerMicroApp) {
      const pdfDataUrl = base64.startsWith("data:application/pdf;base64,")
        ? base64
        : `data:application/pdf;base64,${base64}`;
      const newWindow = window.open();
      if (newWindow) {
        newWindow.document.write(`<iframe width='100%' height='100%' src='${pdfDataUrl}'></iframe>`);
      }
      return;
    }

    const printJSModule = (await import("print-js")).default;
    printJSModule({
      printable: base64WithoutPrefix,
      type: "pdf",
      base64: true
    });
  }

  public static printExcel(base64: any) {
    console.log("TODO: SYSTEM FUNCTION NOT IMPLEMENTED YET: printExcel");
    console.log(base64);
  }

  // Local Storage
  // addToBag: _addToBag,
  // removeFromBag: _removeFromBag,
  // clearBag: _clearBag,

  // Location

  public static async locationCoordinatesOfAdress(address: string): Promise<any> {
    if (address === undefined || address === "") {
      return { data: { latitude: "0", longitude: "0" } };
    }
    if (!this.isDocumentReady()) {
      return new Promise((resolve) => {
        setTimeout(async () => {
          const res = await this.locationCoordinatesOfAdress(address);
          resolve(res);
        }, 100);
      });
    }

    const geocoder = new google.maps.Geocoder();

    try {
      const response = await geocoder.geocode({ address });
      if (response?.results.length > 0) {
        const lat = response.results[0].geometry?.location?.lat();
        const lng = response.results[0].geometry?.location?.lng();
        const result = { data: { latitude: lat, longitude: lng } };
        return result;
      }
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return { data: { latitude: undefined, longitude: undefined } };
    }
  }

  public static async locationAdressOfCoordinates(latitude: any, longitude: any): Promise<any> {
    if (latitude === undefined || latitude === "" || longitude === undefined || latitude === "") {
      return { data: { address: "", city: "", state: "", country: "" } };
    }
    if (!this.isDocumentReady()) {
      return new Promise((resolve) => {
        setTimeout(async () => {
          const res = await this.locationAdressOfCoordinates(latitude, longitude);
          resolve(res);
        }, 100);
      });
    }

    const geocoder = new google.maps.Geocoder();

    try {
      const response = await geocoder.geocode({
        location: { lat: Number(latitude), lng: Number(longitude) }
      });

      let city: any;
      let state: any;
      let country: any;
      let address: any;
      let neighborhood: any;
      let street: any;
      let postalCode: any;

      const r = response.results[0];
      if (r) {
        address = r.formatted_address;
        const { address_components } = r;
        if (address_components?.length > 0) {
          for (let i = 0; i < address_components.length; i++) {
            if (address_components[i]?.types?.length > 0) {
              for (let j = 0; j < address_components[i].types.length; j++) {
                if (address_components[i]?.types) {
                  switch (address_components[i].types[j]) {
                    case "administrative_area_level_1":
                      city = address_components[i].long_name;
                      break;
                    case "administrative_area_level_2":
                      state = address_components[i].long_name;
                      break;
                    case "country":
                      country = address_components[i].long_name;
                      break;
                    case "administrative_area_level_4":
                      neighborhood = address_components[i].long_name;
                      break;
                    case "route":
                      street = address_components[i].long_name;
                      break;
                    case "postal_code":
                      postalCode = address_components[i].long_name;
                      break;
                  }
                }
              }
            }
          }
        }
      }
      const result = {
        data: {
          address,
          city,
          state,
          country,
          neighborhood,
          street,
          postalCode
        }
      };
      return result;
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return {
        data: {
          address: undefined,
          city: undefined,
          state: undefined,
          country: undefined
        }
      };
    }
  }

  public static async locationGetCurrentCoordinates(): Promise<any> {
    try {
      if (ReactSystemFunctions.isMapWithLiveLocationTrackingPresented()) {
        if (watchPositionId == null) {
          const firstPosition = await this.initializeWatchPositionAndGetFirstPosition();
          return { data: firstPosition };
        }
        return {
          data: watchPositionData ?? {
            accuracy: undefined,
            latitude: undefined,
            longitude: undefined
          }
        };
      }

      if (watchPositionId != null) {
        ReactSystemFunctions.clearWatchPosition();
      }

      const coordinates = await this.locationGetCurrentCoordinatesPromise();
      const result = {
        data: {
          accuracy: coordinates?.coords?.accuracy,
          latitude: coordinates?.coords?.latitude,
          longitude: coordinates?.coords?.longitude
        }
      };
      return result;
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return {
        data: {
          accuracy: undefined,
          latitude: undefined,
          longitude: undefined
        }
      };
    }
  }

  static async locationGetCurrentCoordinatesPromise(): Promise<any> {
    return new Promise((resolve, reject) => {
      navigator.geolocation.getCurrentPosition(resolve, reject, {
        enableHighAccuracy: true, // Use high-accuracy mode, if available
        timeout: 10000, // Set a timeout of 10 seconds
        maximumAge: 0 // Force a fresh location
      });
    });
  }

  private static isMapWithLiveLocationTrackingPresented = () => {
    const mapElements = document.getElementsByClassName("kuika_maps_with_live_location");

    if (mapElements && mapElements.length > 0) {
      return true;
    }
    return false;
  };

  private static initializeWatchPositionAndGetFirstPosition = (): Promise<{
    accuracy: number;
    latitude: number;
    longitude: number;
  }> => {
    return new Promise((resolve, reject) => {
      if (!navigator.geolocation) {
        reject(new Error("Geolocation is not supported"));
        return;
      }

      watchPositionId = navigator.geolocation.watchPosition(
        (position) => {
          watchPositionData = position.coords;
          ReactSystemFunctions.dispatchLocationUpdate(position.coords);
          resolve({
            accuracy: position.coords.accuracy,
            latitude: position.coords.latitude,
            longitude: position.coords.longitude
          });
        },
        (error) => {
          reject(error);
        },
        {
          enableHighAccuracy: true,
          timeout: 10000,
          maximumAge: 0
        }
      );
    });
  };

  private static dispatchLocationUpdate = (coords: GeolocationCoordinates) => {
    const event = new CustomEvent("kuika-watch-position-update", {
      detail: {
        latitude: coords.latitude,
        longitude: coords.longitude,
        accuracy: coords.accuracy
      }
    });
    window.dispatchEvent(event);
  };

  private static clearWatchPosition = () => {
    if (navigator.geolocation && watchPositionId !== null) {
      navigator.geolocation.clearWatch(watchPositionId);
      watchPositionId = null;
      watchPositionData = null;
    }
  };

  // UI
  public static changeVisibilityOf(screen: any, stateName: string, isVisible: string, _arg: string = "") {
    const obj = {};
    obj[stateName] = isVisible;
    screen.setState(obj);
  }

  public static toggleVisibilityOf(screen: any, stateName: string) {
    const obj = {};
    let isVisible = screen.state[stateName];
    if (isVisible === "hidden") {
      isVisible = "visible";
    } else {
      isVisible = "hidden";
    }
    obj[stateName] = isVisible;
    screen.setState(obj);
  }

  public static toggleEditabilityOf(screen: any, stateName: string) {
    const obj = {};
    let isVisible = screen.state[stateName];
    if (isVisible === "disabled") {
      isVisible = "enabled";
    } else {
      isVisible = "disabled";
    }
    obj[stateName] = isVisible;
    screen.setState(obj);
  }

  public static changeEnabledOf(screen: any, stateName: string, isEnabled: string) {
    const obj = {};
    obj[stateName] = isEnabled;
    screen.setState(obj);
  }

  public static hideIsNotAuthorized(screen: any, stateName: string, roleIds: string[]) {
    const obj = {} as any;
    let isVisible = "hidden";
    const { userInfo } = screen.props.context;
    if (userInfo == null || userInfo == undefined) return isVisible;
    const role =
      userInfo.roles &&
      userInfo.roles.find((r: { id: string; name: string }) => roleIds.find((p) => p === r.id || p === r.name));
    if (role || roleIds.length == 0) {
      isVisible = "visible";
    }
    obj[stateName] = isVisible;
    screen.setState(obj);
  }

  public static sendWhatsappMessage(number: string, message: string) {
    const urlParams = new URLSearchParams(window.location.search);
    const redirectOnMobileValue = urlParams.get("redirectOnMobile");

    if (redirectOnMobileValue === "true") {
      this.postWebKitMessage(null, {
        actionType: "SEND_WP_MESSAGE",
        number: `${number}`,
        message: `${message}`
      });
    } else {
      window.open(`https://wa.me/${number}?text=${encodeURIComponent(message)}`);
    }
  }

  public static disableIsNotAuthorized(screen: any, stateName: string, roleIds: string[]) {
    const obj = {} as any;
    let isEnabled = "disabled";
    const { userInfo } = screen.props.context;
    const role = userInfo?.roles?.find((r: { id: string; name: string }) =>
      roleIds.find((p) => p === r.id || p === r.name)
    );
    if (role) {
      isEnabled = "enabled";
    }
    obj[stateName] = isEnabled;
    screen.setState(obj);
  }

  public static setValueOf(
    screen: any,
    componentName: any,
    value: any,
    multipleValuePropName?: string | null,
    _pk?: any
  ) {
    if (!screen) return;
    // pagination case start
    if (
      screen[`${componentName}_kuikaPaginationRef`] != undefined ||
      screen[`${componentName}_kuikaPaginationRef`] != null
    ) {
      if (
        screen[`${componentName}_kuikaPaginationRef`].current != undefined &&
        screen[`${componentName}_kuikaPaginationRef`].current != null &&
        screen[`${componentName}_kuikaPaginationRef`].current.setPaginationData != undefined
      ) {
        if (
          multipleValuePropName === "pageSize" &&
          screen[`${componentName}_kuikaPaginationRef`].current.setPageSize != undefined
        ) {
          screen[`${componentName}_kuikaPaginationRef`].current.setPageSize(value);
        } else {
          screen[`${componentName}_kuikaPaginationRef`].current.setPaginationData(value);
        }
      }
    }
    // pagination case end
    if (screen[`${componentName}_kuikaTableRef`] != undefined || screen[`${componentName}_kuikaTableRef`] != null) {
      if (
        screen[`${componentName}_kuikaTableRef`].current != undefined &&
        screen[`${componentName}_kuikaTableRef`].current != null &&
        screen[`${componentName}_kuikaTableRef`].current.setSelectedValues != undefined
      ) {
        if (
          multipleValuePropName === "selectedValues" &&
          screen[`${componentName}_kuikaTableRef`].current.setSelectedValues != undefined
        ) {
          screen[`${componentName}_kuikaTableRef`].current.setSelectedValues(value);
        }
      }
    }
    // MicroApp
    else if (
      screen[`${componentName}_kuikaMicroAppRef`] != undefined ||
      screen[`${componentName}_kuikaMicroAppRef`] != null
    ) {
      if (screen[`${componentName}_kuikaMicroAppRef`].current) {
        screen[`${componentName}_kuikaMicroAppRef`].current.setProjectId?.(value);
      }
    } else if (
      screen[`${componentName}_kuikaChatRef`] != undefined &&
      screen[`${componentName}_kuikaChatRef`] != null &&
      screen[`${componentName}_kuikaChatRef`].current
    ) {
      if (multipleValuePropName === "message" && screen[`${componentName}_kuikaChatRef`].current.setMessage) {
        screen[`${componentName}_kuikaChatRef`].current.setMessage(value);
      }

      if (
        multipleValuePropName === "currentlyEditingMessageId" &&
        screen[`${componentName}_kuikaChatRef`].current.setCurrentlyEditingMessageId
      ) {
        screen[`${componentName}_kuikaChatRef`].current.setCurrentlyEditingMessageId(value);
      }
    } else if (
      screen[`${componentName}_kuikaWebViewRef`] != undefined ||
      screen[`${componentName}_kuikaWebViewRef`] != null
    ) {
      if (screen[`${componentName}_kuikaWebViewRef`].current) {
        if (screen[`${componentName}_kuikaWebViewRef`].current.setUrl) {
          screen[`${componentName}_kuikaWebViewRef`].current.setUrl(value);
        }
      }
    } else if (
      screen[`${componentName}_kuikaCarouselRef`] != undefined ||
      screen[`${componentName}_kuikaCarouselRef`] != null
    ) {
      if (screen[`${componentName}_kuikaCarouselRef`].current) {
        if (screen[`${componentName}_kuikaCarouselRef`].current.setStartingIndex) {
          screen[`${componentName}_kuikaCarouselRef`].current.setStartingIndex(value);
        }
      }
    }
    // Document CASE START
    else if (screen[`${componentName}_kuikaDocumentRef`] != undefined) {
      const ref = screen[`${componentName}_kuikaDocumentRef`];
      // "mode" targets the view/readonly/edit setter; anything else (incl. legacy single-target
      // calls with no propName) targets versionId for backward compatibility.
      const targetsMode: boolean = (multipleValuePropName ?? "").toLowerCase() === "mode";
      const setterName: "setMode" | "setVersionId" = targetsMode ? "setMode" : "setVersionId";
      const applySetter = (): void => {
        ref.current[setterName](value);
      };
      if (ref.current?.[setterName]) {
        applySetter();
      } else {
        // Component not mounted yet — wait for ref to be ready, then call
        const waitForRef = () => {
          if (ref.current?.[setterName]) {
            applySetter();
          } else {
            setTimeout(waitForRef, 50);
          }
        };
        setTimeout(waitForRef, 50);
      }
      return;
    }
    // Document CASE END
    // DocumentCompare CASE START
    else if (screen[`${componentName}_kuikaDocumentCompareRef`] != undefined) {
      const ref = screen[`${componentName}_kuikaDocumentCompareRef`];
      const setter = multipleValuePropName === "rightVersionId" ? "setRightVersionId" : "setLeftVersionId";
      if (ref.current?.[setter]) {
        ref.current[setter](value);
      } else {
        const waitForRef = () => {
          if (ref.current?.[setter]) {
            ref.current[setter](value);
          } else {
            setTimeout(waitForRef, 50);
          }
        };
        setTimeout(waitForRef, 50);
      }
      return;
    }
    // DocumentCompare CASE END
    // LocationSearch CASE START
    else if (
      screen[`${componentName}_kuikaPlacesAutocompleteInputRef`] != undefined &&
      screen[`${componentName}_kuikaPlacesAutocompleteInputRef`] != null
    ) {
      if (screen[`${componentName}_kuikaPlacesAutocompleteInputRef`].current != null) {
        if (screen[`${componentName}_kuikaPlacesAutocompleteInputRef`].current.handleChange) {
          screen[`${componentName}_kuikaPlacesAutocompleteInputRef`].current.handleChange(value);
        }
      }
    }
    // LocationSearch CASE END
    else if (
      screen[`${componentName}_kuikaDateRef`] != undefined ||
      screen[`${componentName}_kuikaDateRef`] != null ||
      screen[`${componentName}_kuikaDatePickerRef`] != undefined ||
      screen[`${componentName}_kuikaDatetimeRef`] != undefined
    ) {
      let refText =
        screen[`${componentName}_kuikaDateRef`] != undefined
          ? "_kuikaDateRef"
          : screen[`${componentName}_kuikaDatePickerRef`] !== undefined
            ? "_kuikaDatePickerRef"
            : screen[`${componentName}_kuikaDatetimeRef`] !== undefined
              ? "_kuikaDatetimeRef"
              : "";
      if (screen[`${componentName}${refText}`].current) {
        if (
          screen[`${componentName}${refText}`].current.setDisableBeforeDate &&
          multipleValuePropName === "disablebeforedate"
        ) {
          screen[`${componentName}${refText}`].current.setDisableBeforeDate(value);
          return;
        }
        if (
          screen[`${componentName}${refText}`].current.setDisableBeforeTime &&
          multipleValuePropName === "disablebeforetime"
        ) {
          screen[`${componentName}${refText}`].current.setDisableBeforeTime(value);
          return;
        }
        if (
          screen[`${componentName}${refText}`].current.setDisableAfterTime &&
          multipleValuePropName === "disableaftertime"
        ) {
          screen[`${componentName}${refText}`].current.setDisableAfterTime(value);
          return;
        }
      }
      const data = {};
      data[componentName] = value;
      screen.props.form.setFieldsValue(data);
      return Guid.create().toString();
    } else if (
      screen?.[`${componentName}_kuikaCalendarRef`]?.current != undefined &&
      screen?.[`${componentName}_kuikaCalendarRef`]?.current != null
    ) {
      if (multipleValuePropName === "defaultPanel") {
        screen?.[`${componentName}_kuikaCalendarRef`]?.current?.setPanel(value);
      }
      // _kuikaTextInputRef
    } else if (
      screen?.[`${componentName}_kuikaTextInputRef`]?.current != undefined &&
      screen?.[`${componentName}_kuikaTextInputRef`]?.current != null &&
      multipleValuePropName === "mask"
    ) {
      screen?.[`${componentName}_kuikaTextInputRef`]?.current?.setMask?.(value);
    } else {
      const data = {};
      if (multipleValuePropName) {
        let obj = screen.props.form.getFieldValue(componentName);
        if (obj === undefined) {
          obj = {};
        }
        if (typeof obj !== "object" || obj === null) {
          obj = {};
        }
        obj[multipleValuePropName] = value;
        data[componentName] = obj;
      } else {
        data[componentName] = value;
      }

      screen.props.form.setFieldsValue(data);
      return Guid.create().toString();
    }
  }

  public static toggleLeftMenu(screen: any): string {
    screen.setState({ isLeftMenuVisible: !screen.state.isLeftMenuVisible });
    return "";
  }

  public static async changePassword(
    screen: any,
    currentpassword: string,
    newpassword: string,
    dontSendEmail?: boolean,
    language?: string,
    callback?: () => {}
  ) {
    const response: any = await UserService.ChangePassword({
      currentpassword,
      newpassword,
      newpasswordConfirm: newpassword,
      dontSendEmail: dontSendEmail || false,
      language: language || ""
    } as IChangePasswordDto);

    if (response.status.toString().startsWith("4") || response.status.toString().startsWith("5")) {
      KuikaAppManager.hideSpinner(screen);
      throw new Error(`Password change failed: Reason: ${response.message}`);
    }
  }

  public static readFromLocalStorage(key: string) {
    return window.localStorage.getItem(key);
  }

  public static writeToLocalStorage(key: string, value: string) {
    window.localStorage.setItem(key, value);
  }

  public static deleteFromLocalStorage(key: string) {
    window.localStorage.removeItem(key);
  }

  public static readFromSessionStorage(key: string) {
    return window.sessionStorage.getItem(key);
  }

  public static writeToSessionStorage(key: string, value: string) {
    window.sessionStorage.setItem(key, value);
  }

  public static deleteFromSessionStorage(key: string) {
    window.sessionStorage.removeItem(key);
  }

  public static isDate(value: any, _value2: any): string {
    let result = value instanceof Date || value instanceof moment;
    if (result === true) return "";
    result = isNaN(Date.parse(value)) === false || moment(value).isValid();
    return result === true ? "" : "Invalid Date";
  }

  public static isEmpty(val: any, _val2?: any): boolean {
    if (typeof val === "number") {
      return false;
    }
    return _.isEmpty(val);
  }

  // setValueOfDI: _setValueOfDI,

  // Comparison
  public static isGreaterThan(val1: string | any[], val2: string | any[]): boolean {
    if (val1 === undefined || val2 === undefined || val1 === null || val2 === null) return false;
    if (val1.length === 0 || val2.length === 0) return false;
    return Number(val1) > Number(val2);
  }

  public static isGreaterOrEqual(val1: string | any[], val2: string | any[]): boolean {
    if (val1 === undefined || val2 === undefined || val1 === null || val2 === null) return false;
    if (val1.length === 0 || val2.length === 0) return false;
    return Number(val1) >= Number(val2);
  }

  public static isLessThan(val1: string | any[], val2: string | any[]): boolean {
    if (val1 === undefined || val2 === undefined || val1 === null || val2 === null) return false;
    if (val1.length === 0 || val2.length === 0) return false;
    return Number(val1) < Number(val2);
  }

  public static isLessOrEqual(val1: string | any[], val2: string | any[]): boolean {
    if (val1 === undefined || val2 === undefined || val1 === null || val2 === null) return false;
    if (val1.length === 0 || val2.length === 0) return false;
    return Number(val1) <= Number(val2);
  }

  public static isEqualTo(val1: string | boolean, val2: string | boolean): boolean {
    if (
      (val1?.toString()?.toLowerCase() === "true" && val2 === true) ||
      (val1?.toString()?.toLowerCase() === "false" && val2 === false) ||
      (val1 === true && val2?.toString()?.toLowerCase() === "true") ||
      (val1 === false && val2?.toString()?.toLowerCase() === "false") ||
      (val1?.toString()?.toLowerCase() === "true" && val2?.toString()?.toLowerCase() === "true") ||
      (val1?.toString()?.toLowerCase() === "false" && val2?.toString()?.toLowerCase() === "false")
    ) {
      return true;
    }

    return val1 == val2;
  }

  public static isShorterOrEqualLength(val1: string, val2: null): boolean {
    if (val1 === undefined || val2 === undefined || val1 === null || val2 === null) return false;
    return val1.length <= Number(val2);
  }

  public static isShorterLength(val1: string, val2: null): boolean {
    if (val1 === undefined || val2 === undefined || val1 === null || val2 === null) return false;
    return val1.length < Number(val2);
  }

  public static isLongerLength(val1: string, val2: null): boolean {
    if (val1 === undefined || val2 === undefined || val1 === null || val2 === null) return false;
    return val1.length > Number(val2);
  }

  public static isLongerOrEqualLength(val1: string, val2: null): boolean {
    if (val1 === undefined || val2 === undefined || val1 === null || val2 === null) return false;
    return val1.length >= Number(val2);
  }

  public static isEqualLength(val1: string, val2: null): boolean {
    if (val1 === undefined || val2 === undefined || val1 === null || val2 === null) return false;
    return val1.length === Number(val2);
  }

  public static isNotEqualTo(val1: any, val2: any): boolean {
    if (
      (val1?.toString()?.toLowerCase() === "true" && val2 === true) ||
      (val1?.toString()?.toLowerCase() === "false" && val2 === false) ||
      (val1 === true && val2?.toString()?.toLowerCase() === "true") ||
      (val1 === false && val2?.toString()?.toLowerCase() === "false") ||
      (val1?.toString()?.toLowerCase() === "true" && val2?.toString()?.toLowerCase() === "true") ||
      (val1?.toString()?.toLowerCase() === "false" && val2?.toString()?.toLowerCase() === "false")
    ) {
      return false;
    }

    return val1 != val2;
  }

  public static startsWith(val1: string, val2: string | any): boolean {
    if (val1 === undefined || val2 === undefined) return false;
    if (val1 === null || val2 === null) return false;
    if (val1.length === 0 || val2.length === 0) return false;
    if (val1.startsWith && val1.startsWith(val2)) return true;
    return false;
  }

  public static doesNotStartWith(val1: string, val2: string | any): boolean {
    if (val1 === undefined || val2 === undefined) return false;
    if (val1 === null || val2 === null) return false;
    if (val1.length === 0 || val2.length === 0) return false;
    if (!val1.startsWith(val2)) return true;
    return false;
  }

  public static endsWith(val1: string, val2: string | any): boolean {
    if (val1 === undefined || val2 === undefined) return false;
    if (val1 === null || val2 === null) return false;
    if (val1.length === 0 || val2.length === 0) return false;
    if (val1.endsWith && val1.endsWith(val2)) return true;
    return false;
  }

  public static contains(val1: string | any[], val2: string | any): boolean {
    if (val1 === undefined || val2 === undefined || val1 === null || val2 === null) return false;
    if (val1.length === 0 || val2.length === 0) return false;
    if (val1.indexOf && val1.indexOf(val2) > -1) return true;
    return false;
  }

  public static doesNotContain(val1: string | any[], val2: string | any): boolean {
    // doesNotContain is the logical complement of contains, exactly as the C#, Kotlin and Swift
    // runtimes define it (CsSystemFunctions/KtSystemFunctions/SwiftSystemFunctions: !contains).
    // The previous hand-rolled body returned false for an empty/missing val1, which is wrong: an
    // empty value does not contain anything, so "does not contain X" must be true. That bug
    // disabled/hid components whose Editability/Visibility/Validation condition read an empty
    // value — e.g. a MultiSelect whose `value.Title doesNotContain <actionResult>.first.field`
    // was evaluated on an empty selection at page init, leaving the dependent component wrongly
    // disabled (KOA-17789). KOA-17730 surfaced this by making value() return [] for an empty
    // select instead of throwing, so the condition now actually reaches doesNotContain.
    return !ReactSystemFunctions.contains(val1, val2);
  }

  public static isEarlierThan(val1: moment.MomentInput, val2: moment.MomentInput): boolean {
    if (val1 === null || val2 === null) return false;
    if (val1 === undefined || val2 === undefined) return false;
    return moment(val1).isBefore(moment(val2));
  }

  public static isEarlierOrEqual(val1: moment.MomentInput, val2: moment.MomentInput): boolean {
    if (val1 === null || val2 === null) return false;
    if (val1 === undefined || val2 === undefined) return false;
    return moment(val1).isSameOrBefore(moment(val2), "day");
  }

  public static isLaterThan(val1: moment.MomentInput, val2: moment.MomentInput): boolean {
    if (val1 === undefined || val2 === undefined) return false;
    return moment(val1).isAfter(moment(val2));
  }

  public static isLaterOrEqual(val1: moment.MomentInput, val2: moment.MomentInput): boolean {
    if (val1 === null || val2 === null) return false;
    if (val1 === undefined || val2 === undefined) return false;
    return moment(val1).isSameOrAfter(moment(val2), "day");
  }

  /* public static isSameDay(val1, val2): boolean {
    if (val1 === null || val2 === null) return false;
    if (val1 === undefined || val2 === undefined) return false;
    alert("TODO: SYSTEM FUNCTION NOT IMPLEMENTED YET: isSameDay");
    return false;
  }

  public static isSameMonth(val1, val2): boolean {
    if (val1 === null || val2 === null) return false;
    if (val1 === undefined || val2 === undefined) return false;
    alert("TODO: SYSTEM FUNCTION NOT IMPLEMENTED YET: isSameMonth");
    return false;
  }

  public static isSameYear(val1, val2): boolean {
    if (val1 === null || val2 === null) return false;
    if (val1 === undefined || val2 === undefined) return false;
    alert("TODO: SYSTEM FUNCTION NOT IMPLEMENTED YET: isSameYear");
    return false;
  }
  */

  public static isNotEmpty(val: any, _x?: any): boolean {
    if (val === 0) {
      return true;
    }
    if (!val || val == "") {
      return false;
    }
    return true;
  }

  public static isGuid(val): boolean {
    return Guid.isGuid(val);
  }

  private static readonly BARCODE_FORMATS = [
    "qr_code",
    "ean_13",
    "ean_8",
    "code_128",
    "code_39",
    "code_93",
    "upc_a",
    "upc_e",
    "itf",
    "pdf417",
    "aztec",
    "data_matrix",
    "codabar"
  ];

  private static readonly CAMERA_CONSTRAINTS: MediaTrackConstraints = {
    facingMode: { ideal: "environment" },
    width: { ideal: 1280 },
    height: { ideal: 720 }
  };

  private static buildBarcodeOverlay = (): IBarcodeOverlayHandles => {
    const overlay = document.createElement("div");
    overlay.style.cssText = [
      "position:fixed",
      "inset:0",
      "z-index:99999",
      "background:rgba(0,0,0,0.92)",
      "display:flex",
      "flex-direction:column",
      "align-items:center",
      "justify-content:center",
      "font-family:sans-serif"
    ].join(";");

    const box = document.createElement("div");
    box.style.cssText = [
      "position:relative",
      "width:min(90vw,400px)",
      "height:min(90vw,400px)",
      "border-radius:12px",
      "overflow:hidden",
      "background:#000",
      "box-shadow:0 0 0 2px #246DFF"
    ].join(";");

    const cornerStyles = [
      "top:0;left:0;border-top:3px solid #246DFF;border-left:3px solid #246DFF",
      "top:0;right:0;border-top:3px solid #246DFF;border-right:3px solid #246DFF",
      "bottom:0;left:0;border-bottom:3px solid #246DFF;border-left:3px solid #246DFF",
      "bottom:0;right:0;border-bottom:3px solid #246DFF;border-right:3px solid #246DFF"
    ];
    cornerStyles.forEach((style) => {
      const corner = document.createElement("div");
      corner.style.cssText = `position:absolute;width:20px;height:20px;z-index:2;${style}`;
      box.appendChild(corner);
    });

    if (!document.getElementById("kuika-scan-style")) {
      const style = document.createElement("style");
      style.id = "kuika-scan-style";
      style.textContent = "@keyframes kuikaScan{0%,100%{top:8px}50%{top:calc(100% - 10px)}}";
      document.head.appendChild(style);
    }
    const scanLine = document.createElement("div");
    scanLine.style.cssText = [
      "position:absolute",
      "left:8px",
      "right:8px",
      "height:2px",
      "background:linear-gradient(90deg,transparent,#246DFF,transparent)",
      "z-index:2",
      "animation:kuikaScan 2s ease-in-out infinite"
    ].join(";");
    box.appendChild(scanLine);

    const video = document.createElement("video");
    video.style.cssText = "width:100%;height:100%;object-fit:cover";
    video.setAttribute("autoplay", "");
    video.setAttribute("muted", "");
    video.setAttribute("playsinline", "");
    box.appendChild(video);

    const label = document.createElement("p");
    label.textContent = translationService.translate("scan_barcode.instruction");
    label.style.cssText = "color:#ccc;font-size:13px;margin:16px 0 0;text-align:center;padding:0 16px";

    const cancelBtn = document.createElement("button");
    cancelBtn.textContent = translationService.translate("common.cancel");
    cancelBtn.style.cssText = [
      "margin-top:20px",
      "padding:10px 32px",
      "border-radius:8px",
      "border:none",
      "background:#333",
      "color:#fff",
      "font-size:14px",
      "cursor:pointer"
    ].join(";");

    overlay.appendChild(box);
    overlay.appendChild(label);
    overlay.appendChild(cancelBtn);
    document.body.appendChild(overlay);

    return { overlay, video, label, cancelBtn };
  };

  private static startNativeDetector = (
    video: HTMLVideoElement,
    onDetect: (value: string) => void,
    onFrame: (id: number) => void
  ): void => {
    const DetectorCtor = window.BarcodeDetector as IBarcodeDetectorCtor;
    const detector = new DetectorCtor({
      formats: ReactSystemFunctions.BARCODE_FORMATS
    });

    const scanFrame = () => {
      if (video.readyState < video.HAVE_CURRENT_DATA) {
        onFrame(requestAnimationFrame(scanFrame));
        return;
      }
      detector
        .detect(video)
        .then((results) => {
          if (results.length > 0) onDetect(results[0].rawValue);
          else onFrame(requestAnimationFrame(scanFrame));
        })
        .catch(() => onFrame(requestAnimationFrame(scanFrame)));
    };

    onFrame(requestAnimationFrame(scanFrame));
  };

  private static startZXingReader = (
    video: HTMLVideoElement,
    onDetect: (value: string) => void,
    onStreamReady: (stream: MediaStream) => void,
    onReaderReady: (reader: BrowserMultiFormatReader) => void,
    onError: (message: string) => void
  ): void => {
    const reader = new BrowserMultiFormatReader();
    onReaderReady(reader);

    reader
      .decodeFromConstraints({ video: ReactSystemFunctions.CAMERA_CONSTRAINTS }, video, (result) => {
        if (result) onDetect(result.getText());
      })
      .then(() => {
        if (video.srcObject instanceof MediaStream) onStreamReady(video.srcObject);
      })
      .catch((error) => onError(error instanceof Error ? error.message : String(error)));
  };

  public static scanBarcode(): Promise<string | undefined> {
    return new Promise((resolve, reject) => {
      const { overlay, video, label, cancelBtn } = ReactSystemFunctions.buildBarcodeOverlay();

      let stream: MediaStream | null = null;
      let rafId: number | null = null;
      let zxingReader: BrowserMultiFormatReader | null = null;
      let settled = false;

      const settle = (value: string | undefined) => {
        if (settled) return;
        settled = true;
        cleanup();
        resolve(value);
      };

      const timeoutId = setTimeout(() => settle(undefined), 120_000);

      const cleanup = () => {
        clearTimeout(timeoutId);
        if (rafId !== null) {
          cancelAnimationFrame(rafId);
          rafId = null;
        }
        if (zxingReader) {
          try {
            zxingReader.reset();
          } catch {
            /* reader already stopped */
          }
          zxingReader = null;
        }
        if (stream) {
          stream.getTracks().forEach((t) => t.stop());
          stream = null;
        }
        if (overlay.parentNode) document.body.removeChild(overlay);
      };

      cancelBtn.addEventListener("click", () => settle(undefined));

      if (window.BarcodeDetector) {
        navigator.mediaDevices
          .getUserMedia({ video: ReactSystemFunctions.CAMERA_CONSTRAINTS })
          .then((s) => {
            stream = s;
            video.srcObject = s;
            return video.play();
          })
          .then(() =>
            ReactSystemFunctions.startNativeDetector(video, settle, (id) => {
              rafId = id;
            })
          )
          .catch((err) => {
            cleanup();
            reject(new Error(`Camera access denied: ${err instanceof Error ? err.message : String(err)}`));
          });
      } else {
        ReactSystemFunctions.startZXingReader(
          video,
          settle,
          (s) => {
            stream = s;
          },
          (reader) => {
            zxingReader = reader;
          },
          (msg) => {
            label.textContent = translationService.translate("scan_barcode.camera_error", undefined, { msg });
            label.style.color = "#f87171";
            setTimeout(() => settle(undefined), 2500);
          }
        );
      }
    });
  }

  // Remaining
  // isValid: _isValid,
  public static isValid(val1: any): boolean {
    if (typeof val1 === "string") return val1.length === 0;
    if (val1 === false) return false;
    if (val1 === true) return true;
    return true;
  }

  public static validateToken() {}

  public static async downloadFile(data: string | IRestResult, filename?: string): Promise<void> {
    if (!data || data === "") {
      this.notify(undefined, "Invalid file data.", "warning", "bottom-right", 3, null, null, null);
      return;
    }
    if (typeof data === "string" && KMainFunctions.isValidUrl(data)) {
      const blob: Blob = await KMainFunctions.toBlob(data);
      KMainFunctions.downloadFile(
        blob,
        KMainFunctions.generateFilenameForDownloadFile(
          filename,
          KMainFunctions.getExtensionByMimeType(filename, blob.type)
        )
      );
      return;
    }

    if (typeof data === "string" && Guid.parse(data).toString() !== Guid.EMPTY) {
      const url = KMainFunctions.getUrlByWithResourceId(data);
      const blob: Blob = await KMainFunctions.toBlob(url);
      KMainFunctions.downloadFile(
        blob,
        KMainFunctions.generateFilenameForDownloadFile(
          filename,
          KMainFunctions.getExtensionByMimeType(filename, blob.type)
        )
      );
      return;
    }

    if (typeof data === "string" && KMainFunctions.isBase64(data)) {
      const mimeType = await KMainFunctions.getFileType(data);
      const blob = new Blob([KMainFunctions.base64ToUint8Array(data)], {
        type: mimeType
      });
      KMainFunctions.downloadFile(
        blob,
        KMainFunctions.generateFilenameForDownloadFile(
          filename,
          KMainFunctions.getExtensionByMimeType(filename, mimeType)
        )
      );
      return;
    }

    if (typeof data === "string" && KMainFunctions.isRelativeUrl(data)) {
      const backendUrl: string = KuikaAppManager.GetBackendUrl();
      const absoluteUrl: string = data.startsWith("/") ? `${backendUrl}${data}` : `${backendUrl}/${data}`;
      const blob: Blob = await KMainFunctions.toBlob(absoluteUrl);
      KMainFunctions.downloadFile(
        blob,
        KMainFunctions.generateFilenameForDownloadFile(
          filename,
          KMainFunctions.getExtensionByMimeType(filename, blob.type)
        )
      );
      return;
    }

    if (typeof data === "object") {
      const blob: Blob = await KMainFunctions.toBlob(
        `${KMainFunctions.getBase64UrlPrefix(data.mimeType)}${data.content}`
      );
      KMainFunctions.downloadFile(
        blob,
        KMainFunctions.generateFilenameForDownloadFile(
          !!filename && filename !== "" ? filename : data.fileName,
          KMainFunctions.getExtensionByMimeType(!!filename && filename !== "" ? filename : data.fileName, blob.type)
        )
      );
      return;
    }

    this.notify(undefined, "Invalid file data.", "warning", "bottom-right", 3, null, null, null);
    return;
  }

  public static getLanguage(_languages: any, defaultLanguage: string): string {
    let retVal = "";
    const mlFromLocalStorage = localStorage.getItem("ml");
    if (!mlFromLocalStorage) {
      if (defaultLanguage) {
        localStorage.setItem("ml", defaultLanguage);
        retVal = defaultLanguage;
      }
    } else {
      retVal = mlFromLocalStorage;
    }
    return retVal;
  }

  public static toggleMenuCollapse(screen: any, stateName: string) {
    const obj = {} as any;
    var tmp = Object.keys(screen.props.form.getFieldsValue()).find((v) => v.includes(stateName));

    var value = screen.props.form.getFieldValue(tmp);
    obj.tmp = value;
    obj.tmp.collapsed = !obj.tmp.collapsed;
    screen.props.form.setFieldsValue(!value);
  }

  public static toggleHamburgerMenuCollapse(screen: any, stateName: string) {
    const obj = {} as any;
    var tmp = Object.keys(screen.props.form.getFieldsValue()).find((v) => v.includes(stateName));
    var value = screen.props.form.getFieldValue(tmp);
    obj[tmp] = { ...value, hamburgerCollapsed: !value.hamburgerCollapsed };
    screen.props.form.setFieldsValue(obj);
  }

  public static setLanguage(_screen: any, culture: string) {
    if (localStorage.getItem("ml") === culture) {
      return;
    }

    // Auth lives in the HttpOnly `access_token`/`refresh_token` cookies, not in
    // localStorage — the JS-readable `is_logged_in` cookie is the only login
    // signal the SPA can observe (same check as isLoggedIn/interceptors). A
    // stale `localStorage.getItem("refreshToken")` here was null for every
    // cookie-authenticated user, so Set Language never reached the server.
    const isAuthenticated: boolean = KuikaAppManager.readLoginStateCookie("is_logged_in") === "1";

    if (isAuthenticated) {
      LanguageService.SaveLanguage(culture).then((res) => {
        if (res && res.status === 200) {
          localStorage.setItem("ml", culture);
          window.location.reload();
        } else {
          console.error("Save language failed", {
            status: res?.status,
            statusText: res?.statusText,
            url: res?.config?.url
          });
          KMainFunctions.displayErrorNotification(
            localStorage.getItem("ml") === "tr_TR"
              ? "Dil değiştirilemedi. Lütfen tekrar deneyin."
              : "Language could not be changed. Please try again."
          );
        }
      });
    } else {
      // Not logged in (e.g. login/public screen): there is no user record to
      // sync to, so persist the choice client-side and reload for the UI.
      localStorage.setItem("ml", culture);
      window.location.reload();
    }
  }

  public static getAvailableLanguages(languages: any[]) {
    const languageList: any = [];
    languages?.map((x: { ShortName: string; IsDefault: any; Name: any }) => {
      if (x.ShortName !== "FixedValues") {
        languageList.push({
          shortName: x.ShortName,
          isDefault: x.IsDefault,
          name: x.Name
        });
      }
    });
    return languageList;
  }

  public static translateCustomActions(languages: any, actionId: any, defaultLanguage: any, defaultValue: string) {
    if (!languages) return defaultValue;

    const lastUnderscoreIndex = actionId.lastIndexOf("_");
    const stringWithoutLastUnderscore = actionId.substring(0, lastUnderscoreIndex).replace(/_/g, "-");
    actionId = stringWithoutLastUnderscore + actionId.substring(lastUnderscoreIndex);

    const cache = this.getTranslateCache(languages);
    const langName = this.getLanguage(languages, defaultLanguage);

    // Try selected language (PropertyName-only lookup)
    const langMaps = cache.byName.get(langName);
    if (langMaps) {
      const value = langMaps.propOnly.get(actionId);
      if (value) return value;
    }

    // Fallback to FixedValues
    const fixedMaps = cache.byShortName.get("FixedValues");
    if (fixedMaps) {
      const value = fixedMaps.propOnly.get(actionId);
      if (value) return value;
    }

    return defaultValue;
  }

  public static translate(languages: any, diId: any, propertyName: any, defaultLanguage: any) {
    if (!languages) return "";

    const cache = this.getTranslateCache(languages);
    const langName = this.getLanguage(languages, defaultLanguage);
    const key = `${diId}\0${propertyName}`;

    // Try selected language
    const langMaps = cache.byName.get(langName);
    if (langMaps) {
      const value = langMaps.idProp.get(key);
      if (value) return value;
    }

    // Fallback to FixedValues
    const fixedMaps = cache.byShortName.get("FixedValues");
    if (fixedMaps) {
      const value = fixedMaps.idProp.get(key);
      if (value) return value;
    }

    return "";
  }

  public static getEmailValidationMessage() {
    const language = localStorage.getItem("ml");
    let retValue = "";
    switch (language) {
      case "en_US":
        retValue = "Please Enter a Valid Email.";
        break;

      case "fr_FR":
        retValue = "Veuillez saisir un e-mail valide.";
        break;

      case "tr_TR":
        retValue = "Geçerli bir mail adresi giriniz.";
        break;
      default:
        retValue = "Please Enter a Valid Email.";
        break;
    }
    return retValue;
  }

  public static openInMap(p1: any, p2: any, _p3: any, _p4: any) {
    window.open(`https://www.google.com/maps/@${p1},${p2},12.00z`);
    return;
  }

  public static phoneNumberCall(number: any) {
    window.open(`tel:${number}`);
  }

  public static mailTo(receivers: string, cc?: string, bcc?: string, subject?: string, body?: string) {
    if (!receivers) return;
    let divider = "?";

    let mailToURL = `mailto:${receivers}`;

    if (cc) {
      mailToURL += `${divider}cc=${cc}`;
      divider = "&";
    }

    if (bcc) {
      mailToURL += `${divider}bcc=${bcc}`;
      divider = "&";
    }

    if (subject) {
      mailToURL += `${divider}subject=${subject}`;
      divider = "&";
    }

    if (body) {
      mailToURL += `${divider}body=${body}`;
      divider = "&";
    }

    window.open(mailToURL);
  }
  // validatePhoneNumber: _validatePhoneNumber,
  // validateEmail: _validateEmail,

  // toLocaleString: _toLocaleString,
  // trimRight: _trimRight,
  // toTitleCase: _toTitleCase,
  // substring: _substring,
  // concatenate: _concatenate,

  // registerPopup: _registerPopup,
  // deregisterPopup: _deregisterPopup,

  // attachFile: _attachFile,
  // attachFileUrl: _attachFileUrl,
  // downloadFile: _downloadFile,
  // downloadFileUrl: _downloadFileUrl,

  // scanBarcodeKuikaFunction: _scanBarcodeKuikaFunction,

  // searchOnClientSide: _searchOnClientSide,
  // kuikaSearchOnClientSide: _kuikaSearchOnClientSide,

  // getFromLangPack: _getFromLangPack,
  // setLanguage: _setLanguage,
  // getLanguage: _getLanguage,
  // getAvailableLanguages: _getAvailableLanguages,
  // translate: _translate,
  // translateToStringArray: _translateToStringArray,

  // isNotEmpty: _isNotEmpty,
  // getColorForTableRow: _getColorForTableRow,
  // increment: _increment,
  // and: _and,
  // or: _or,
  // not: _not,

  // base64ToBlob: _base64ToBlob,
  // downloadFile: _downloadFile,
  // authGoogleExternalLogin: _authGoogleExternalLogin,
  public static goToFullScreen(): void {
    const elem: any = document.getElementsByTagName("html")[0];

    const urlParams = new URLSearchParams(window.location.search);
    const redirectOnMobileValue = urlParams.get("redirectOnMobile");

    if (redirectOnMobileValue === "true") {
      this.postWebKitMessage(null, {
        actionType: "GO_TO_FULL_SCREEN"
      });
    } else if (elem.requestFullscreen) {
      elem.requestFullscreen();
    } else if (elem.webkitRequestFullscreen) {
      /* Safari */
      elem.webkitRequestFullscreen();
    } else if (elem.msRequestFullscreen) {
      /* IE11 */
      elem.msRequestFullscreen();
    }
  }

  public static getLocale(): any {
    let mlKey = localStorage.getItem("ml");

    if (!mlKey) {
      mlKey = "en_US";
    }

    switch (mlKey) {
      case "hy_AM":
        return hy_AM;

      case "az_AZ":
        return az_AZ;

      case "bg_BG":
        return bg_BG;

      case "ca_ES":
        return ca_ES;

      case "hr_HR":
        return hr_HR;

      case "cs_CZ":
        return cs_CZ;

      case "da_DK":
        return da_DK;

      case "nl_NL":
        return nl_NL;

      case "en_US":
        return en_US;

      case "en_GB":
        return en_GB;

      case "et_EE":
        return et_EE;

      case "fi_FI":
        return fi_FI;

      case "fr_FR":
        return fr_FR;

      case "ka_GE":
        return ka_GE;

      case "de_DE":
        return de_DE;

      case "el_GR":
        return el_GR;

      case "hu_HU":
        return hu_HU;

      case "is_IS":
        return is_IS;

      case "it_IT":
        return it_IT;

      case "kk_KZ":
        return kk_KZ;

      case "lv_LV":
        return lv_LV;

      case "lt_LT":
        return lt_LT;

      case "mk_MK":
        return mk_MK;

      case "nb_NO":
        return nb_NO;

      case "pl_PL":
        return pl_PL;

      case "pt_PT":
        return pt_PT;

      case "ro_RO":
        return ro_RO;

      case "ru_RU":
        return ru_RU;

      case "sr_RS":
        return sr_RS;

      case "sk_SK":
        return sk_SK;

      case "sl_SI":
        return sl_SI;

      case "es_ES":
        return es_ES;

      case "sv_SE":
        return sv_SE;

      case "tr_TR":
        return tr_TR;

      case "uk_UA":
        return uk_UA;

      default:
        return en_US;
    }
  }

  public static updateUserName(
    currentUserName: string,
    newUserName: string,
    dontSendEmail?: boolean,
    language?: string
  ): void {
    const obj = {
      userName: currentUserName,
      newUserName,
      dontSendEmail: dontSendEmail || false,
      language: language || ""
    } as IUpdateUsernameDto;
    UserService.UpdateUserName(obj);
  }

  public static updateUserStartingScreen(currentUserName: string, startingScreenId: string): void {
    const obj: IUpdateUserStartingScreen = {
      userName: currentUserName,
      startingScreenId
    };
    UserService.UpdateUserStartingScreen(obj);
  }

  public static async componentToPDF(targetComponent: string, quality: string, orientation: string) {
    const generatePDF = (await import("react-to-pdf")).default;
    const Resolution = (await import("react-to-pdf")).Resolution;

    const options: any = {
      method: "build",
      resolution: Resolution[quality],
      overrides: {
        pdf: {
          compress: true
        },
        canvas: {
          useCORS: true
        }
      },
      page: {
        orientation: orientation ?? "portrait"
      }
    };
    const getTargetElement = () => document.getElementById(targetComponent);
    var a = await generatePDF(getTargetElement, options);
    var blobValue = a.output("blob");
    return new Promise((resolve, _) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.readAsDataURL(blobValue);
    });
  }

  public static async componentToPDFSave(
    targetComponent: string,
    filename: string,
    quality: string,
    orientation: string
  ) {
    const generatePDF = (await import("react-to-pdf")).default;
    const Resolution = (await import("react-to-pdf")).Resolution;

    const urlParams = new URLSearchParams(window.location.search);
    const redirectOnMobileValue = urlParams.get("redirectOnMobile");

    let file = filename;
    if (!file.endsWith(".pdf")) {
      file = `${file}.pdf`;
    }

    const options: any = {
      filename: file,
      method: "save",
      resolution: Resolution[quality],
      overrides: {
        pdf: {
          compress: true
        },
        canvas: {
          useCORS: true
        }
      },
      page: {
        orientation: orientation ?? "portrait"
      }
    };
    const getTargetElement = () => document.getElementById(targetComponent);
    const result = await generatePDF(getTargetElement, options);
    if (redirectOnMobileValue && redirectOnMobileValue === "true") {
      const blob = result.output("blob");
      const base64 = await KMainFunctions.convertBlobToBase64(blob);
      this.postWebKitMessage(null, {
        actionType: "DOWNLOAD_BLOB",
        filename: `${file}`,
        base64Str: `${base64}`,
        mimeType: `${blob.type}`
      });
    }
  }

  public static scrollTo(elemenetId: string) {
    if (!elemenetId) return;
    const element = window.document.getElementById(elemenetId);
    if (!element) return;
    element.scrollIntoView({ behavior: "smooth" });
  }

  public static setFocusTo(elementId: string) {
    if (!elementId) return;
    const element = window.document.getElementById(elementId);
    const element2: HTMLElement = window.document.querySelector(`[focusId="${elementId}"]`);
    if (!element && !element2) return;
    setTimeout(() => {
      // Use preventScroll to avoid browser auto-scrolling to the focused element,
      // which causes unwanted scroll-to-top in MFE (microapp) context (EMR-1).
      element?.focus({ preventScroll: true });
      element2?.focus({ preventScroll: true });
    }, 0);
  }

  public static openPdf(data: string, warnLandscape: boolean, openAs: "newTab" | "currentPage"): void {
    if (KMainFunctions.isBase64(data) || data.startsWith("data:application/pdf;base64")) {
      KMainFunctions.openBase64Pdf(data, warnLandscape, openAs);
      return;
    }

    if (KMainFunctions.isValidUrl(data)) {
      KMainFunctions.openUrlPdf(data, openAs);
      return;
    }

    const urlParams = new URLSearchParams(window.location.search);
    const redirectOnMobileValue = urlParams.get("redirectOnMobile");

    if (redirectOnMobileValue === "true") {
      this.postWebKitMessage(null, {
        actionType: "GET_REPORT",
        link: `${data}`,
        warnLandscape: `${warnLandscape}`,
        openAs: `${openAs}`
      });
      return;
    }

    this.notify(undefined, "Invalid pdf data.", "warning", "bottom-right", 3, null, null, null);
    return;
  }

  public static async share(data: string): Promise<void> {
    try {
      if (!navigator.share || !data) return;

      let text: string | undefined;
      let files: File[];

      if (
        (data.toLowerCase().startsWith("http://") || data.toLowerCase().startsWith("https://")) &&
        data.indexOf(" ") < 0
      ) {
        if (data.toLowerCase().endsWith(".pdf")) {
          const blob: Blob = await KMainFunctions.toBlob(data);
          files = [new File([blob], `${Guid.create().toString()}.${blob.type.split("/")[1]}`, { type: blob.type })];
        } else {
          text = data;
        }
      } else if (data.startsWith("BEGIN:VCARD") || data.startsWith("VCARD")) {
        const vcfBlob = new Blob([data], { type: "text/vcard" });
        const vcfFile = new File([vcfBlob], "Share.vcf", {
          type: "text/vcard"
        });
        try {
          await navigator.share({ files: [vcfFile] });
        } catch {
          const url = URL.createObjectURL(vcfBlob);
          const a = document.createElement("a");
          a.href = url;
          a.download = "Share.vcf";
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          URL.revokeObjectURL(url);
        }
        return;
      } else if (data.includes(";base64,")) {
        const blob: Blob = await KMainFunctions.toBlob(data);
        const mimeType = data.split(";base64,")[0].replace("data:", "");
        const ext = mimeType.split("/")[1] || "txt";
        const fileName = `${Guid.create().toString()}.${ext}`;
        files = [new File([blob], fileName, { type: mimeType })];
      } else {
        text = data;
      }
      const shareData: ShareData = {};
      if (text) shareData.text = text;
      if (files?.length) shareData.files = files;
      await navigator.share(shareData);
    } catch (e) {
      KMainFunctions.exceptionHandler(e);
    }
  }

  public static selectLanguage(): string {
    return "";
  }

  public static getVersionInfo(): string {
    return "1.0.0";
  }

  public static getMyNotifications(_username: any, _no: any, _no2: any, _no3: any) {
    console.log("TODO: SYSTEM FUNCTION NOT IMPLEMENTED YET: getMyNotifications");
  }

  public static markAsReadNotification(_username: any, _notificationId: any) {
    console.log("TODO: SYSTEM FUNCTION NOT IMPLEMENTED YET: markAsReadNotification");
  }

  public static async sendPushNotificationToUsername(
    username: string,
    title: string,
    message: string,
    extraData: any
  ): Promise<void> {
    NotificationService.SendPushNotificationToUsername({
      username,
      title,
      message,
      extraData
    });
  }

  public static isValidEmail(val1: any, _val2: any): any {
    if (!val1) return true;

    return /^([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x22([^\x0d\x22\x5c\x80-\xff]|\x5c[\x00-\x7f])*\x22)(\x2e([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x22([^\x0d\x22\x5c\x80-\xff]|\x5c[\x00-\x7f])*\x22))*\x40([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x5b([^\x0d\x5b-\x5d\x80-\xff]|\x5c[\x00-\x7f])*\x5d)(\x2e([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x5b([^\x0d\x5b-\x5d\x80-\xff]|\x5c[\x00-\x7f])*\x5d))*$/.test(
      val1?.toString()?.trim()
    );
    // return /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(val1?.toString());
  }

  public static SendPushNotification(p1, p2, p3) {}

  public static async isLoggedIn() {
    if (KuikaAppManager.readLoginStateCookie("is_logged_in") === "1") {
      const result = await UserService.ValidateToken();
      return KMainFunctions.IsResStatus2XX(result);
    }
    return false;
  }

  // STRIPE ACTIONS START
  public static async stripePayment(amount: string, currency: string, description: string): Promise<IStripePayment> {
    const stripePaymentDto = {
      amount,
      currency,
      description
    } as IStripePaymentDto;
    const res = await StripeService.OneTimePayment(stripePaymentDto);
    if (res.status === 200) {
      return res.data;
    }
    return {} as IStripePayment;
  }

  public static async getPaymentReceiptLink(paymentIntent: string): Promise<string> {
    const dto = {
      paymentIntent
    } as IStripeCaptureDto;
    const res = await StripeService.GetPaymentReceiptLink(dto);
    if (res.status === 200) {
      return res.data;
    }
    return {} as any;
  }

  public static async getPaymentReceiptBase64(paymentIntent: string): Promise<string> {
    const dto = {
      paymentIntent
    } as IStripeCaptureDto;
    const res = await StripeService.GetPaymentReceiptBase64(dto);
    if (res.status === 200) {
      return res.data;
    }
    return {} as any;
  }

  public static async checkPaymentIntentStatus(paymentIntent: string): Promise<any> {
    const dto = {
      paymentIntent
    } as IStripeCaptureDto;
    const res = await StripeService.CheckPaymentIntentStatus(dto);
    if (res.status === 200) {
      return res;
    }
    return {} as any;
  }

  public static async openStripePaymentDrawer(
    screen: any,
    cllbck: any,
    amount: string,
    currency: string,
    description: string,
    applicationFee: string,
    destination: string,
    captureMethod: string,
    paymentType: string,
    supportedPaymentTypes?: string
  ): Promise<any> {
    const stripePaymentDto = {
      amount,
      currency,
      description,
      applicationFeeAmount: applicationFee,
      ConnectedAccount: destination,
      captureMethod,
      supportedPaymentTypes
    } as IStripePaymentDto;
    const endPoint =
      paymentType === "single" ? StripeService.OneTimePayment : StripeService.OneTimePaymentWithDestination;
    const res = await endPoint(stripePaymentDto);
    if (res.status === 200) {
      const response = {};
      screen?.props.showStripeDrawer(res.data, cllbck, screen, false);
      return res.data;
    }
    return "";
  }

  public static async setupIntent(screen: any, cllbck: any, supportedPaymentTypes: string): Promise<any> {
    const stripePaymentDto = {
      supportedPaymentTypes
    } as any;
    const res = await StripeService.SetupIntent(stripePaymentDto);
    if (res.status === 200) {
      const response = {};
      screen?.props.showStripeDrawer(res.data, cllbck, screen, true);
      return res.data;
    }
    return "";
  }

  public static async refundStripePayment(paymentIntent: string, reason: string, amount: string): Promise<boolean> {
    const stripePaymentDto = {
      amount,
      reason,
      paymentIntent
    } as IStripeRefundDto;
    const res = await StripeService.RefundPayment(stripePaymentDto);
    if (res.status === 200) {
      return res.data;
    }
    return false;
  }

  public static async captureReservedFunds(paymentIntent: string, amount: string): Promise<boolean> {
    const stripePaymentDto = {
      amount,
      paymentIntent
    } as IStripeCaptureDto;
    const res = await StripeService.CapturePayment(stripePaymentDto);
    if (res.status === 200) {
      return res.data;
    }
    return false;
  }

  public static async chargePaymentMethod(
    paymentmethod: string,
    currency: string,
    amount: string,
    stripeCustomerId: string,
    description: string,
    paymenttype: string,
    feeamount: string,
    destination: string
  ): Promise<any> {
    const stripePaymentDto = {
      paymentmethod,
      amount,
      currency,
      stripeCustomerId,
      description,
      paymenttype,
      feeamount,
      destination
    } as IStripeChargePaymentMethodDto;
    const res = await StripeService.ChargePaymentMethod(stripePaymentDto);
    if (res.status === 200) {
      return res.data;
    }
    return false;
  }

  public static async getConnectedAccountBalance(connectedAccount: string): Promise<any> {
    const stripePaymentDto = {
      connectedAccount
    } as IStripeConnectedAccountDto;
    const res = await StripeService.GetConnectedAccountBalance(stripePaymentDto);
    if (res.status === 200) {
      return res.data;
    }
    return undefined;
  }

  public static async getConnectedAccountStatus(connectedAccount: string): Promise<any> {
    const stripePaymentDto = {
      connectedAccount
    } as IStripeConnectedAccountDto;
    const res = await StripeService.GetConnectedAccountStatus(stripePaymentDto);
    if (res.status === 200) {
      return res.data;
    }
    return false;
  }

  public static async getConnectedAccountOnboardingLink(connectedAccount: string): Promise<any> {
    const stripePaymentDto = {
      connectedAccount,
      returnLocation: KMainFunctions.windowLocationOrigin
    } as IStripeConnectedAccountOnboardingDto;
    const res = await StripeService.GetConnectedAccountOnboardingLink(stripePaymentDto);
    if (res.status === 200) {
      return res.data;
    }
    return KMainFunctions.windowLocationOrigin;
  }

  public static async createConnectedAccount(type: string, country: string, email: string): Promise<any> {
    const stripePaymentDto = {
      type,
      country,
      email
    } as IStripeCreateConnectedAccountDto;
    const res = await StripeService.CreateConnectedAccount(stripePaymentDto);
    if (res.status === 200) {
      return res.data;
    }
    return "";
  }

  public static async connectedAccountWithdraw(
    amount: string,
    connectedAccount: string,
    currency: string
  ): Promise<any> {
    const stripePaymentDto = {
      amount,
      connectedAccount,
      currency
    } as IStripeConnectedAccountWithdraw;
    const res = await StripeService.ConnectedAccountWithdraw(stripePaymentDto);
    if (res.status === 200) {
      return res.data;
    }
    return "";
  }

  public static async connectedAccountPayout(amount: string, connectedAccount: string, currency: string): Promise<any> {
    const stripePaymentDto = {
      amount,
      connectedAccount,
      currency
    } as IStripeConnectedAccountPayout;
    const res = await StripeService.ConnectedAccountPayout(stripePaymentDto);
    if (res.status === 200) {
      return res.data;
    }
    return "";
  }

  public static async cancelStripePayment(paymentIntent: string): Promise<boolean> {
    const dto = {
      paymentIntent
    } as IStripeCaptureDto;
    const res = await StripeService.CancelPaymentIntent(dto);
    if (res.status === 200) {
      return res.data;
    }
    return false;
  }

  public static async updateStripeUserInfo(
    email: string,
    name: string,
    phone: string,
    description: string
  ): Promise<boolean> {
    const dto = {
      email,
      name,
      phone,
      description
    } as IStripeUpdateCustomerDto;
    const res = await StripeService.UpdateStripeUserInfo(dto);
    if (res.status === 200) {
      return res.data;
    }
    return false;
  }

  public static async removeStripePaymentMethod(paymentmethod: string): Promise<any> {
    const stripePaymentDto = {
      paymentmethod
    } as IStripeDeletePaymentMethodDto;
    const res = await StripeService.DeletePaymentMethod(stripePaymentDto);
    if (res.status === 200) {
      return res.data;
    }
    return undefined;
  }

  public static async getCustomerPaymentMethods(): Promise<any> {
    const res = await StripeService.GetCustomerPaymentMethods();
    if (res.status === 200) {
      return res;
    }
    return undefined;
  }

  public static async getCustomerPaymentMethodsbyId(stripeCustomerId: string): Promise<any> {
    const res = await StripeService.GetCustomerPaymentMethodsbyId({
      stripeCustomerId
    });
    if (res.status === 200) {
      return res;
    }
    return undefined;
  }

  public static async printPDFQZ(
    printerName: string,
    pdfBase64: string,
    pageW: number,
    pageH: number,
    totalHeight: number,
    stickyPaper: boolean,
    onePage: boolean,
    pdfList: any,
    key: string
  ): Promise<boolean> {
    const qz = (await import("qz-tray")).default;
    const { KEYUTIL, KJUR, stob64, hextorstr } = await import("jsrsasign");

    const privateKey = key;

    qz.security.setSignatureAlgorithm("SHA512"); // Since 2.1
    qz.security.setSignaturePromise((toSign: any) => {
      return function (resolve: (arg0: any) => void, reject: (arg0: any) => void) {
        try {
          const pk = KEYUTIL.getKey(privateKey);
          const sig = new KJUR.crypto.Signature({ alg: "SHA512withRSA" }); // Use "SHA1withRSA" for QZ Tray 2.0 and older
          sig.init(pk);
          sig.updateString(toSign);
          const hex = sig.sign();
          resolve(stob64(hextorstr(hex)));
        } catch (err) {
          console.error(err);
          reject(err);
        }
      };
    });

    try {
      const config = qz.configs.create(printerName);
      config.config = {
        orientation: "portrait",
        size: {
          width: pageW,
          height: pageH
        },
        units: "in"
      };

      if (totalHeight == 0) totalHeight = pageH;

      qz.security.setCertificatePromise((resolve: (arg0: string) => void, _reject: any) => {
        resolve(`-----BEGIN CERTIFICATE-----
          MIID4TCCAsmgAwIBAgIUTix9J/qAFmdZj1DlZ32r5UCBQzgwDQYJKoZIhvcNAQEL
          BQAwfzELMAkGA1UEBhMCVFIxCzAJBgNVBAgMAlRSMQswCQYDVQQHDAJUUjEOMAwG
          A1UECgwFSURBVEExDjAMBgNVBAsMBUlEQVRBMRcwFQYDVQQDDA4qLmlkYXRhLmNv
          bS50cjEdMBsGCSqGSIb3DQEJARYOKi5pZGF0YS5jb20udHIwIBcNMjIwNDIwMTQ0
          MDQwWhgPMjA1MzEwMTMxNDQwNDBaMH8xCzAJBgNVBAYTAlRSMQswCQYDVQQIDAJU
          UjELMAkGA1UEBwwCVFIxDjAMBgNVBAoMBUlEQVRBMQ4wDAYDVQQLDAVJREFUQTEX
          MBUGA1UEAwwOKi5pZGF0YS5jb20udHIxHTAbBgkqhkiG9w0BCQEWDiouaWRhdGEu
          Y29tLnRyMIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEA7ksdRHbjfxrB
          tVaskaDR5Zx3JGxsmE5cpbcwRZ0s8H3VkyxKlfSER9tMJs/CGlTtOsmCPgVW5uW9
          qkXOGB0LMFCkM2qfW22hq5eLFunWDicAgkc4rvIgTHbtMR+aM4hxQh4F04OaN5gy
          xFwDAwpKDJ6p43qX/TLzPaM7TUEX7SjYdA38oKjK3SFHzUDrvIKkieySmF12lyGJ
          UMrndN9scgH1DpD6uBHHqwUi7bUMRw2vaFGAXrkaBytfIlB/rzgsPIA0Ir0SfcON
          hK3oOXJe68pIY00AJkbmzp7SgjxGU/lpVhJI/wMRqHjXJ7106avX5h/IqDkfEtjG
          QI004UqriwIDAQABo1MwUTAdBgNVHQ4EFgQU9+kYlFmzC7HX7RGKDZ3KJJj4l8Yw
          HwYDVR0jBBgwFoAU9+kYlFmzC7HX7RGKDZ3KJJj4l8YwDwYDVR0TAQH/BAUwAwEB
          /zANBgkqhkiG9w0BAQsFAAOCAQEAQbRjJC6k5ZFYOgHTAhBsrwsvZ6ukbzEHbBhC
          rbE7NzTYS2QhYMbYM6O0e0jJ57dnEk03V4fXuaKLRVfKAqwFNEZgydwOZ7rZXi6O
          6Pi2IIxN7LHYtYrZwnANaWfUvwbULa439Fh1L5mVbKNpI0qLoC8JSO1gn+7BFv0v
          4AkgeFoEXa2IqlpupGIHFKPNA3M3RGNNFrysDDDKwV+cc2oAmXnxsEPI59sF4D1C
          l71cSa0tP2ZrHiv6PqgYQRSp4Tx2NlohkAmR/cZYmHjWb+jPYb/uVSNQP3ytoo+7
          XO7lMjGj++rQ+cqglSQrz6Tga4XFqseviYcWz11N8r5r6n7qww==
          -----END CERTIFICATE-----
          `);
      });

      if (onePage) {
        qz.websocket.connect().then(() => {
          const base64string = pdfBase64.split(",")[1];
          var printData: any = [];
          printData = pdfBase64.startsWith("^XA")
            ? [pdfBase64]
            : [
                "^XA\n",
                `^MN${stickyPaper ? "Y" : "N"}\n`,
                `^LL${totalHeight * 203.2}\n`,
                {
                  type: "pdf",
                  format: "base64",
                  data: base64string,
                  options: {
                    language: "ZPL",
                    pageHeight: totalHeight * 203.2,
                    pageWidth: pageW * 203.2
                  }
                },
                "^XZ\n"
              ];
          qz.print(config, printData)
            .catch()
            .then(() => {
              qz.websocket.disconnect();
            });
        });
      } else {
        qz.websocket.connect().then(() => {
          pdfList = pdfBase64.split("#####");
          for (const item of pdfList) {
            const base64string = item.split(",")[1];
            var printData: any = [];
            printData = item.startsWith("^XA")
              ? [item]
              : [
                  "^XA\n",
                  `^MN${stickyPaper ? "Y" : "N"}\n`,
                  `^LL${totalHeight * 203.2}\n`,
                  {
                    type: "pdf",
                    format: "base64",
                    data: base64string,
                    options: {
                      language: "ZPL",
                      pageHeight: totalHeight * 203.2,
                      pageWidth: pageW * 203.2
                    }
                  },
                  "^XZ\n"
                ];
            qz.print(config, printData)
              .catch()
              .then(() => {
                qz.websocket.disconnect();
              });
          }
        });
      }
      return true;
    } catch {
      return false;
    }
  }

  public static async generateQrCode(value: any) {
    try {
      const QRCode = (await import("qrcode")).default;
      const qr = await QRCode.toDataURL(value, { errorCorrectionLevel: "H" });
      return qr;
    } catch (err) {
      console.error(err);
      return "";
    }
  }

  public static updateUserRoles(roles: any) {
    if (window.userInfo) {
      window.userInfo.roles = roles;
    }
  }

  public static async generateVcf(
    name: string,
    surname: string,
    email: string,
    mobile: string,
    workPhone: string,
    homePhone: string,
    _gender: string,
    photo: string,
    nickname: string,
    note: string,
    organization: string,
    role: string,
    title: string,
    url: string,
    workUrl: string,
    homeUrl: string
  ): Promise<string> {
    const VCard = (await import("vcard-creator")).default;
    const vCard = new VCard();
    vCard.addName(surname, name);

    if (!_.isEmpty(email)) {
      vCard.addEmail(email);
    }

    if (!_.isEmpty(mobile)) {
      vCard.addPhoneNumber(mobile, "CELL");
    }

    if (!_.isEmpty(workPhone)) {
      vCard.addPhoneNumber(workPhone, "WORK");
    }

    if (!_.isEmpty(homePhone)) {
      vCard.addPhoneNumber(homePhone, "HOME");
    }

    if (!_.isEmpty(photo)) {
      vCard.addPhoto(photo);
    }

    if (!_.isEmpty(nickname)) {
      vCard.addNickname(nickname);
    }

    if (!_.isEmpty(note)) {
      vCard.addNote(note);
    }

    if (!_.isEmpty(organization)) {
      vCard.addCompany(organization);
    }

    if (!_.isEmpty(role)) {
      vCard.addRole(role);
    }

    if (!_.isEmpty(title)) {
      vCard.addJobtitle(title);
    }

    if (!_.isEmpty(url)) {
      vCard.addURL(url);
    }

    if (!_.isEmpty(workUrl)) {
      vCard.addURL(workUrl, "WORK");
    }

    if (!_.isEmpty(homeUrl)) {
      vCard.addURL(homeUrl, "HOME");
    }

    return vCard.toString();
  }

  public static async downloadVcf(
    name: string,
    surname: string,
    email: string,
    mobile: string,
    workPhone: string,
    homePhone: string,
    gender: string,
    photo: string,
    nickname: string,
    note: string,
    organization: string,
    role: string,
    title: string,
    url: string,
    workUrl: string,
    homeUrl: string
  ): Promise<void> {
    const vcfString = await this.generateVcf(
      name,
      surname,
      email,
      mobile,
      workPhone,
      homePhone,
      gender,
      photo,
      nickname,
      note,
      organization,
      role,
      title,
      url,
      workUrl,
      homeUrl
    );

    const blob = new Blob([vcfString], {
      type: "text/vcard"
    });

    const objectUrl = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = objectUrl;
    a.download = `${name}_${surname}.vcf`;
    a.click();
  }

  public static isWeb(): boolean {
    return true;
  }

  public static isIOS(): boolean {
    return false;
  }

  public static isAndroid(): boolean {
    return false;
  }

  // Backend-reachability gate. `navigator.onLine` alone is unreliable —
  // Chrome's DevTools "Network → Offline" preset blocks traffic at the network
  // layer without flipping the API to false, and conversely the OS may report
  // online while the backend / DNS / captive portal is unreachable. So we
  // combine the OS hint with observed Axios traffic: a recent ERR_NETWORK
  // counts as offline until a subsequent successful response.
  //
  // Note for the SW interaction: assets served from the Workbox runtime cache
  // do NOT count as "online" signals. `markNetworkSuccess`/`markNetworkError`
  // are only called from the Axios interceptors, and `/v1/api/*` is in the
  // SW's NETWORK_ONLY list — so these markers reflect actual backend reach.
  private static observedNetworkErrorAt: number = 0;
  private static observedNetworkSuccessAt: number = 0;
  private static readonly OFFLINE_AFTER_ERROR_MS: number = 30_000;
  private static onlineEventsBound: boolean = false;

  private static bindOnlineEvents(): void {
    if (ReactSystemFunctions.onlineEventsBound || typeof window === "undefined") return;
    window.addEventListener("online", () => {
      ReactSystemFunctions.observedNetworkErrorAt = 0;
    });
    window.addEventListener("offline", () => {
      ReactSystemFunctions.observedNetworkErrorAt = Date.now();
    });
    ReactSystemFunctions.onlineEventsBound = true;
  }

  public static async isOnline(): Promise<boolean> {
    ReactSystemFunctions.bindOnlineEvents();
    if (typeof navigator !== "undefined" && !navigator.onLine) {
      return false;
    }
    const errAt: number = ReactSystemFunctions.observedNetworkErrorAt;
    const okAt: number = ReactSystemFunctions.observedNetworkSuccessAt;
    if (errAt > okAt && Date.now() - errAt < ReactSystemFunctions.OFFLINE_AFTER_ERROR_MS) {
      return false;
    }
    return true;
  }

  public static markNetworkSuccess(): void {
    ReactSystemFunctions.observedNetworkSuccessAt = Date.now();
  }

  public static markNetworkError(): void {
    ReactSystemFunctions.observedNetworkErrorAt = Date.now();
  }

  /**
   * Fetch fresh offline database from server.
   * Same as mobile: KtSystemFunctions.fetchOfflineDb() / SwiftSystemFunctions.fetchOfflineDb()
   *
   * Mobile flow:
   * 1. Check unsent records → if any, show warning and return null
   * 2. Call API to fetch database
   * 3. Import database to local storage (KPersister.SaveFile)
   * 4. Return base64 content
   */
  public static async fetchOfflineDb(): Promise<string | null> {
    const syncService = OfflineSyncService.getInstance();
    const wasmService = KuikaCoreWasmBridgeService.getInstance();
    const persistenceService = OfflineDbPersistenceService.getInstance();

    // A fetch replaces the entire local DB, so warn only when there is something to lose:
    // actual unsent local changes. Mirror mobile (KPersister.IsUnsentRecordsAvailable) and the
    // dirty-aware Db_GetPendingChanges — a row is pending only if it is in the dirty table, not
    // merely because it was seeded SentFromMobile = 0 by a previous fetch. Without this gate the
    // confirm fired on every fetch (even right after a push, when nothing is pending) — the
    // "push first" false positive. A first-time fetch has no local DB and nothing to lose.
    // On the durable (OPFS/native) path the DB lives in the file, not IndexedDB — check the engine.
    await wasmService.initialize();
    const hasLocalDb: boolean = wasmService.hasDurablePersistence()
      ? await wasmService.Db_IsInitialized()
      : await persistenceService.hasPersistedDatabase();
    if (hasLocalDb) {
      const hasPendingChanges: boolean = await syncService.hasPendingChanges();
      if (hasPendingChanges) {
        const proceed: boolean = window.confirm(translationService.translate("offline_db.fetch_unsynced_confirm"));
        if (!proceed) {
          return null;
        }
      }
    }

    const loadingId = this.showLoadingNotification(translationService.translate("offline_db.downloading"));

    try {
      // fetchAndImport picks the memory-optimal path: on the browser OPFS path it STREAMS the
      // download straight into the OPFS file (no full-DB buffer → multi-GB capable); otherwise it
      // does the binary byte import.
      const imported = await syncService.fetchAndImport();
      if (imported) {
        // Durable store (OPFS / native) already persisted the DB. Only the IndexedDB fallback
        // (:memory:) needs a whole-DB base64 mirror (which would OOM on large DBs).
        let returnValue = "offline-db-ready";
        if (!wasmService.hasDurablePersistence()) {
          const exported = await wasmService.Db_ExportDatabaseBase64();
          await persistenceService.saveDatabase(exported);
          returnValue = exported;
        }

        this.removeNotification(loadingId);
        this.showResultNotification(translationService.translate("offline_db.download_success"), "success");
        return returnValue;
      }

      this.removeNotification(loadingId);
      this.showResultNotification(translationService.translate("offline_db.download_error"), "danger");
      return null;
    } catch (error) {
      console.error("fetchOfflineDb failed:", error);
      this.removeNotification(loadingId);
      this.showResultNotification(translationService.translate("offline_db.download_error"), "danger");
      return null;
    }
  }

  /**
   * Push local changes to server.
   * Same as mobile: KtSystemFunctions.pushOfflineDb() / SwiftSystemFunctions.pushOfflineDb()
   *
   * Mobile flow:
   * 1. Export unsent records database (GetUnsentRecordsDbBase64)
   * 2. Call API to push database
   * 3. Mark all records as synced (SetSentFromMobileToSent)
   * 4. Return true
   */
  public static async pushOfflineDb(): Promise<boolean> {
    if (!navigator.onLine) {
      this.showResultNotification(translationService.translate("offline_db.push_offline_warning"), "warning");
      return false;
    }

    const syncService = OfflineSyncService.getInstance();
    const wasmService = KuikaCoreWasmBridgeService.getInstance();

    const loadingId = this.showLoadingNotification(translationService.translate("offline_db.uploading"));

    try {
      const result = await syncService.pushChanges();

      if (result.success && result.payload) {
        // CRITICAL: mark synced ONLY the rows that were in the pushed
        // payload. A criteria-based re-scan would also mark rows the user
        // added between export and this call (the push network window) —
        // those would never be sent and silently lost on the next fetch.
        // The exact pushed bytes are returned by pushChanges so the mark
        // and the transmission can never diverge.
        await wasmService.Db_MarkPayloadAsSynced(result.payload);

        this.removeNotification(loadingId);
        this.showResultNotification(translationService.translate("offline_db.upload_success"), "success");
        return true;
      }

      this.removeNotification(loadingId);
      this.showResultNotification(translationService.translate("offline_db.upload_error"), "danger");
      return false;
    } catch (error) {
      console.error("pushOfflineDb failed:", error);
      this.removeNotification(loadingId);
      this.showResultNotification(translationService.translate("offline_db.upload_error"), "danger");
      return false;
    }
  }

  /**
   * Delete local offline database.
   * Same as mobile: KtSystemFunctions.deleteOfflineDb() / SwiftSystemFunctions.deleteOfflineDb()
   */
  public static async deleteOfflineDb(): Promise<boolean> {
    const loadingId = this.showLoadingNotification(translationService.translate("offline_db.deleting"));

    try {
      const syncService = OfflineSyncService.getInstance();
      await syncService.deleteOfflineDatabase();

      this.removeNotification(loadingId);
      this.showResultNotification(translationService.translate("offline_db.delete_success"), "success");
      return true;
    } catch (error) {
      console.error("deleteOfflineDb failed:", error);
      this.removeNotification(loadingId);
      this.showResultNotification(translationService.translate("offline_db.delete_error"), "danger");
      return false;
    }
  }

  private static showLoadingNotification(message: string): string {
    return store.addNotification({
      message,
      type: "default",
      container: "bottom-right",
      animationIn: ["animated", "fadeIn"],
      animationOut: ["animated", "fadeOut"],
      dismiss: { duration: 0 }
    });
  }

  private static removeNotification(id: string): void {
    if (id) store.removeNotification(id);
  }

  private static showResultNotification(message: string, type: "success" | "danger" | "warning"): void {
    store.addNotification({
      message,
      type,
      container: "bottom-right",
      animationIn: ["animated", "fadeIn"],
      animationOut: ["animated", "fadeOut"],
      dismiss: { duration: 3000, pauseOnHover: true, showIcon: true }
    });
  }

  // ARITHMETIC

  public static increment(value, seed) {
    return this.toDecimal(undefined, value) + this.toDecimal(undefined, seed);
  }

  public static decrament(value, value2) {
    return this.toDecimal(undefined, value) - this.toDecimal(undefined, value2);
  }

  public static sum(value, value2) {
    return this.toDecimal(undefined, value) + this.toDecimal(undefined, value2);
  }

  public static subtract(value, value2) {
    return this.toDecimal(undefined, value) - this.toDecimal(undefined, value2);
  }

  public static divide(value, value2) {
    return this.toDecimal(undefined, value) / this.toDecimal(undefined, value2);
  }

  public static multiply(value, value2) {
    return this.toDecimal(undefined, value) * this.toDecimal(undefined, value2);
  }

  public static subArray(value, startingIndex: number, count: number) {
    if (!value) return null;

    if (Array.isArray(value) && value.every((item) => typeof item === "number")) {
      const inputVal: number[] = value;
      const retVal: number[] = [];

      for (let i = startingIndex; i < startingIndex + count; i++) {
        if (i >= 0 && i < inputVal.length) {
          retVal.push(inputVal[i]);
        }
      }

      return retVal;
    }
    if (typeof value === "string") {
      return this.subString(value, startingIndex, count).split("");
    }
    if (Array.isArray(value)) {
      const retVal: any[] = [];

      for (let i = startingIndex; i < startingIndex + count; i++) {
        if (i >= 0 && i < value.length) {
          retVal.push(value[i]);
        }
      }

      return retVal;
    }

    return value;
  }

  public static subString(value: string | null | undefined, startingIndex: number, count: number): any {
    if (value === null || value === undefined) return null;
    return value.substring(startingIndex, startingIndex + count);
  }

  // public static concatenate(
  //   arrayOrString1: string | any[] | null | undefined,
  //   arrayOrString2: string | any[] | null | undefined
  // ): any {
  //   const isArr1 = Array.isArray(arrayOrString1);
  //   const isArr2 = Array.isArray(arrayOrString2);

  //   if (isArr1 || isArr2) {
  //     const result: any[] = [];

  //     if (isArr1) result.push(...(arrayOrString1 as any[]));
  //     else if (arrayOrString1 != null) result.push(arrayOrString1);

  //     if (isArr2) result.push(...(arrayOrString2 as any[]));
  //     else if (arrayOrString2 != null) result.push(arrayOrString2);

  //     return result.map((x) => x?.toString?.() ?? "").join("");
  //   }

  //   const s1 = arrayOrString1?.toString() ?? "";
  //   const s2 = arrayOrString2?.toString() ?? "";
  //   return s1 + s2;
  // }

  public static async iyzicoInitializeCheckoutForm(
    screen: any,
    cllbck: any,
    userName: string,
    pricingPlanReferenceCode: string,
    phoneNumber: string,
    identityNumber: string,
    address: string,
    city: string,
    country: string,
    zipCode: string
  ) {
    const ad = {
      address1: address,
      address2: "",
      city,
      country,
      zipCode
    } as IIyzicoAddressDto;
    const u = {
      userName,
      pricingPlanReferenceCode,
      address: ad,
      phoneNumber,
      identityNumber
    } as IIyzicoCheckoutFormDto;
    await IyzicoService.CheckoutForm(u)
      .then((response) => {
        if (response && response.data && response.data.checkoutFormContent) {
          screen?.props.showIyzicoDrawer({ data: response.data }, cllbck, screen);
        } else {
          KuikaAppManager.hideSpinner(screen);
        }
      })
      .catch(() => {
        KuikaAppManager.hideSpinner(screen);
      });
  }

  public static generateLink(screenName?: string, parameters?: { [key: string]: any }) {
    let linkString = window.location.href;

    if (screenName) {
      let lastIndex = linkString.lastIndexOf("/");
      if (lastIndex !== -1) {
        linkString = linkString.substring(0, lastIndex);
        linkString += `/${screenName}`;
      }
    }

    if (Object.keys(parameters).length > 0) {
      linkString += "?";
    }

    let index: number = 0;
    for (const [key, value] of Object.entries(parameters)) {
      const escapedString: string = encodeURIComponent(String(value));
      linkString += `${key}=${escapedString}`;
      if (index < Object.keys(parameters).length - 1) {
        linkString += "&";
      }
      index += 1;
    }

    return linkString;
  }

  public static runUIVisionMacro(stringifiedMacro: string) {
    try {
      const json = JSON.parse(stringifiedMacro);

      const isExtensionLoaded = function () {
        const $root = document.documentElement;
        return !!$root && !!$root.getAttribute("data-kantu");
      };
      const openExternal = function (url) {
        const $el = document.createElement("a");
        $el.setAttribute("target", "_blank");
        $el.setAttribute("href", url);
        $el.style.position = "absolute";
        $el.style.top = "-9999px";
        $el.style.left = "-9999px";
        document.body.appendChild($el);
        $el.click();
        setTimeout(() => {
          $el.remove();
        }, 200);
      };
      const openWebsite = function () {
        openExternal("https://ui.vision/rpa/home/getrpa");
      };
      if (!isExtensionLoaded()) {
        if (confirm("UI.Vision RPA is not installed yet. Do you want to download it now?")) {
          return openWebsite();
        }
      } else {
        return window.dispatchEvent(
          new CustomEvent("kantuSaveAndRunMacro", {
            detail: {
              direct: 1,
              closeRpa: 1,
              json
            }
          })
        );
      }
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
    }
  }

  public static async copyToClipboard(value?: string) {
    try {
      await navigator.clipboard.writeText(value);
    } catch (e) {
      KMainFunctions.exceptionHandler(e);
    }
  }

  public static signinwithgoogle(screen: any): Promise<{}> {
    screen.props.googleLogin();
    localStorage.setItem("isGoogleLoginInProgress", "true");
    localStorage.setItem("isGoogleLoginAborted", "false");

    const previousUser = _.cloneDeep(window.userInfo ?? {});

    return new Promise((resolve, reject) => {
      const interval = setInterval(() => {
        if (localStorage.getItem("isGoogleLoginInProgress") === "false") {
          clearInterval(interval);
          if (localStorage.getItem("isGoogleLoginAborted") === "true") {
            localStorage.removeItem("isGoogleLoginInProgress");
            localStorage.removeItem("isGoogleLoginAborted");
            KuikaAppManager.hideSpinner(screen);
            reject();
          } else {
            resolve({});
          }

          if (previousUser && !_.isEqual(previousUser, window.userInfo)) {
            clearInterval(interval);
            localStorage.removeItem("isGoogleLoginInProgress");
            localStorage.removeItem("isGoogleLoginAborted");
            resolve({});
          }
        }
      }, 200);
    });
  }

  public static getPublicIpAddress(): string {
    try {
      // Send a cross-origin request to get the public IP address
      const request = new XMLHttpRequest();
      request.open("GET", "https://api.ipify.org?format=json", false);
      request.send(null);
      if (request.status === 200) {
        const response = JSON.parse(request.responseText);
        return response.ip;
      }
      return "";
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return "";
    }
  }

  public static sendVerificationCode(screen: any) {
    UserService.SendVerificationCode({
      email: USER,
      dontSendEmail: false,
      language: ""
    })
      .then(() => {})
      .catch((e) => {
        KMainFunctions.exceptionHandler(e);
      });

    return "Mail send";
  }

  public static async generateOTP(userName: string) {
    const TOTP = (await import("totp-generator")).TOTP;

    const secret = this.convertToOtpSecret(userName.toLowerCase());

    let algorithm: "SHA-1" | "SHA-256" | "SHA-512" = "SHA-1";

    if (OTP_ALGORITHM === "SHA256") algorithm = "SHA-256";
    else if (OTP_ALGORITHM === "SHA512") algorithm = "SHA-512";

    const generatedOTP = await TOTP.generate(secret, {
      period: OTP_PERIOD,
      digits: OTP_DIGITS,
      algorithm
    });

    return generatedOTP.otp;
  }

  public static generateAuthenticatorAppUri(userName?: string) {
    try {
      const language = localStorage.getItem("ml");
      if (!userName) {
        let message = "";
        switch (language) {
          case "en_US":
            message = "Unable to generate authenticator app (OTP) URI without username.";
            break;

          case "fr_FR":
            message = "Impossible de générer l'URI de l'application d'authentification (OTP) sans nom d'utilisateur.";
            break;

          case "tr_TR":
            message = "Kullanıcı adı olmadan Kimlik Doğrulayıcı (OTP) ugulama URI'yı oluşturulamaz.";
            break;
        }
        throw new Error(message);
      }

      if (!OTP_SECRET_KEY) {
        let message = "Authenticator (OTP) application settings are missing. Please contact your Administrator";
        switch (language) {
          case "en_US":
            message = "Authenticator (OTP) application settings are missing. Please contact your Administrator";
            break;

          case "fr_FR":
            message =
              "Les paramètres de l'application Authentificateur (OTP) sont manquants. Veuillez contacter votre administrateur";
            break;

          case "tr_TR":
            message = "Kimlik Doğrulayıcı (OTP) uygulama ayarları eksik. Lütfen Yöneticinizle iletişime geçin";
            break;
        }
        throw new Error(message);
      }
      const usrName = userName?.toString()?.toLowerCase() ?? "";
      const domainName = this.removeSpecialCharacter(window.kuika?.info?.workspace ?? "");
      const secret = this.convertToOtpSecret(usrName);
      const url = `otpauth://totp/${domainName}:${usrName}?secret=${secret}&issuer=${domainName}&algorithm=${OTP_ALGORITHM}&digits=${OTP_DIGITS}&period=${OTP_PERIOD}`;
      return url;
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return "";
    }
  }

  public static convertToOtpSecret(userName: string) {
    const secretKey: string = `${userName.toLowerCase()}${OTP_SECRET_KEY}KUIKAMOBILEKEYKUIKAMOBILEKEY2345KUIKAMOBILEKEYKUIKAMOBILEKEY2345`;
    const secret = this.subString(this.ignoreNonAllowedCharacters4Base32Secret(secretKey), 0, 64);

    return secret ?? "";
  }

  public static async changeTwoFactorAuthenticationType(authenticationType) {
    try {
      await UserService.ChangeTwoFactorAuthenticationType({
        authenticationType
      });
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
    }
  }

  public static removeSpecialCharacter(value: string): string {
    return value.replace(/[^A-Za-z0-9 ]/g, "");
  }

  public static ignoreNonAllowedCharacters4Base32Secret(value: string) {
    return value.replace(/[^A-Za-z2-7 ]/g, "");
  }

  public static importTableConfigs = (screen, tableName, configJSON) => {
    const screenTable = Object.keys(screen).filter((v) => v.includes(tableName));
    const refTable = screenTable.find((v) => v.includes("kuikaTableRef") || v.includes("kuikaPivotTableRef"));
    if (
      screen[refTable] != undefined &&
      screen[refTable] != null &&
      screen[refTable].current != undefined &&
      screen[refTable].current != null &&
      screen[refTable].current.setTableConfigJson != undefined &&
      configJSON != undefined &&
      configJSON != null &&
      configJSON != ""
    ) {
      screen[refTable].current.setTableConfigJson(configJSON);
    }
  };

  public static exportTableConfigs = (screen, tableName) => {
    const screenTable = Object.keys(screen).filter((v) => v.includes(tableName));
    const refTable = screenTable.find((v) => v.includes("kuikaTableRef") || v.includes("kuikaPivotTableRef"));
    if (
      screen[refTable] != undefined &&
      screen[refTable] != null &&
      screen[refTable].current != undefined &&
      screen[refTable].current != null &&
      screen[refTable].current.getTableConfigJson != undefined
    ) {
      return screen[refTable].current.getTableConfigJson();
    }
    return "";
  };

  public static clearTableFilteringConfigs = (screen, tableName) => {
    const screenTable = Object.keys(screen).filter((v) => v.includes(tableName));
    const refTable = screenTable.find((v) => v.includes("kuikaTableRef"));
    if (
      screen[refTable] != undefined &&
      screen[refTable] != null &&
      screen[refTable].current != undefined &&
      screen[refTable].current != null &&
      screen[refTable].current.clearFilterConfigs != undefined
    ) {
      screen[refTable].current.clearFilterConfigs();
    }
  };

  public static resetTableConfigs = (screen, tableName) => {
    const screenTable = Object.keys(screen).filter((v) => v.includes(tableName));
    const refTable = screenTable.find((v) => v.includes("kuikaTableRef") || v.includes("kuikaPivotTableRef"));
    if (
      screen[refTable] != undefined &&
      screen[refTable] != null &&
      screen[refTable].current != undefined &&
      screen[refTable].current != null &&
      screen[refTable].current.resetTableConfigs != undefined
    ) {
      screen[refTable].current.resetTableConfigs();
    }
  };

  public static searchTable = (screen, tableName, searchText) => {
    const screenTable = Object.keys(screen).filter((v) => v.includes(tableName));
    const refTable = screenTable.find((v) => v.includes("kuikaTableRef") || v.includes("kuikaPivotTableRef"));
    if (
      screen[refTable] != undefined &&
      screen[refTable] != null &&
      screen[refTable].current != undefined &&
      screen[refTable].current != null &&
      screen[refTable].current.searchTable != undefined
    ) {
      screen[refTable].current.searchTable(searchText);
    }
  };

  public static exportTable = (screen, tableName) => {
    const screenTable = Object.keys(screen).filter((v) => v.includes(tableName));
    const refTable = screenTable.find((v) => v.includes("kuikaTableRef") || v.includes("kuikaPivotTableRef"));
    if (
      screen[refTable] != undefined &&
      screen[refTable] != null &&
      screen[refTable].current != undefined &&
      screen[refTable].current != null &&
      screen[refTable].current.exportTable != undefined
    ) {
      screen[refTable].current.exportTable();
    }
  };

  public static exportNodeTree = (screen, nodeTreeName) => {
    const screenKeys = Object.keys(screen).filter((v) => v.includes(nodeTreeName));
    const refKey = screenKeys.find((v) => v.includes("kuikaNodeTreeRef"));
    if (
      refKey &&
      screen[refKey] != undefined &&
      screen[refKey] != null &&
      screen[refKey].current != undefined &&
      screen[refKey].current != null &&
      screen[refKey].current.exportNodeTree != undefined
    ) {
      screen[refKey].current.exportNodeTree();
    }
  };

  public static readNFC = () => {
    KMainFunctions.displayWarningNotification("Action ReadNFC is not supported on web.");
    return null;
  };

  public static isInList(value1: unknown, value2: unknown): boolean {
    if (value1 === null || value1 === undefined || value2 === null || value2 === undefined) {
      return false;
    }
    if (Array.isArray(value2)) {
      const date1 = new Date(value1.toString());
      const isNotNaN = !isNaN(date1.getTime());

      for (let i = 0; i < value2.length; i++) {
        const date2 = new Date(value2[i].toString());
        if (isNotNaN && !isNaN(date2.getTime()) && date1.getTime() === date2.getTime()) {
          return true;
        }

        if (value2[i] === value1) {
          return true;
        }
      }
      return false;
    }
    return false;
  }

  public static async downloadFileFromServer(fileid, filename) {
    ServerFilesService.DownloadFile(fileid, filename);
    return "";
  }

  public static async downloadFileFromBucket(keyName, bucketName, fileName, encrypt) {
    ServerFilesService.DownloadFileFromBucket(keyName, bucketName, fileName, encrypt);
    return "";
  }

  public static async deleteFileFromServer(fileid) {
    return ServerFilesService.DeleteFile(fileid);
  }

  public static isDocumentReady() {
    switch (document.readyState) {
      case "complete":
        return true;
      default:
        return false;
    }
  }

  public static mqttpublish = (client, topic, message, qos, retain = false) => {
    if (!client || !client.connected) {
      console.error("MQTT client is not connected");
      return;
    }

    if (qos === undefined || qos === null) {
      qos = 0;
    }

    qos = Number(qos);

    client.publish(topic, message, { qos, retain }, (error) => {
      if (error) {
        console.error("MQTT publish failed:", error);
      }
    });
  };

  public static mqttsubscribe = async (client, subscribeAction, topic) => {
    return new Promise((resolve, reject) => {
      const mqttTopic = topic;

      if (!client._resubscribeTopics || !client._resubscribeTopics[topic]) {
        client.subscribe(topic, { nl: false }, (err) => {
          if (err) {
            resolve({ isSuccess: false });
          }

          client.on("message", (topic, message) => {
            if (mqttTopic === topic) {
              subscribeAction(message.toString());
            }
          });

          resolve({ isSuccess: true });
        });
      } else {
        resolve({ isSuccess: true });
      }
    });
  };

  public static getMqttClientId(clientName, screenName) {
    var mqttClientId = this.readFromLocalStorage(`${clientName}_${screenName}_MQTT_CLIENT_ID`);
    if (mqttClientId === undefined || mqttClientId === null) {
      mqttClientId = Guid.create().toString();
      this.writeToLocalStorage(`${clientName}_${screenName}_MQTT_CLIENT_ID`, mqttClientId);
    }
    return mqttClientId;
  }

  public static async openImportMappedExcelModal(
    screen: any,
    datasourceId: string,
    tableName: string,
    primaryKey: string,
    mappedColumnsJson: string,
    parametersJson?: string,
    ...paramValues: any[]
  ) {
    const mappedColumns: IImportMappedExcelColumnMapDefinition[] = JSON.parse(mappedColumnsJson);
    const parameterDefinitions: IImportMappedExcelParameter[] = parametersJson ? JSON.parse(parametersJson) : [];

    // Combine parameter metadata with values
    const parameters = parameterDefinitions.map((def, index) => ({
      ...def,
      value: paramValues[index]
    }));

    screen?.props?.showImportMappedExcelModal(datasourceId, tableName, primaryKey, mappedColumns, parameters);

    return new Promise<void>((resolve, reject) => {
      const interval = setInterval(() => {
        if (screen.props.isImportMappedExcelModalVisible === false) {
          clearInterval(interval);
          resolve();
        }
      }, 100);
    });
  }

  public static async VerifyRecaptchaToken(token: string) {
    if (!token) {
      this.notify(null, "Recaptcha token is missing.", "danger", "bottom-right", null, null, null, null);
      return false;
    }

    return true;
  }

  public static async confirmation(
    confirmationMessage: string,
    confirmationFontFamily: string = "Poppins",
    _confirmationHeader: string,
    _icon: "warning" | "trash" | "info" | "question" | "confirmation" | "notification",
    _iconBackgroundColor: string
  ): Promise<boolean> {
    const confirmationHeader = _confirmationHeader || null;
    const icon = _icon || null;
    const iconBackgroundColor = _iconBackgroundColor || "#246dff";

    const warningIcon = `<img src="common/alert-triangle.svg" alt="warning" style="width: 40px; height: 40px;" />`;
    const trashIcon = `<img src="common/trash.svg" alt="trash" style="width: 40px; height: 40px;" />`;
    const infoIcon = `<img src="common/info-circle.svg" alt="info" style="width: 40px; height: 40px;" />`;
    const questionIcon = `<img src="common/question-mark.svg" alt="question" style="width: 40px; height: 40px;" />`;
    const confirmationIcon = `<img src="common/check.svg" alt="confirmation" style="width: 40px; height: 40px;" />`;
    const notificationIcon = `<img src="common/bell.svg" alt="notification" style="width: 40px; height: 40px;" />`;

    const iconMap = {
      warning: warningIcon,
      trash: trashIcon,
      info: infoIcon,
      question: questionIcon,
      confirmation: confirmationIcon,
      notification: notificationIcon
    };

    const modalOptions: any = {
      title: confirmationMessage,
      icon: icon ? iconMap[icon] : undefined,
      showCancelButton: true,
      confirmButtonText: translationService.translate("common.confirm", localStorage.getItem("ml") as ELanguage),
      cancelButtonText: translationService.translate("common.cancel", localStorage.getItem("ml") as ELanguage),
      customClass: {
        title: `swal2-font-${confirmationFontFamily.toLowerCase().replaceAll(" ", "-")}`,
        confirmButton: `swal2-font-${confirmationFontFamily.toLowerCase().replaceAll(" ", "-")}`,
        cancelButton: `swal2-font-${confirmationFontFamily.toLowerCase().replaceAll(" ", "-")}`,
        container: `swal2-font-${confirmationFontFamily.toLowerCase().replaceAll(" ", "-")}`
      }
    };

    if (confirmationHeader && confirmationHeader !== "") {
      modalOptions.html = `
        <div style="margin-bottom: 16px;">
          <h3 style="font-size: 28px; margin: 0 0 24px 0;">${confirmationHeader}</h3>
          <p>${confirmationMessage}</p>
        </div>`;
      modalOptions.header = `<div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 24px; width: 100%; border-bottom: 1px solid #DCDFE4; padding-bottom: 12px;">
              <span style="font-size: 12px; font-weight: 700; text-transform: uppercase; margin: 0 12px 0 12px;">${confirmationHeader}</span>
              <div id="swal-close-button" style="cursor: pointer; width: 24px; height: 24px; display: flex; align-items: center; justify-content: center; margin-right: 12px;">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>
          </div>`;
      delete modalOptions.title;

      modalOptions.didOpen = () => {
        const closeButton = document.getElementById("swal-close-button");
        if (closeButton) {
          closeButton.addEventListener("click", () => Swal.close());
        }
      };
    }

    if (icon) {
      modalOptions.html = modalOptions.html || `<p>${confirmationMessage}</p>`;
      const backgroundColor = iconBackgroundColor || "#246dff";
      const backgroundColor2 = this.lightenColor(backgroundColor, 95);
      const iconContent = iconMap[icon] || icon;
      const gradient = `linear-gradient(37deg, ${backgroundColor} -4.04%, ${backgroundColor2} 68.6%)`;
      modalOptions.html = `
        <div style="display: flex; flex-direction: column; align-items: center; margin-bottom: 16px; width: 400px; border-bottom: 1px solid #DCDFE4; padding-bottom: 12px;">
        ${modalOptions.header || ""}
        <div style="background: ${gradient}; width: 80px; height: 80px; border-radius: 16px; display: flex; align-items: center; justify-content: center; margin-bottom: 24px; box-shadow: 0px 5px 15px 0px rgba(0, 0, 0, 0.12); margin-top: ${
          confirmationHeader ? "0" : "16px"
        };">
            <span>${iconContent}</span>
          </div>
          ${
            confirmationHeader
              ? `<h3 style="font-size: 16px; font-weight: 600; margin: 0 0 16px 0;">${confirmationHeader}</h3>`
              : ""
          }
          <p style="margin: 0; color: #41546E; font-size: 14px; font-weight: 400; padding: 0 12px; marginBottom: ${
            confirmationHeader ? "0" : "16px"
          }">${confirmationMessage}</p>
        </div>`;
      delete modalOptions.title;
      delete modalOptions.icon;
    } else {
      modalOptions.html = `
        <div style="display: flex; flex-direction: column; align-items: center; margin-bottom: 16px; width: 400px; border-bottom: 1px solid #DCDFE4; padding-bottom: 12px;">
        ${modalOptions.header || ""}
          ${
            confirmationHeader
              ? `<h3 style="font-size: 16px; font-weight: 600; margin: 0 0 16px 0;">${confirmationHeader}</h3>`
              : ""
          }
          <p style="margin: 0; color: #41546E; font-size: 14px; font-weight: 400; padding: ${
            !confirmationHeader ? "12px" : "0 12px"
          }; marginBottom: ${confirmationHeader ? "0" : "16px"}">${confirmationMessage}</p>
        </div>`;
      delete modalOptions.title;
      delete modalOptions.icon;
    }

    return (await Swal.fire(modalOptions)).isConfirmed;
  }

  private static lightenColor(hex: string, percent: number): string {
    let r = parseInt(hex.slice(1, 3), 16);
    let g = parseInt(hex.slice(3, 5), 16);
    let b = parseInt(hex.slice(5, 7), 16);

    if (hex.length === 4) {
      r = parseInt(hex[1] + hex[1], 16);
      g = parseInt(hex[2] + hex[2], 16);
      b = parseInt(hex[3] + hex[3], 16);
    }

    r = Math.min(255, Math.round(r + (255 - r) * (percent / 120)));
    g = Math.min(255, Math.round(g + (255 - g) * (percent / 120)));
    b = Math.min(255, Math.round(b + (255 - b) * (percent / 120)));

    return `#${r.toString(16).padStart(2, "0")}${g.toString(16).padStart(2, "0")}${b.toString(16).padStart(2, "0")}`;
  }

  public static getEntityValueFromDynamicForm(screen: any, diId: number) {
    if (!screen) return null;
    if (typeof screen !== "object") return null;

    const dynamicFormKey = Object.keys(screen).find((key) => key.endsWith(`${diId}_value_kuikaDynamicFormRef`));

    if (dynamicFormKey && screen[dynamicFormKey] && screen[dynamicFormKey].current) {
      return screen[dynamicFormKey].current.generateEntityValue();
    }
    return null;
  }

  public static clearDynamicForm(screen: any, diId: number) {
    if (!screen) return null;
    if (typeof screen !== "object") return null;

    const dynamicFormKey = Object.keys(screen).find((key) => key.endsWith(`${diId}_value_kuikaDynamicFormRef`));

    if (dynamicFormKey && screen[dynamicFormKey] && screen[dynamicFormKey].current) {
      screen[dynamicFormKey].current.clearForm();
    }

    return null;
  }

  public static setEntityAttributeValueInDynamicForm(screen: any, diId: number, attributeId: string, value: any) {
    if (!screen) return null;
    if (typeof screen !== "object") return null;

    const dynamicFormKey = Object.keys(screen).find((key) => key.endsWith(`${diId}_value_kuikaDynamicFormRef`));

    if (dynamicFormKey && screen[dynamicFormKey] && screen[dynamicFormKey].current) {
      screen[dynamicFormKey].current.setEntityAttributeValue(attributeId, value);
    }

    return null;
  }

  public static getEntityAttributeValueInDynamicForm(screen: any, diId: number, attributeId: string) {
    if (!screen) return null;
    if (typeof screen !== "object") return null;

    const dynamicFormKey = Object.keys(screen).find((key) => key.endsWith(`${diId}_value_kuikaDynamicFormRef`));

    if (dynamicFormKey && screen[dynamicFormKey] && screen[dynamicFormKey].current) {
      return screen[dynamicFormKey].current.getEntityAttributeValue(attributeId);
    }

    return null;
  }

  public static getIsDynamicFormValid(screen: any, diId: number): boolean {
    if (!screen) return false;
    if (typeof screen !== "object") return false;

    const dynamicFormKey = Object.keys(screen).find((key) => key.endsWith(`${diId}_value_kuikaDynamicFormRef`));

    if (dynamicFormKey && screen[dynamicFormKey] && screen[dynamicFormKey].current) {
      return screen[dynamicFormKey].current.getIsFormValid();
    }

    return false;
  }

  public static getWfPageComponent(screen: any, screenName: string, callback?: any, drawerId?: string) {
    const closeCallback =
      callback ||
      (() => {
        if (drawerId && screen.setState) {
          screen.setState({ [`NavVisible${drawerId}`]: false }, () => {
            if (screen.callCallbackFunction) {
              screen.callCallbackFunction(Number.parseInt(drawerId));
            }
          });
        }
      });
    const props = {
      onClose: closeCallback,
      screenInputs: window.kuika.navigationScreenInputs,
      navigator: screen.props?.navigator,
      form: screen.props?.form,
      context: screen.props?.context
    };
    
  }

  public static addToBag(scope: any, key: string, bagItem: any): boolean {
    ReactSystemFunctions.bags[key] = bagItem;
    return true;
  }

  public static removeFromBag(scope: any, key: string): boolean {
    if (ReactSystemFunctions.bags[key]) {
      delete ReactSystemFunctions.bags[key];
      return true;
    }
    return false;
  }

  public static clearBag(scope: any): boolean {
    ReactSystemFunctions.bags = {};
    return true;
  }

  public static getFromBag(scope: any, key: string): any {
    return ReactSystemFunctions.bags[key] || null;
  }

  public static bagHasKey(scope: any, key: string): boolean {
    return ReactSystemFunctions.bags.hasOwnProperty(key);
  }

  public static toggleLayout(screen: any, position: string): boolean {
    if (!screen || !position) {
      return false;
    }

    const validPositions = ["left", "right", "top", "bottom"];
    if (!validPositions.includes(position.toLowerCase())) {
      return false;
    }

    const pos = position.toLowerCase();
    let targetElementId: string;
    let layoutDiId: number;

    switch (pos) {
      case "left":
        targetElementId = "layout_left";
        layoutDiId = -12;
        break;
      case "right":
        targetElementId = "layout_right";
        layoutDiId = -13;
        break;
      case "top":
        targetElementId = "layout_header";
        layoutDiId = -10;
        break;
      case "bottom":
        targetElementId = "layout_footer";
        layoutDiId = -11;
        break;
      default:
        return false;
    }

    try {
      const matchingElements = document.querySelectorAll(`[id*="${targetElementId}"]`);
      if (!matchingElements?.length) {
        return false;
      }
      const lastIndex = matchingElements.length - 1;
      const targetElement = matchingElements[lastIndex] as HTMLElement;

      const currentVisibility = window.getComputedStyle(targetElement).visibility;
      const isCurrentlyVisible = currentVisibility !== "hidden";

      if (isCurrentlyVisible) {
        targetElement.style.display = "none";
        targetElement.style.width = "0px";
        targetElement.style.height = "0px";
        targetElement.style.overflow = "hidden";
        targetElement.style.visibility = "hidden";
      } else {
        targetElement.style.display = "";
        targetElement.style.width = "";
        targetElement.style.height = "";
        targetElement.style.overflow = "";
        targetElement.style.visibility = "visible";
      }

      return true;
    } catch (error) {
      console.error("Error in toggleLayout:", error);
      return false;
    }
  }

  public static getAppDateFormat(): string | null {
    return "";
  }

  public static getAppTimeFormat(): string | null {
    return "";
  }

  // Cache Functions
  public static async pushToCache(scope: any, key: string, cacheItem: any): Promise<any> {
    try {
      const itemString = JSON.stringify(cacheItem);
      const request = {
        key,
        value: itemString,
        cacheRegion: 12
      };
      const response = await CacheService.PushToCache(request);
      return response.data;
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return null;
    }
  }

  public static async fetchFromCache(scope: any, key: string): Promise<any> {
    try {
      const response = await CacheService.FetchFromCache(key, 12);
      if (response.data?.value) {
        return JSON.parse(response.data.value);
      }
      return null;
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return null;
    }
  }

  public static async fetchFromCacheToList(scope: any, key: string): Promise<any[]> {
    try {
      const response = await CacheService.FetchFromCache(key, 12);
      if (response.data?.value) {
        const result = JSON.parse(response.data.value);
        if (Array.isArray(result)) {
          return result;
        }
      }
      return [];
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return [];
    }
  }

  public static async removeFromCache(scope: any, key: string): Promise<any> {
    try {
      const response = await CacheService.RemoveFromCache(key, 12);
      return response.data;
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return null;
    }
  }

  public static async checkKeyExistence(scope: any, key: string): Promise<{ isExist: boolean }> {
    try {
      const response = await CacheService.CheckKeyExistence(key, 12);
      return response.data;
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return null;
    }
  }

  

  

  // ── Document Management System Actions ───────────────────────────

  /**
   * GET /v1/api/documentmanagement/tree — Returns a flat node list for the Directory element.
   * Folders are always returned in full; documents are paginated.
   * The X-Total-Documents response header carries the total count for the Pagination element.
   * @param folderId    Optional: returns only the subtree of this folder
   * @param page        Page number (default: 1)
   * @param pageSize    Number of documents per page (default: 50, max: 200)
   * @param searchQuery Search filter by document name (optional)
   */
  public static async getDocumentTree(
    screen: any,
    folderId?: string,
    documentId?: string,
    page?: number,
    pageSize?: number,
    searchQuery?: string,
    hideEmptyFolders?: boolean,
    createdBy?: string,
    documentType?: string,
    draftFilter?: string,
    language?: string,
    showVersions?: boolean,
    showLanguages?: boolean,
    showDrafts?: boolean,
    sortBy?: string,
    sortDirection?: string,
    tagFilter?: string,
    mimeTypeFilter?: string,
    dateFrom?: string,
    dateTo?: string,
    checkedOutFilter?: string,
    ownerFilter?: string,
    maxResults?: number
  ): Promise<any> {
    try {
      const params = new URLSearchParams();
      if (folderId && folderId !== "00000000-0000-0000-0000-000000000000") params.set("folderId", folderId);
      if (documentId && documentId !== "00000000-0000-0000-0000-000000000000") params.set("documentId", documentId);
      if (page) params.set("page", String(page));
      if (pageSize) params.set("pageSize", String(pageSize));
      if (searchQuery) params.set("searchQuery", searchQuery);
      if (hideEmptyFolders) params.set("hideEmptyFolders", "true");
      if (createdBy) params.set("createdBy", createdBy);
      if (documentType) params.set("documentType", documentType);
      if (draftFilter) params.set("draftFilter", draftFilter);
      if (showVersions) params.set("showVersions", "true");
      if (showLanguages) params.set("showLanguages", "true");
      if (showDrafts) params.set("showDrafts", "true");
      if (sortBy) params.set("sortBy", sortBy);
      if (sortDirection) params.set("sortDirection", sortDirection);
      if (tagFilter) params.set("tagFilter", tagFilter);
      if (mimeTypeFilter) params.set("mimeTypeFilter", mimeTypeFilter);
      if (dateFrom) params.set("dateFrom", dateFrom);
      if (dateTo) params.set("dateTo", dateTo);
      if (checkedOutFilter) params.set("checkedOutFilter", checkedOutFilter);
      if (ownerFilter) params.set("ownerFilter", ownerFilter);
      if (maxResults) params.set("maxResults", String(maxResults));
      const qs = params.toString();
      const url = qs ? `documentmanagement/tree?${qs}` : "documentmanagement/tree";
      const result = await KuikaAppManager.ApiRequest(screen, url, undefined, "get");
      return result;
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return { data: [] };
    }
  }

  /**
   * GET /v1/api/documentmanagement/archived-tree — Returns a flat node list of archived documents with their folders.
   * Same shape as getDocumentTree — use with the Directory element.
   * hideEmptyFolders defaults to true (only folders containing archived documents are returned).
   * @param folderId         Optional: returns only the subtree of this folder
   * @param page             Page number (default: 1)
   * @param pageSize         Number of documents per page (default: 50, max: 200)
   * @param searchQuery      Search filter by document name (optional)
   * @param hideEmptyFolders Omit folders with no archived documents (default: true)
   */
  public static async getArchivedDocumentTree(
    screen: any,
    folderId?: string,
    page?: number,
    pageSize?: number,
    searchQuery?: string,
    hideEmptyFolders?: boolean,
    maxResults?: number
  ): Promise<any> {
    try {
      const params = new URLSearchParams();
      if (folderId && folderId !== "00000000-0000-0000-0000-000000000000") params.set("folderId", folderId);
      if (page) params.set("page", String(page));
      if (pageSize) params.set("pageSize", String(pageSize));
      if (searchQuery) params.set("searchQuery", searchQuery);
      // hideEmptyFolders defaults to true on the server side; only send when explicitly false
      if (hideEmptyFolders === false) params.set("hideEmptyFolders", "false");
      if (maxResults) params.set("maxResults", String(maxResults));
      const qs = params.toString();
      const url = qs ? `documentmanagement/archived-tree?${qs}` : "documentmanagement/archived-tree";
      const result = await KuikaAppManager.ApiRequest(screen, url, undefined, "get");
      return result;
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return { data: [] };
    }
  }

  /**
   * GET /v1/api/documentmanagement/folders/tree — Returns a flat folder-only node list.
   * No documents are included. Each node: { id, name, parentId, nodeType: "folder" }.
   * Suitable for folder-picker UIs (e.g. a move-to-folder dialog).
   * @param folderId       Optional: returns only the subtree of this folder
   * @param folderPage     Folder page number (default: 1)
   * @param folderPageSize Number of folders per page (default: 200, max: 1000)
   */
  public static async getDocumentFolderTree(
    screen: any,
    folderId?: string,
    folderPage?: number,
    folderPageSize?: number,
    searchQuery?: string,
    hideEmptyFolders?: boolean,
    maxResults?: number
  ): Promise<any> {
    try {
      const params = new URLSearchParams();
      if (folderId && folderId !== "00000000-0000-0000-0000-000000000000") params.set("folderId", folderId);
      if (folderPage) params.set("folderPage", String(folderPage));
      if (folderPageSize) params.set("folderPageSize", String(folderPageSize));
      if (searchQuery) params.set("searchQuery", searchQuery);
      if (hideEmptyFolders) params.set("hideEmptyFolders", "true");
      if (maxResults) params.set("maxResults", String(maxResults));
      const qs = params.toString();
      const url = qs ? `documentmanagement/folders/tree?${qs}` : "documentmanagement/folders/tree";
      const result = await KuikaAppManager.ApiRequest(screen, url, undefined, "get");
      return result;
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return { data: [] };
    }
  }

  /**
   * GET /v1/api/documentmanagement/folders/{folderId}/documents
   * Returns the paginated list of documents directly inside the given folder (non-recursive).
   * Each node: { id, name, parentId, mimeType, nodeType: "document" }.
   * The X-Total-Documents response header carries the total count for the Pagination element.
   * @param folderId    Required: the folder whose documents to list
   * @param page        Page number (default: 1)
   * @param pageSize    Documents per page (default: 50, max: 200)
   * @param searchQuery Filter by document name (optional)
   */
  public static async getFolderDocuments(
    screen: any,
    folderId: string,
    page?: number,
    pageSize?: number,
    searchQuery?: string,
    draftFilter?: string,
    language?: string,
    maxResults?: number
  ): Promise<any> {
    try {
      const params = new URLSearchParams();
      if (page) params.set("page", String(page));
      if (pageSize) params.set("pageSize", String(pageSize));
      if (searchQuery) params.set("searchQuery", searchQuery);
      if (draftFilter) params.set("draftFilter", draftFilter);
      if (maxResults) params.set("maxResults", String(maxResults));
      const qs = params.toString();
      const base = `documentmanagement/folders/${folderId}/documents`;
      const url = qs ? `${base}?${qs}` : base;
      const result = await KuikaAppManager.ApiRequest(screen, url, undefined, "get");
      return result;
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return { data: [] };
    }
  }

  /**
   * DELETE /v1/api/documentmanagement/{documentId}/share/{shareId}
   * Revokes (invalidates) a specific share link. Use shareId from getDocumentShares.
   * Requires manage permission on the document.
   * @param documentId Required: document GUID
   * @param shareId    Required: share link GUID to revoke
   */
  public static async revokeShareLink(screen: any, documentId: string, shareId?: string): Promise<boolean> {
    try {
      const params = new URLSearchParams();
      const qs = params.toString();
      await KuikaAppManager.ApiRequest(
        screen,
        `documentmanagement/${documentId}/share/${shareId}${qs ? `?${qs}` : ""}`,
        undefined,
        "delete"
      );
      return true;
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return false;
    }
  }

  /**
   * GET /v1/api/documentmanagement/stats — Returns aggregate storage statistics.
   * Result: { totalDocuments, archivedDocuments, totalFolders, totalStorageBytes, documentsByMimeType }
   * @param folderId Optional: limit stats to this folder
   * @param includeSubfolders Optional (default true): when false, only the folder itself is counted (no subtree)
   */
  public static async getStorageStats(screen: any, folderId?: string, includeSubfolders?: boolean): Promise<any> {
    try {
      const params = new URLSearchParams();
      if (folderId) params.set("folderId", folderId);
      if (includeSubfolders !== undefined) params.set("includeSubfolders", String(includeSubfolders));
      const qs = params.toString();
      const url = `documentmanagement/stats${qs ? `?${qs}` : ""}`;
      const result = await KuikaAppManager.ApiRequest(screen, url, undefined, "get");
      return result;
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return { data: null };
    }
  }

  /**
   * GET /v1/api/documentmanagement/folders/{folderId}/permissions
   * Lists permission grants on a folder (principalType, principalId, permissionLevel, expiresAt).
   * Requires manage permission on the folder.
   * @param folderId Required: folder GUID
   * @param page     Page number (default: 1)
   * @param pageSize Items per page (default: 100)
   */
  public static async getFolderPermissions(
    screen: any,
    folderId: string,
    page?: number,
    pageSize?: number,
    maxResults?: number
  ): Promise<any> {
    try {
      const params = new URLSearchParams();
      if (page) params.set("page", String(page));
      if (pageSize) params.set("pageSize", String(pageSize));
      if (maxResults) params.set("maxResults", String(maxResults));
      const qs = params.toString();
      const base = `documentmanagement/folders/${folderId}/permissions`;
      const result = await KuikaAppManager.ApiRequest(screen, qs ? `${base}?${qs}` : base, undefined, "get");
      return result;
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return { data: [] };
    }
  }

  /**
   * GET /v1/api/documentmanagement/{documentId}/share
   * Lists active (non-expired) share links for a document.
   * Fields: id, permissionLevel, expiresAt, maxUseCount, useCount, createdAt.
   * ShareToken is intentionally excluded. Requires manage permission.
   * @param documentId Required: document GUID
   * @param page       Page number (default: 1)
   * @param pageSize   Items per page (default: 50)
   */
  public static async getDocumentShares(
    screen: any,
    documentId: string,
    page?: number,
    pageSize?: number,
    maxResults?: number
  ): Promise<any> {
    try {
      const params = new URLSearchParams();
      if (page) params.set("page", String(page));
      if (pageSize) params.set("pageSize", String(pageSize));
      if (maxResults) params.set("maxResults", String(maxResults));
      const qs = params.toString();
      const base = `documentmanagement/${documentId}/share`;
      const result = await KuikaAppManager.ApiRequest(screen, qs ? `${base}?${qs}` : base, undefined, "get");
      return result;
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return { data: [] };
    }
  }

  /**
   * GET /v1/api/documentmanagement/mine
   * Returns non-archived documents uploaded by the current user, newest first.
   * The X-Total-Documents response header carries the total count.
   * @param page          Page number (default: 1)
   * @param pageSize      Documents per page (default: 50, max: 200)
   * @param includeShared When true, also returns documents shared with the user (default: false)
   */
  public static async getMyDocuments(
    screen: any,
    page?: number,
    pageSize?: number,
    includeShared?: boolean,
    sortBy?: string,
    draftFilter?: string,
    language?: string,
    maxResults?: number
  ): Promise<any> {
    try {
      const params = new URLSearchParams();
      if (page) params.set("page", String(page));
      if (pageSize) params.set("pageSize", String(pageSize));
      if (includeShared !== undefined) params.set("includeShared", String(includeShared));
      if (sortBy) params.set("sortBy", sortBy);
      if (draftFilter) params.set("draftFilter", draftFilter);
      if (maxResults) params.set("maxResults", String(maxResults));
      const qs = params.toString();
      const result = await KuikaAppManager.ApiRequest(
        screen,
        qs ? `documentmanagement/mine?${qs}` : "documentmanagement/mine",
        undefined,
        "get"
      );
      return result;
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return { data: [] };
    }
  }

  /**
   * GET /v1/api/documentmanagement/folders/{folderId}/subfolders
   * Returns direct child subfolders (one level only, not recursive).
   * Each node: { id, name, parentId, nodeType: "folder" }.
   * The X-Total-Folders response header carries the total count.
   * @param folderId Required: parent folder GUID
   * @param page     Page number (default: 1)
   * @param pageSize Items per page (default: 200)
   */
  public static async getFolderSubfolders(
    screen: any,
    folderId: string,
    page?: number,
    pageSize?: number,
    maxResults?: number
  ): Promise<any> {
    try {
      const params = new URLSearchParams();
      if (page) params.set("page", String(page));
      if (pageSize) params.set("pageSize", String(pageSize));
      if (maxResults) params.set("maxResults", String(maxResults));
      const qs = params.toString();
      const base = `documentmanagement/folders/${folderId}/subfolders`;
      const result = await KuikaAppManager.ApiRequest(screen, qs ? `${base}?${qs}` : base, undefined, "get");
      return result;
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return { data: [] };
    }
  }

  /**
   * GET /v1/api/documentmanagement/{documentId} — Returns metadata for a single document.
   * Fields: id, documentName, mimeType, currentVersion, isArchived, folderId, downloadUrl.
   * @param documentId Required: document GUID
   */
  public static async getDocumentMetadata(screen: any, documentId: string): Promise<any> {
    try {
      const params = new URLSearchParams();
      const qs = params.toString();
      const result = await KuikaAppManager.ApiRequest(
        screen,
        `documentmanagement/${documentId}${qs ? `?${qs}` : ""}`,
        undefined,
        "get"
      );
      return result;
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return { data: null };
    }
  }

  /**
   * GET /v1/api/documentmanagement/{documentId}/versions — Returns all versions of a document.
   * Each item: { id, version, contentSize, contentHash, createdAt, createdUserId }.
   * @param documentId Required: document GUID
   */
  public static async getVersions(
    screen: any,
    documentId: string,
    language?: string,
    isDraft?: boolean,
    page?: number,
    pageSize?: number,
    maxResults?: number
  ): Promise<any> {
    try {
      const params = new URLSearchParams();
      if (language) params.set("language", language);
      if (isDraft !== undefined) params.set("isDraft", String(isDraft));
      if (page) params.set("page", String(page));
      if (pageSize) params.set("pageSize", String(pageSize));
      if (maxResults) params.set("maxResults", String(maxResults));
      const qs = params.toString();
      const result = await KuikaAppManager.ApiRequest(
        screen,
        `documentmanagement/${documentId}/versions${qs ? `?${qs}` : ""}`,
        undefined,
        "get"
      );
      return result;
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return { data: [] };
    }
  }

  /**
   * DELETE /v1/api/documentmanagement/folders/{folderId}[?force=true]
   * @param folderId     Required: folder GUID
   * @param forceDelete  When true, recursively soft-deletes all subfolders and documents first.
   *                     When false (default), returns 409 if the folder is not empty.
   */
  public static async deleteFolder(screen: any, folderId: string, forceDelete: boolean = false): Promise<boolean> {
    if (!folderId || folderId === "null" || folderId === "undefined") {
      console.warn("[DMS] deleteFolder: no folder selected, skipping.");
      return false;
    }
    try {
      const url = forceDelete
        ? `documentmanagement/folders/${folderId}?force=true`
        : `documentmanagement/folders/${folderId}`;
      await KuikaAppManager.ApiRequest(screen, url, undefined, "delete");
      return true;
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return false;
    }
  }

  /**
   * PUT /v1/api/documentmanagement/folders/{folderId}/move — Moves a folder under a new parent.
   * Pass null/empty for targetParentId to move to the root level.
   * @param folderId       Required: folder GUID to move
   * @param targetParentId Optional: new parent folder GUID (null = root)
   */
  public static async moveFolder(screen: any, folderId: string, targetParentId?: string): Promise<boolean> {
    if (!folderId || folderId === "null" || folderId === "undefined") {
      console.warn("[DMS] moveFolder: no folder selected, skipping.");
      return false;
    }
    try {
      await KuikaAppManager.ApiRequest(
        screen,
        `documentmanagement/folders/${folderId}/move`,
        { targetParentId: targetParentId || null },
        "put"
      );
      return true;
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return false;
    }
  }

  /**
   * PUT /v1/api/documentmanagement/folders/{folderId}/move-to-parent
   * Moves a folder one level up (to its grandparent). Returns 409 if already at root.
   * @param folderId Required: folder GUID
   */
  public static async moveFolderToParent(screen: any, folderId: string): Promise<boolean> {
    if (!folderId || folderId === "null" || folderId === "undefined") {
      console.warn("[DMS] moveFolderToParent: no folder selected, skipping.");
      return false;
    }
    try {
      await KuikaAppManager.ApiRequest(
        screen,
        `documentmanagement/folders/${folderId}/move-to-parent`,
        undefined,
        "put"
      );
      return true;
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return false;
    }
  }

  /**
   * GET /v1/api/documentmanagement/{documentId}/permissions — Lists permission grants on a document.
   * Each item: { id, principalType, principalId, permissionLevel, expiresAt }.
   * Requires manage permission.
   * @param documentId Required: document GUID
   * @param page       Page number (default: 1)
   * @param pageSize   Items per page (default: 100)
   */
  public static async getDocumentPermissions(
    screen: any,
    documentId: string,
    page?: number,
    pageSize?: number,
    maxResults?: number
  ): Promise<any> {
    try {
      const params = new URLSearchParams();
      if (page) params.set("page", String(page));
      if (pageSize) params.set("pageSize", String(pageSize));
      if (maxResults) params.set("maxResults", String(maxResults));
      const qs = params.toString();
      const base = `documentmanagement/${documentId}/permissions`;
      const result = await KuikaAppManager.ApiRequest(screen, qs ? `${base}?${qs}` : base, undefined, "get");
      return result;
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return { data: [] };
    }
  }

  /**
   * GET /v1/api/documentmanagement?includeArchived=true — Lists archived documents.
   * The X-Total-Count response header carries the total count for the Pagination element.
   * @param page     Page number (default: 1)
   * @param pageSize Documents per page (default: 50, max: 200)
   */
  public static async getArchivedDocuments(
    screen: any,
    page?: number,
    pageSize?: number,
    archivedAfter?: string,
    archivedBefore?: string,
    sortBy?: string,
    maxResults?: number
  ): Promise<any> {
    try {
      const params = new URLSearchParams();
      if (page) params.set("page", String(page));
      if (pageSize) params.set("pageSize", String(pageSize));
      if (archivedAfter) params.set("archivedAfter", archivedAfter);
      if (archivedBefore) params.set("archivedBefore", archivedBefore);
      if (sortBy) params.set("sortBy", sortBy);
      if (maxResults) params.set("maxResults", String(maxResults));
      const qs = params.toString();
      const result = await KuikaAppManager.ApiRequest(
        screen,
        qs ? `documentmanagement/archived?${qs}` : "documentmanagement/archived",
        undefined,
        "get"
      );
      return result;
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return { data: [] };
    }
  }

  /**
   * POST /v1/api/documentmanagement/{documentId}/duplicate — Duplicates a document into a target folder.
   * The duplicate is fully independent (new encryption key, name gets " (copy)" suffix).
   * Returns the new document metadata.
   * @param documentId     Required: source document GUID
   * @param targetFolderId Optional: destination folder GUID (null = root)
   */
  public static async duplicateDocument(screen: any, documentId: string, targetFolderId?: string): Promise<any> {
    try {
      const body: any = { folderId: targetFolderId || null };
      const result = await KuikaAppManager.ApiRequest(
        screen,
        `documentmanagement/${documentId}/duplicate`,
        body,
        "post"
      );
      return result;
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return { data: null };
    }
  }

  /**
   * GET /v1/api/documentmanagement/search — Searches documents by name across all accessible documents.
   * Excludes archived documents. Sorted by creation date (newest first).
   * The X-Total-Documents response header carries the total count.
   * @param query    Search string (optional — returns all if omitted)
   * @param page     Page number (default: 1)
   * @param pageSize Documents per page (default: 50, max: 200)
   */
  public static async searchDocuments(
    screen: any,
    query?: string,
    page?: number,
    pageSize?: number,
    folderId?: string,
    createdAfter?: string,
    createdBefore?: string,
    createdBy?: string
  ): Promise<any> {
    try {
      const params = new URLSearchParams();
      if (query) params.set("query", query);
      if (page) params.set("page", String(page));
      if (pageSize) params.set("pageSize", String(pageSize));
      if (folderId) params.set("folderId", folderId);
      if (createdAfter) params.set("createdAfter", createdAfter);
      if (createdBefore) params.set("createdBefore", createdBefore);
      if (createdBy) params.set("createdBy", createdBy);
      const qs = params.toString();
      const result = await KuikaAppManager.ApiRequest(
        screen,
        qs ? `documentmanagement/search?${qs}` : "documentmanagement/search",
        undefined,
        "get"
      );
      return result;
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return { data: [] };
    }
  }

  /**
   * GET /v1/api/documentmanagement/{documentId}/audit — Returns the audit log for a document.
   * Each item: { action, userId, ipAddress, createdAt, details }.
   * Requires manage permission. The X-Total-Count header carries the total count.
   * @param documentId Required: document GUID
   * @param page       Page number (default: 1)
   * @param pageSize   Items per page (default: 50, max: 200)
   */
  public static async getDocumentAuditLogs(
    screen: any,
    documentId: string,
    page?: number,
    pageSize?: number,
    maxResults?: number
  ): Promise<any> {
    try {
      const params = new URLSearchParams();
      if (page) params.set("page", String(page));
      if (pageSize) params.set("pageSize", String(pageSize));
      if (maxResults) params.set("maxResults", String(maxResults));
      const qs = params.toString();
      const base = `documentmanagement/${documentId}/audit`;
      const result = await KuikaAppManager.ApiRequest(screen, qs ? `${base}?${qs}` : base, undefined, "get");
      return result;
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return { data: [] };
    }
  }

  /**
   * GET /v1/api/documentmanagement/shared — Returns documents shared with the current user.
   * "Shared with me" view: documents explicitly granted via permissions, excluding own uploads.
   * The X-Total-Documents response header carries the total count.
   * @param page     Page number (default: 1)
   * @param pageSize Documents per page (default: 50, max: 200)
   */
  public static async getDocumentsSharedWithMe(
    screen: any,
    page?: number,
    pageSize?: number,
    draftFilter?: string,
    language?: string,
    maxResults?: number
  ): Promise<any> {
    try {
      const params = new URLSearchParams();
      if (page) params.set("page", String(page));
      if (pageSize) params.set("pageSize", String(pageSize));
      if (draftFilter) params.set("draftFilter", draftFilter);
      if (maxResults) params.set("maxResults", String(maxResults));
      const qs = params.toString();
      const result = await KuikaAppManager.ApiRequest(
        screen,
        qs ? `documentmanagement/shared?${qs}` : "documentmanagement/shared",
        undefined,
        "get"
      );
      return result;
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return { data: [] };
    }
  }

  /**
   * GET /v1/api/documentmanagement/shared-by-me — Returns documents the current user has shared with others.
   * Lists own documents that have at least one active permission grant.
   * The X-Total-Documents response header carries the total count.
   * @param page     Page number (default: 1)
   * @param pageSize Documents per page (default: 50, max: 200)
   */
  public static async getDocumentsSharedByMe(
    screen: any,
    page?: number,
    pageSize?: number,
    draftFilter?: string,
    language?: string,
    maxResults?: number
  ): Promise<any> {
    try {
      const params = new URLSearchParams();
      if (page) params.set("page", String(page));
      if (pageSize) params.set("pageSize", String(pageSize));
      if (draftFilter) params.set("draftFilter", draftFilter);
      if (maxResults) params.set("maxResults", String(maxResults));
      const qs = params.toString();
      const result = await KuikaAppManager.ApiRequest(
        screen,
        qs ? `documentmanagement/shared-by-me?${qs}` : "documentmanagement/shared-by-me",
        undefined,
        "get"
      );
      return result;
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return { data: [] };
    }
  }

  /**
   * GET /v1/api/documentmanagement/recently-modified
   * Returns non-archived documents modified (or created) within the last N days. Sorted by most recently modified first.
   * @param days     Look-back window in days (default: 30)
   * @param page     Page number (default: 1)
   * @param pageSize Documents per page (default: 50, max: 200)
   */
  public static async getRecentlyModifiedDocuments(
    screen: any,
    days?: number,
    page?: number,
    pageSize?: number,
    draftFilter?: string,
    language?: string,
    maxResults?: number
  ): Promise<any> {
    try {
      const params = new URLSearchParams();
      if (days) params.set("days", String(days));
      if (page) params.set("page", String(page));
      if (pageSize) params.set("pageSize", String(pageSize));
      if (draftFilter) params.set("draftFilter", draftFilter);
      if (maxResults) params.set("maxResults", String(maxResults));
      const qs = params.toString();
      const result = await KuikaAppManager.ApiRequest(
        screen,
        qs ? `documentmanagement/recently-modified?${qs}` : "documentmanagement/recently-modified",
        undefined,
        "get"
      );
      return result;
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return { data: [] };
    }
  }

  /**
   * GET /v1/api/documentmanagement/search/advanced — Advanced document search combining all filter parameters.
   * All parameters are optional. The X-Total-Documents header carries the total count.
   * @param query        Name search string (optional)
   * @param folderId     Restrict search to a folder subtree (optional)
   * @param createdAfter ISO date string (optional)
   * @param createdBefore ISO date string (optional)
   * @param createdBy    Creator user GUID (optional)
   * @param page         Page number (default: 1)
   * @param pageSize     Documents per page (default: 50, max: 200)
   */
  public static async searchDocumentsAdvanced(
    screen: any,
    query?: string,
    folderId?: string,
    createdAfter?: string,
    createdBefore?: string,
    createdBy?: string,
    documentType?: string,
    documentNumber?: string,
    tagName?: string,
    page?: number,
    pageSize?: number,
    draftFilter?: string,
    language?: string,
    maxResults?: number
  ): Promise<any> {
    try {
      const params = new URLSearchParams();
      if (query) params.set("query", query);
      if (folderId) params.set("folderId", folderId);
      if (createdAfter) params.set("createdAfter", createdAfter);
      if (createdBefore) params.set("createdBefore", createdBefore);
      if (createdBy) params.set("createdBy", createdBy);
      if (documentType) params.set("documentType", documentType);
      if (documentNumber) params.set("documentNumber", documentNumber);
      if (tagName) params.set("tagName", tagName);
      if (page) params.set("page", String(page));
      if (pageSize) params.set("pageSize", String(pageSize));
      if (draftFilter) params.set("draftFilter", draftFilter);
      if (maxResults) params.set("maxResults", String(maxResults));
      const qs = params.toString();
      const result = await KuikaAppManager.ApiRequest(
        screen,
        qs ? `documentmanagement/search/advanced?${qs}` : "documentmanagement/search/advanced",
        undefined,
        "get"
      );
      return result;
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return { data: [] };
    }
  }

  /**
   * GET /v1/api/documentmanagement/{documentId}/activity-summary
   * Returns: totalDownloads, lastDownloadAt, activePermissions, activeShares, totalVersions.
   * Requires manage permission on the document.
   * @param documentId Required: document GUID
   */
  public static async getDocumentActivitySummary(screen: any, documentId: string): Promise<any> {
    try {
      const params = new URLSearchParams();
      const qs = params.toString();
      const result = await KuikaAppManager.ApiRequest(
        screen,
        `documentmanagement/${documentId}/activity-summary${qs ? `?${qs}` : ""}`,
        undefined,
        "get"
      );
      return result;
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return { data: null };
    }
  }

  /**
   * GET /v1/api/documentmanagement/folders/{folderId}/stats
   * Returns: folderId, totalDocuments, archivedDocuments, subfolderCount, totalStorageBytes, lastUpdatedAt.
   * @param folderId          Required: folder GUID
   * @param includeSubfolders When true (default), recursively aggregates the entire subtree
   */
  public static async getFolderStats(screen: any, folderId: string, includeSubfolders?: boolean): Promise<any> {
    try {
      const params = new URLSearchParams();
      if (includeSubfolders !== undefined) params.set("includeSubfolders", String(includeSubfolders));
      const qs = params.toString();
      const base = `documentmanagement/folders/${folderId}/stats`;
      const result = await KuikaAppManager.ApiRequest(screen, qs ? `${base}?${qs}` : base, undefined, "get");
      return result;
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return { data: null };
    }
  }

  /**
   * GET /v1/api/documentmanagement/admin/audit — Admin-level paginated audit log across ALL DMS entities.
   * Optional filters: action, userId, from/to date range, entityType.
   * Requires admin/manage role.
   */
  public static async getAllAuditLogs(
    screen: any,
    page?: number,
    pageSize?: number,
    action?: string,
    userId?: string,
    from?: string,
    to?: string,
    entityType?: string,
    maxResults?: number
  ): Promise<any> {
    try {
      const params = new URLSearchParams();
      if (page) params.set("page", String(page));
      if (pageSize) params.set("pageSize", String(pageSize));
      if (action) params.set("action", action);
      if (userId) params.set("userId", userId);
      if (from) params.set("from", from);
      if (to) params.set("to", to);
      if (entityType) params.set("entityType", entityType);
      if (maxResults) params.set("maxResults", String(maxResults));
      const qs = params.toString();
      const result = await KuikaAppManager.ApiRequest(
        screen,
        qs ? `documentmanagement/admin/audit?${qs}` : "documentmanagement/admin/audit",
        undefined,
        "get"
      );
      return result;
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return { data: [] };
    }
  }

  /**
   * PUT /v1/api/documentmanagement/{documentId}/metadata — Sets (replaces) the free-form JSON metadata on a document.
   * Pass a valid JSON object as a string, e.g. '{"category":"invoice","year":"2026"}'.
   * Requires edit permission on the document.
   * @param documentId Required: document GUID
   * @param metadata   JSON string
   */
  public static async setDocumentMetadata(screen: any, documentId: string, metadata?: string): Promise<boolean> {
    try {
      const body: any = { metadata };
      await KuikaAppManager.ApiRequest(screen, `documentmanagement/${documentId}/metadata`, body, "put");
      return true;
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return false;
    }
  }

  /** Sets or updates a single metadata key-value pair on a document. Existing metadata is preserved. */
  public static async setDocumentMetadataField(
    screen: any,
    documentId: string,
    key: string,
    value: string
  ): Promise<any> {
    try {
      return await KuikaAppManager.ApiRequest(
        screen,
        `documentmanagement/${documentId}/metadata/field`,
        { key, value },
        "put"
      );
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return null;
    }
  }

  /** Removes a single metadata key from a document. Other fields are preserved. */
  public static async removeDocumentMetadataField(screen: any, documentId: string, key: string): Promise<any> {
    try {
      return await KuikaAppManager.ApiRequest(
        screen,
        `documentmanagement/${documentId}/metadata/field?key=${encodeURIComponent(key)}`,
        undefined,
        "delete"
      );
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return null;
    }
  }

  /** Returns the value of a single metadata field from a document by key. */
  public static async getDocumentMetadataField(screen: any, documentId: string, key: string): Promise<any> {
    try {
      return await KuikaAppManager.ApiRequest(
        screen,
        `documentmanagement/${documentId}/metadata/field?key=${encodeURIComponent(key)}`,
        undefined,
        "get"
      );
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return null;
    }
  }

  /**
   * GET /v1/api/documentmanagement/by-metadata?key=&value= — Returns documents where Metadata JSON contains the given key/value pair.
   * Works on flat JSON values only (no nested objects).
   * The X-Total-Documents header carries the total count.
   * @param metadataKey   JSON key to match (e.g. "category")
   * @param metadataValue JSON value to match (e.g. "invoice")
   * @param page          Page number (default: 1)
   * @param pageSize      Documents per page (default: 50, max: 200)
   */
  public static async getDocumentsByMetadata(
    screen: any,
    metadataKey: string,
    metadataValue: string,
    page?: number,
    pageSize?: number,
    draftFilter?: string,
    language?: string,
    maxResults?: number
  ): Promise<any> {
    try {
      const params = new URLSearchParams();
      params.set("key", metadataKey);
      params.set("value", metadataValue);
      if (page) params.set("page", String(page));
      if (pageSize) params.set("pageSize", String(pageSize));
      if (draftFilter) params.set("draftFilter", draftFilter);
      if (maxResults) params.set("maxResults", String(maxResults));
      const result = await KuikaAppManager.ApiRequest(
        screen,
        `documentmanagement/by-metadata?${params.toString()}`,
        undefined,
        "get"
      );
      return result;
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return { data: [] };
    }
  }

  /**
   * GET /v1/api/documentmanagement/{documentId}/file — Downloads a document to the user's device.
   * Requires at least view permission.
   * @param documentId Required: document GUID
   * @param fileName   Optional: override the filename shown in the browser's save dialog.
   *                   If omitted, uses the filename from the Content-Disposition response header,
   *                   falling back to "document".
   * @param watermark  Optional: if true, the server applies the DMS watermark before streaming.
   *                   Requires watermarkView or higher permission; view-only users are blocked (403).
   */
  public static async downloadDocument(
    screen: any,
    documentId: string,
    versionId?: string,
    fileName?: string,
    watermark?: boolean,
    language?: string,
    convertTo?: string
  ): Promise<void> {
    try {
      const base = KuikaAppManager.GetBackendUrl().replace(/\/$/, "");
      const params = new URLSearchParams();
      if (watermark) params.set("watermark", "true");
      if (convertTo) params.set("convertTo", convertTo);
      const qs = params.toString();
      const pathSegment = versionId
        ? `documentmanagement/versions/${versionId}/file`
        : `documentmanagement/${documentId}/file`;
      const resp = await axios.get(`${base}/${pathSegment}${qs ? `?${qs}` : ""}`, {
        responseType: "blob"
      });

      // Resolve filename: caller prop → Content-Disposition header → fallback
      // RFC 5987: filename*=UTF-8''<percent-encoded> takes priority over filename="<ascii>"
      let resolvedName = fileName?.trim() || undefined;
      if (!resolvedName) {
        const cd: string = resp.headers?.["content-disposition"] ?? "";
        const extMatch = /filename\*=UTF-8''([^;"'\r\n]+)/i.exec(cd);
        const basicMatch = /filename=["']?([^;"'\r\n]+)["']?/i.exec(cd);
        const raw = extMatch?.[1] ?? basicMatch?.[1];
        resolvedName = raw ? decodeURIComponent(raw.trim().replace(/['"]/g, "")) : "document";
      }

      KMainFunctions.downloadFile(resp.data, resolvedName);
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
    }
  }

  /**
   * POST /v1/api/documentmanagement — Uploads a new document.
   * ⚠️ Maximum 50 MB. Use Chunked Upload for larger files.
   */
  public static async uploadDocument(
    screen: any,
    fileName: string,
    mimeType: string,
    base64Content: string,
    documentName?: string,
    folderId?: string,
    language?: string,
    isDraft?: boolean,
    documentNumber?: string,
    documentType?: string
  ): Promise<string | null> {
    try {
      const raw = base64Content?.includes(",") ? base64Content.split(",")[1] : base64Content;

      // 50 MB validation — base64 length * 0.75 ≈ actual byte size
      const MAX_BYTES = 50 * 1024 * 1024;
      const estimatedBytes = Math.ceil((raw?.length ?? 0) * 0.75);
      if (estimatedBytes > MAX_BYTES) {
        const mb = Math.round(estimatedBytes / 1024 / 1024);
        throw new Error(
          `File size exceeds the 50 MB limit (estimated: ${mb} MB). Use Chunked Upload for larger files.`
        );
      }

      const bytes = atob(raw);
      const buf = new Uint8Array(bytes.length);
      for (let i = 0; i < bytes.length; i++) buf[i] = bytes.charCodeAt(i);
      const blob = new Blob([buf], { type: mimeType });

      const formData = new FormData();
      formData.append("file", blob, fileName);
      formData.append("documentName", documentName || fileName);
      if (folderId) formData.append("folderId", folderId);
      if (language) formData.append("language", language);
      if (isDraft !== undefined) formData.append("isDraft", String(isDraft));
      if (documentNumber) formData.append("documentNumber", documentNumber);
      if (documentType) formData.append("documentType", documentType);

      return await KuikaAppManager.ApiRequest(screen, "documentmanagement", formData, "post");
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return null;
    }
  }

  /** DELETE /v1/api/documentmanagement/{documentId} — Soft delete */
  public static async deleteDocument(screen: any, documentId: string): Promise<boolean> {
    if (!documentId || documentId === "null" || documentId === "undefined") {
      console.warn("[DMS] deleteDocument: no document selected, skipping.");
      return false;
    }
    try {
      const params = new URLSearchParams();
      const qs = params.toString();
      await KuikaAppManager.ApiRequest(
        screen,
        `documentmanagement/${documentId}${qs ? `?${qs}` : ""}`,
        undefined,
        "delete"
      );
      return true;
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return false;
    }
  }

  /** POST /v1/api/documentmanagement/folders — Creates a new folder. @returns axios envelope whose `data` matches CreateResult { folderId } */
  public static async createDocumentFolder(screen: any, name: string, parentFolderId?: string): Promise<any> {
    try {
      return await KuikaAppManager.ApiRequest(
        screen,
        "documentmanagement/folders",
        { name, parentFolderId: parentFolderId || null },
        "post"
      );
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return null;
    }
  }

  /** PUT /v1/api/documentmanagement/{documentId}/move — Moves the document to a folder. folderId=null → root */
  public static async moveDocument(screen: any, documentId: string, folderId?: string): Promise<boolean> {
    if (!documentId || documentId === "null" || documentId === "undefined") {
      console.warn("[DMS] moveDocument: no document selected, skipping.");
      return false;
    }
    try {
      const body: any = { folderId: folderId || null };
      await KuikaAppManager.ApiRequest(screen, `documentmanagement/${documentId}/move`, body, "put");
      return true;
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return false;
    }
  }

  /** PUT /v1/api/documentmanagement/folders/{folderId} — Renames the folder */
  public static async renameDocumentFolder(screen: any, folderId: string, name: string): Promise<boolean> {
    if (!folderId || folderId === "null" || folderId === "undefined") {
      console.warn("[DMS] renameDocumentFolder: no folder selected, skipping.");
      return false;
    }
    try {
      await KuikaAppManager.ApiRequest(screen, `documentmanagement/folders/${folderId}`, { name }, "put");
      return true;
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return false;
    }
  }

  /**
   * POST /v1/api/documentmanagement/{documentId}/share — Creates a share link.
   * @param expiresInDays  Number of days the link is valid (optional)
   * @returns Axios envelope whose `data` matches ShareLinkResult { url, shareId }
   */
  public static async createDocumentShareLink(screen: any, documentId: string, expiresInDays?: number): Promise<any> {
    try {
      const expiresAt = expiresInDays ? new Date(Date.now() + expiresInDays * 24 * 60 * 60 * 1000).toISOString() : null;
      const body: any = { permissionLevel: "view", expiresAt, maxUseCount: null };
      const response: any = await KuikaAppManager.ApiRequest(
        screen,
        `documentmanagement/${documentId}/share`,
        body,
        "post"
      );
      // Backend returns { id, permissionLevel, expiresAt, maxUseCount, shareUrl }.
      // Action contract (ShareLinkResult) declares { url, shareId } — rename in place.
      if (response && response.data) {
        response.data = { url: response.data.shareUrl, shareId: response.data.id };
      }
      return response;
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return { data: { url: "", shareId: "" } };
    }
  }

  /**
   * POST /v1/api/documentmanagement/{documentId}/upload-link — Creates an anonymous upload link
   * with a 6-digit verification code. The recipient enters the code to upload a new version.
   * @param expiresInDays  Number of days the link is valid (optional; backend default applies otherwise)
   * @returns Axios envelope whose `data` matches UploadLinkResult { uploadUrl, uploadLinkId, code, expiresAt }
   */
  public static async createDocumentUploadLink(screen: any, documentId: string, expiresInDays?: number): Promise<any> {
    try {
      const expiresAt = expiresInDays ? new Date(Date.now() + expiresInDays * 24 * 60 * 60 * 1000).toISOString() : null;
      // windowLocationOrigin returns origin + virtualDirectoryURL — i.e. the frontend
      // base URL as deployed (incl. any sub-path). Backend uses this as the link
      // host, since Referer is unreliable behind proxies/CDNs.
      const body: any = {
        expiresAt,
        maxCodeAttempts: null,
        maxUseCount: null,
        clientBaseUrl: KMainFunctions.windowLocationOrigin
      };
      const response: any = await KuikaAppManager.ApiRequest(
        screen,
        `documentmanagement/${documentId}/upload-link`,
        body,
        "post"
      );
      if (response && response.data) {
        response.data = {
          uploadUrl: response.data.uploadUrl,
          uploadLinkId: response.data.id,
          code: response.data.code,
          expiresAt: response.data.expiresAt
        };
      }
      return response;
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return { data: { uploadUrl: "", uploadLinkId: "", code: "", expiresAt: null } };
    }
  }

  /**
   * POST /v1/api/documentmanagement/{documentId}/permissions — Grants permission to a user or role.
   * @param principalType  "user" (default) | "role"
   */
  public static async grantDocumentPermission(
    screen: any,
    documentId: string,
    userOrRoleId?: string,
    permissionLevel?: string,
    principalType?: string,
    expiresInDays?: number
  ): Promise<boolean> {
    const validLevels = ["view", "watermarkView", "edit", "manage"];
    if (permissionLevel && !validLevels.includes(permissionLevel)) {
      KMainFunctions.exceptionHandler(
        new Error(`Invalid permissionLevel: "${permissionLevel}". Valid values: ${validLevels.join(", ")}`)
      );
      return false;
    }

    const validTypes = ["user", "role"];
    const resolvedType = principalType && String(principalType).length > 0 ? principalType : "user";
    if (!validTypes.includes(resolvedType)) {
      KMainFunctions.exceptionHandler(new Error(`Invalid principalType: "${resolvedType}". Valid values: user, role`));
      return false;
    }

    // Designer codegen passes Int32 params via convertToTypeByName which doesn't recognize
    // "Int32" and returns the raw string. Normalize: positive int → days, anything else → null.
    let resolvedExpiresInDays: number | null = null;
    if (expiresInDays != null && (expiresInDays as unknown) !== "") {
      const parsed: number = parseInt(String(expiresInDays), 10);
      if (Number.isFinite(parsed) && parsed > 0) {
        resolvedExpiresInDays = parsed;
      }
    }

    try {
      const body: any = {
        principalType: resolvedType,
        principalId: userOrRoleId,
        permissionLevel,
        expiresAt: null,
        expiresInDays: resolvedExpiresInDays
      };
      await KuikaAppManager.ApiRequest(screen, `documentmanagement/${documentId}/permissions`, body, "post");
      return true;
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return false;
    }
  }

  /** PATCH /v1/api/documentmanagement/{documentId} — Renames the document */
  public static async renameDocument(screen: any, documentId: string, name?: string): Promise<boolean> {
    if (!documentId || documentId === "null" || documentId === "undefined") {
      console.warn("[DMS] renameDocument: no document selected, skipping.");
      return false;
    }
    try {
      const body: any = { name };
      await KuikaAppManager.ApiRequest(screen, `documentmanagement/${documentId}`, body, "patch");
      return true;
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return false;
    }
  }

  /**
   * DELETE /v1/api/documentmanagement/{documentId}/permissions/{permissionId}
   * Revokes a permission granted on the document.
   */
  public static async revokeDocumentPermission(
    screen: any,
    documentId: string,
    permissionId?: string
  ): Promise<boolean> {
    try {
      const params = new URLSearchParams();
      const qs = params.toString();
      await KuikaAppManager.ApiRequest(
        screen,
        `documentmanagement/${documentId}/permissions/${permissionId}${qs ? `?${qs}` : ""}`,
        undefined,
        "delete"
      );
      return true;
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return false;
    }
  }

  /**
   * POST /v1/api/documentmanagement/folders/{folderId}/permissions
   * Grants permission on the folder. permissionLevel: view | edit | manage. principalType: user | role
   */
  public static async grantFolderPermission(
    screen: any,
    folderId: string,
    userOrRoleId: string,
    permissionLevel: string,
    principalType?: string,
    expiresInDays?: number
  ): Promise<boolean> {
    const resolvedType: string = principalType && String(principalType).length > 0 ? principalType : "user";

    // Designer codegen passes Int32 params via convertToTypeByName which doesn't recognize
    // "Int32" and returns the raw string. Normalize: positive int → days, anything else → null.
    let resolvedExpiresInDays: number | null = null;
    if (expiresInDays != null && (expiresInDays as unknown) !== "") {
      const parsed: number = parseInt(String(expiresInDays), 10);
      if (Number.isFinite(parsed) && parsed > 0) {
        resolvedExpiresInDays = parsed;
      }
    }

    try {
      await KuikaAppManager.ApiRequest(
        screen,
        `documentmanagement/folders/${folderId}/permissions`,
        {
          principalType: resolvedType,
          principalId: userOrRoleId,
          permissionLevel,
          expiresAt: null,
          expiresInDays: resolvedExpiresInDays
        },
        "post"
      );
      return true;
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return false;
    }
  }

  /**
   * DELETE /v1/api/documentmanagement/folders/{folderId}/permissions/{permissionId}
   * Revokes a permission granted on the folder.
   */
  public static async revokeFolderPermission(screen: any, folderId: string, permissionId: string): Promise<boolean> {
    try {
      await KuikaAppManager.ApiRequest(
        screen,
        `documentmanagement/folders/${folderId}/permissions/${permissionId}`,
        undefined,
        "delete"
      );
      return true;
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return false;
    }
  }

  /** POST /v1/api/documentmanagement/{documentId}/archive — Moves the document to the archive */
  public static async archiveDocument(screen: any, documentId: string): Promise<boolean> {
    try {
      const params = new URLSearchParams();
      const qs = params.toString();
      await KuikaAppManager.ApiRequest(
        screen,
        `documentmanagement/${documentId}/archive${qs ? `?${qs}` : ""}`,
        undefined,
        "post"
      );
      return true;
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return false;
    }
  }

  /** POST /v1/api/documentmanagement/{documentId}/unarchive — Removes the document from the archive */
  public static async unarchiveDocument(screen: any, documentId: string): Promise<boolean> {
    try {
      const params = new URLSearchParams();
      const qs = params.toString();
      await KuikaAppManager.ApiRequest(
        screen,
        `documentmanagement/${documentId}/unarchive${qs ? `?${qs}` : ""}`,
        undefined,
        "post"
      );
      return true;
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return false;
    }
  }

  /** POST /v1/api/documentmanagement/{documentId}/restore — Restores a soft-deleted document */
  public static async restoreDocument(screen: any, documentId: string): Promise<boolean> {
    try {
      const params = new URLSearchParams();
      const qs = params.toString();
      await KuikaAppManager.ApiRequest(
        screen,
        `documentmanagement/${documentId}/restore${qs ? `?${qs}` : ""}`,
        undefined,
        "post"
      );
      return true;
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return false;
    }
  }

  // ── Templates ─────────────────────────────────────────────────────

  public static async getTemplates(
    screen: any,
    category?: string,
    page?: number,
    pageSize?: number,
    searchQuery?: string,
    includeInactive?: boolean,
    mimeType?: string,
    maxResults?: number
  ): Promise<any> {
    try {
      const params = new URLSearchParams();
      if (category) params.set("category", category);
      if (page) params.set("page", String(page));
      if (pageSize) params.set("pageSize", String(pageSize));
      if (searchQuery) params.set("searchQuery", searchQuery);
      if (includeInactive) params.set("includeInactive", "true");
      if (mimeType) params.set("mimeType", mimeType);
      if (maxResults) params.set("maxResults", String(maxResults));
      const qs = params.toString();
      const url = qs ? `documentmanagement/templates?${qs}` : "documentmanagement/templates";
      return await KuikaAppManager.ApiRequest(screen, url, undefined, "get");
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return { data: [] };
    }
  }

  public static async createTemplate(
    screen: any,
    name: string,
    description: string,
    mimeType: string,
    category: string,
    base64Content: string
  ): Promise<any> {
    try {
      return await KuikaAppManager.ApiRequest(
        screen,
        "documentmanagement/templates/from-base64",
        { name, description, mimeType, category, base64Content },
        "post"
      );
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return null;
    }
  }

  public static async updateTemplate(
    screen: any,
    templateId: string,
    name?: string,
    description?: string,
    category?: string,
    isActive?: boolean,
    metadata?: string
  ): Promise<any> {
    try {
      return (
        await KuikaAppManager.ApiRequest(
          screen,
          `documentmanagement/templates/${templateId}`,
          { name, description, category, isActive, metadata },
          "put"
        )
      )?.data;
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return null;
    }
  }

  public static async updateTemplateContent(screen: any, templateId: string, base64Content: string): Promise<any> {
    try {
      // Controller route: PUT templates/{templateId}/file with FormFile
      const base = KuikaAppManager.GetBackendUrl().replace(/\/$/, "");
      const blob = base64Content
        ? new Blob([Uint8Array.from(atob(base64Content), (c) => c.charCodeAt(0))])
        : new Blob([]);
      const formData = new FormData();
      formData.append("file", blob, "template.bin");
      const resp = await fetch(`${base}/documentmanagement/templates/${templateId}/file`, {
        method: "PUT",
        body: formData
      });
      return await resp.json();
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return null;
    }
  }

  public static async deleteTemplate(screen: any, templateId: string): Promise<boolean> {
    try {
      await KuikaAppManager.ApiRequest(screen, `documentmanagement/templates/${templateId}`, undefined, "delete");
      return true;
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return false;
    }
  }

  public static async downloadTemplate(screen: any, templateId: string): Promise<any> {
    try {
      return await KuikaAppManager.ApiRequest(
        screen,
        `documentmanagement/templates/${templateId}/file`,
        undefined,
        "get"
      );
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return null;
    }
  }

  public static async getTemplateCategories(screen: any): Promise<any> {
    try {
      return await KuikaAppManager.ApiRequest(screen, "documentmanagement/templates/categories", undefined, "get");
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return { data: [] };
    }
  }

  public static async getTemplateMetadata(screen: any, templateId: string): Promise<any> {
    try {
      return await KuikaAppManager.ApiRequest(screen, `documentmanagement/templates/${templateId}`, undefined, "get");
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return null;
    }
  }

  public static async activateTemplate(screen: any, templateId: string): Promise<any> {
    try {
      return (
        await KuikaAppManager.ApiRequest(
          screen,
          `documentmanagement/templates/${templateId}/activate`,
          undefined,
          "post"
        )
      )?.data;
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return null;
    }
  }

  public static async deactivateTemplate(screen: any, templateId: string): Promise<any> {
    try {
      return (
        await KuikaAppManager.ApiRequest(
          screen,
          `documentmanagement/templates/${templateId}/deactivate`,
          undefined,
          "post"
        )
      )?.data;
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return null;
    }
  }

  public static async createDocumentFromTemplate(
    screen: any,
    templateId: string,
    documentName: string,
    folderId?: string,
    language?: string,
    metadata?: string,
    documentNumber?: string,
    documentType?: string,
    isDraft?: boolean
  ): Promise<any> {
    try {
      return await KuikaAppManager.ApiRequest(
        screen,
        `documentmanagement/templates/${templateId}/generate`,
        { documentName, folderId, language, metadata, documentNumber, documentType, isDraft },
        "post"
      );
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return null;
    }
  }

  // ── Tags ─────────────────────────────────────────────────────────

  public static async addDocumentTag(
    screen: any,
    documentId: string,
    tagName?: string,
    tagGroup?: string
  ): Promise<any> {
    try {
      const body: any = { tagName, tagGroup };
      return await KuikaAppManager.ApiRequest(screen, `documentmanagement/${documentId}/tags`, body, "post");
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return null;
    }
  }

  public static async removeDocumentTag(screen: any, documentId: string, tagName?: string): Promise<boolean> {
    try {
      const params = new URLSearchParams();
      const qs = params.toString();
      await KuikaAppManager.ApiRequest(
        screen,
        `documentmanagement/${documentId}/tags/${encodeURIComponent(tagName || "")}${qs ? `?${qs}` : ""}`,
        undefined,
        "delete"
      );
      return true;
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return false;
    }
  }

  public static async getDocumentTags(screen: any, documentId: string): Promise<any> {
    try {
      return await KuikaAppManager.ApiRequest(screen, `documentmanagement/${documentId}/tags`, undefined, "get");
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return { data: [] };
    }
  }

  public static async getDocumentsByTag(
    screen: any,
    tagName: string,
    tagGroup?: string,
    page?: number,
    pageSize?: number,
    draftFilter?: string,
    language?: string,
    maxResults?: number
  ): Promise<any> {
    try {
      const params = new URLSearchParams();
      params.set("tagName", tagName);
      if (tagGroup) params.set("tagGroup", tagGroup);
      if (page) params.set("page", String(page));
      if (pageSize) params.set("pageSize", String(pageSize));
      if (draftFilter) params.set("draftFilter", draftFilter);
      if (maxResults) params.set("maxResults", String(maxResults));
      return await KuikaAppManager.ApiRequest(screen, `documentmanagement/by-tag?${params}`, undefined, "get");
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return { data: [] };
    }
  }

  /** Adds a tag to all documents in folderId (and subfolders). Returns affected count. */
  public static async bulkAddTag(screen: any, folderId: string, tagName: string, tagGroup?: string): Promise<any> {
    try {
      const body: any = { folderId, tagName, tagGroup };
      return (await KuikaAppManager.ApiRequest(screen, "documentmanagement/bulk/add-tag", body, "post"))?.data;
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return null;
    }
  }

  // ── Folder Tags ──────────────────────────────────────────────────

  public static async addFolderTag(screen: any, folderId: string, tagName?: string, tagGroup?: string): Promise<any> {
    try {
      const body: any = { tagName, tagGroup };
      return await KuikaAppManager.ApiRequest(screen, `documentmanagement/folders/${folderId}/tags`, body, "post");
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return null;
    }
  }

  public static async removeFolderTag(screen: any, folderId: string, tagName?: string): Promise<boolean> {
    try {
      await KuikaAppManager.ApiRequest(
        screen,
        `documentmanagement/folders/${folderId}/tags/${encodeURIComponent(tagName || "")}`,
        undefined,
        "delete"
      );
      return true;
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return false;
    }
  }

  public static async getFolderTags(screen: any, folderId: string): Promise<any> {
    try {
      return await KuikaAppManager.ApiRequest(screen, `documentmanagement/folders/${folderId}/tags`, undefined, "get");
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return { data: [] };
    }
  }

  public static async getFoldersByTag(
    screen: any,
    tagName: string,
    tagGroup?: string,
    page?: number,
    pageSize?: number,
    maxResults?: number
  ): Promise<any> {
    try {
      const params = new URLSearchParams();
      params.set("tagName", tagName);
      if (tagGroup) params.set("tagGroup", tagGroup);
      if (page) params.set("page", String(page));
      if (pageSize) params.set("pageSize", String(pageSize));
      if (maxResults) params.set("maxResults", String(maxResults));
      return await KuikaAppManager.ApiRequest(screen, `documentmanagement/folders/by-tag?${params}`, undefined, "get");
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return { data: [] };
    }
  }

  /** Returns the most-used folder tags (name, group, folderCount). */
  public static async getFolderTagCloud(screen: any, limit?: number, tagGroup?: string): Promise<any> {
    try {
      const params = new URLSearchParams();
      if (limit) params.set("limit", String(limit));
      if (tagGroup) params.set("tagGroup", tagGroup);
      const qs = params.toString();
      return await KuikaAppManager.ApiRequest(
        screen,
        `documentmanagement/dashboard/folder-tag-cloud${qs ? `?${qs}` : ""}`,
        undefined,
        "get"
      );
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return { data: [] };
    }
  }

  // ── Versioning & Drafts ──────────────────────────────────────────

  public static async createVersion(
    screen: any,
    versionId: string,
    base64Content: string,
    changeNote?: string,
    discardExistingDraft?: boolean
  ): Promise<any> {
    try {
      return await KuikaAppManager.ApiRequest(
        screen,
        `documentmanagement/versions/${versionId}/new`,
        { base64Content, changeNote, discardExistingDraft },
        "post"
      );
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return null;
    }
  }

  public static async getVersionDetails(screen: any, versionId: string): Promise<any> {
    try {
      return await KuikaAppManager.ApiRequest(screen, `documentmanagement/versions/${versionId}`, undefined, "get");
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return null;
    }
  }

  public static async downloadVersion(screen: any, versionId: string): Promise<any> {
    try {
      return await KuikaAppManager.ApiRequest(
        screen,
        `documentmanagement/versions/${versionId}/file`,
        undefined,
        "get"
      );
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return null;
    }
  }

  /**
   * Updates document properties (name, type, number, metadata) in a single call.
   * Only provided fields are updated — null/undefined fields are left unchanged.
   */
  public static async updateDocument(
    screen: any,
    documentId: string,
    documentName?: string,
    documentType?: string,
    documentNumber?: string,
    metadata?: string
  ): Promise<any> {
    try {
      return await KuikaAppManager.ApiRequest(
        screen,
        `documentmanagement/${documentId}/properties`,
        {
          documentName: documentName || null,
          documentType: documentType || null,
          documentNumber: documentNumber || null,
          metadata: metadata || null
        },
        "put"
      );
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return null;
    }
  }

  public static async getVersionLanguages(screen: any, versionId: string): Promise<any> {
    try {
      return await KuikaAppManager.ApiRequest(
        screen,
        `documentmanagement/versions/${versionId}/languages`,
        undefined,
        "get"
      );
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return { data: [] };
    }
  }

  public static async addLanguageVariant(
    screen: any,
    versionId: string,
    language: string,
    base64Content: string,
    changeNote?: string
  ): Promise<any> {
    try {
      return await KuikaAppManager.ApiRequest(
        screen,
        `documentmanagement/versions/${versionId}/languages`,
        { language, base64Content, changeNote },
        "post"
      );
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return null;
    }
  }

  public static async setVersionLanguage(screen: any, versionId: string, newLanguage: string): Promise<boolean> {
    try {
      await KuikaAppManager.ApiRequest(
        screen,
        `documentmanagement/versions/${versionId}/language`,
        { newLanguage },
        "put"
      );
      return true;
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return false;
    }
  }

  public static async createDraft(
    screen: any,
    versionId: string,
    base64Content?: string,
    changeNote?: string,
    discardExistingDraft?: boolean
  ): Promise<any> {
    try {
      return await KuikaAppManager.ApiRequest(
        screen,
        `documentmanagement/versions/${versionId}/drafts`,
        { base64Content, changeNote, discardExistingDraft },
        "post"
      );
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return null;
    }
  }

  public static async updateDraft(
    screen: any,
    versionId: string,
    base64Content: string,
    changeNote?: string
  ): Promise<any> {
    try {
      const base = KuikaAppManager.GetBackendUrl().replace(/\/$/, "");
      const blob = base64Content
        ? new Blob([Uint8Array.from(atob(base64Content), (c) => c.charCodeAt(0))])
        : new Blob([]);
      const formData = new FormData();
      formData.append("file", blob, "document.bin");
      if (changeNote) formData.append("changeNote", changeNote);
      const resp = await fetch(`${base}/documentmanagement/versions/${versionId}/content`, {
        method: "PUT",
        body: formData
      });
      return await resp.json();
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return null;
    }
  }

  public static async publishDraft(screen: any, versionId: string): Promise<any> {
    try {
      return await KuikaAppManager.ApiRequest(
        screen,
        `documentmanagement/versions/${versionId}/publish`,
        undefined,
        "post"
      );
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return null;
    }
  }

  public static async discardDraft(screen: any, versionId: string): Promise<boolean> {
    try {
      await KuikaAppManager.ApiRequest(screen, `documentmanagement/versions/${versionId}`, undefined, "delete");
      return true;
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return false;
    }
  }

  public static async getDrafts(
    screen: any,
    documentId: string,
    versionId?: string,
    page?: number,
    pageSize?: number,
    maxResults?: number
  ): Promise<any> {
    try {
      const params = new URLSearchParams();
      if (versionId) params.set("versionId", versionId);
      if (page) params.set("page", String(page));
      if (pageSize) params.set("pageSize", String(pageSize));
      if (maxResults) params.set("maxResults", String(maxResults));
      const qs = params.toString();
      const url = qs ? `documentmanagement/${documentId}/drafts?${qs}` : `documentmanagement/${documentId}/drafts`;
      return await KuikaAppManager.ApiRequest(screen, url, undefined, "get");
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return { data: [] };
    }
  }

  // ── Bulk Operations ──────────────────────────────────────────────

  /** Moves all documents in folderId (and subfolders) to targetFolderId. Returns affected count. */
  public static async bulkMoveDocuments(screen: any, folderId: string, targetFolderId?: string): Promise<any> {
    try {
      const body: any = { folderId, targetFolderId };
      return (await KuikaAppManager.ApiRequest(screen, "documentmanagement/bulk/move", body, "post"))?.data;
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return null;
    }
  }

  /** Soft-deletes all documents in folderId (and subfolders). Returns affected count. */
  public static async bulkDeleteDocuments(screen: any, folderId: string): Promise<any> {
    try {
      const body: any = { folderId };
      return (await KuikaAppManager.ApiRequest(screen, "documentmanagement/bulk/delete", body, "post"))?.data;
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return null;
    }
  }

  /** Archives all documents in folderId (and subfolders). Returns affected count. */
  public static async bulkArchiveDocuments(screen: any, folderId: string): Promise<any> {
    try {
      const body: any = { folderId };
      return (await KuikaAppManager.ApiRequest(screen, "documentmanagement/bulk/archive", body, "post"))?.data;
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return null;
    }
  }

  // ── Relations ────────────────────────────────────────────────────

  public static async linkDocuments(
    screen: any,
    sourceDocumentId: string,
    targetDocumentId: string,
    relationType: string
  ): Promise<any> {
    try {
      return await KuikaAppManager.ApiRequest(
        screen,
        `documentmanagement/${sourceDocumentId}/relations`,
        { targetDocumentId, relationType },
        "post"
      );
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return null;
    }
  }

  public static async unlinkDocuments(
    screen: any,
    sourceDocumentId: string,
    targetDocumentId: string,
    relationType: string
  ): Promise<boolean> {
    try {
      await KuikaAppManager.ApiRequest(
        screen,
        `documentmanagement/${sourceDocumentId}/relations/${targetDocumentId}?relationType=${encodeURIComponent(relationType)}`,
        undefined,
        "delete"
      );
      return true;
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return false;
    }
  }

  public static async getRelatedDocuments(
    screen: any,
    documentId: string,
    versionId?: string,
    relationType?: string,
    draftFilter?: string,
    language?: string,
    page?: number,
    pageSize?: number,
    maxResults?: number
  ): Promise<any> {
    try {
      const params = new URLSearchParams();
      if (relationType) params.set("relationType", relationType);
      if (draftFilter) params.set("draftFilter", draftFilter);
      if (page) params.set("page", String(page));
      if (pageSize) params.set("pageSize", String(pageSize));
      if (maxResults) params.set("maxResults", String(maxResults));
      const qs = params.toString();
      const url = qs
        ? `documentmanagement/${documentId}/relations?${qs}`
        : `documentmanagement/${documentId}/relations`;
      return await KuikaAppManager.ApiRequest(screen, url, undefined, "get");
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return { data: [] };
    }
  }

  // ── Comments ─────────────────────────────────────────────────────

  public static async getDocumentComments(screen: any, versionId: string): Promise<any> {
    try {
      return await KuikaAppManager.ApiRequest(
        screen,
        `documentmanagement/versions/${versionId}/comments`,
        undefined,
        "get"
      );
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return null;
    }
  }

  public static async getDocumentCommentCount(screen: any, versionId: string): Promise<any> {
    try {
      return (
        await KuikaAppManager.ApiRequest(
          screen,
          `documentmanagement/versions/${versionId}/comments/count`,
          undefined,
          "get"
        )
      )?.data;
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return null;
    }
  }

  // ── Thumbnail ────────────────────────────────────────────────────

  public static async getDocumentThumbnail(screen: any, documentId: string): Promise<any> {
    try {
      const params = new URLSearchParams();
      const qs = params.toString();
      return await KuikaAppManager.ApiRequest(
        screen,
        `documentmanagement/${documentId}/thumbnail${qs ? `?${qs}` : ""}`,
        undefined,
        "get"
      );
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return null;
    }
  }

  public static async setDocumentThumbnail(
    screen: any,
    documentId: string,
    base64Content?: string,
    mimeType?: string
  ): Promise<boolean> {
    try {
      const body: any = { base64Content, mimeType };
      await KuikaAppManager.ApiRequest(screen, `documentmanagement/${documentId}/thumbnail/base64`, body, "put");
      return true;
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return false;
    }
  }

  // ── Document Number ──────────────────────────────────────────────

  public static async setDocumentNumber(screen: any, documentId: string, documentNumber?: string): Promise<boolean> {
    try {
      const body: any = { documentNumber };
      await KuikaAppManager.ApiRequest(screen, `documentmanagement/${documentId}/number`, body, "put");
      return true;
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return false;
    }
  }

  // ── Compare ──────────────────────────────────────────────────────

  /** Compare two versions. Returns structured diff result. */
  public static async compareVersions(
    screen: any,
    leftVersionId: string,
    rightVersionId: string,
    docxEngine?: string,
    xlsxEngine?: string,
    pdfEngine?: string,
    pptxEngine?: string,
    textEngine?: string
  ): Promise<any> {
    try {
      const body: any = { leftVersionId, rightVersionId };
      if (docxEngine) body.docxEngine = docxEngine;
      if (xlsxEngine) body.xlsxEngine = xlsxEngine;
      if (pdfEngine) body.pdfEngine = pdfEngine;
      if (pptxEngine) body.pptxEngine = pptxEngine;
      if (textEngine) body.textEngine = textEngine;
      return await KuikaAppManager.ApiRequest(screen, "documentmanagement/compare", body, "post");
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return null;
    }
  }

  /** Compare two versions and return as downloadable file. */
  public static async compareVersionsAsFile(
    screen: any,
    leftVersionId: string,
    rightVersionId: string,
    docxEngine?: string,
    xlsxEngine?: string,
    pdfEngine?: string,
    pptxEngine?: string,
    textEngine?: string
  ): Promise<any> {
    try {
      const body: any = { leftVersionId, rightVersionId };
      if (docxEngine) body.docxEngine = docxEngine;
      if (xlsxEngine) body.xlsxEngine = xlsxEngine;
      if (pdfEngine) body.pdfEngine = pdfEngine;
      if (pptxEngine) body.pptxEngine = pptxEngine;
      if (textEngine) body.textEngine = textEngine;
      return await KuikaAppManager.ApiRequest(screen, "documentmanagement/compare/as-file", body, "post");
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return null;
    }
  }

  // ── Indexing ─────────────────────────────────────────────────────

  public static async searchDocumentContent(
    screen: any,
    query: string,
    documentType?: string,
    tagName?: string,
    folderId?: string,
    language?: string,
    page?: number,
    pageSize?: number,
    createdAfter?: string,
    createdBefore?: string
  ): Promise<any> {
    try {
      return await KuikaAppManager.ApiRequest(
        screen,
        "documentmanagement/search/content",
        { query, documentType, tagName, folderId, language, page, pageSize, createdAfter, createdBefore },
        "post"
      );
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return null;
    }
  }

  public static async indexUnindexedDocuments(screen: any, batchSize?: number): Promise<any> {
    try {
      return (
        await KuikaAppManager.ApiRequest(screen, "documentmanagement/search/index-pending", { batchSize }, "post")
      )?.data;
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return null;
    }
  }

  public static async reindexDocument(screen: any, documentId: string): Promise<any> {
    try {
      const body: any = {};
      return await KuikaAppManager.ApiRequest(
        screen,
        `documentmanagement/${documentId}/reindex`,
        Object.keys(body).length ? body : undefined,
        "post"
      );
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return null;
    }
  }

  // ── Generic Search Engine ────────────────────────────────────────

  public static async indexSearchRecord(
    screen: any,
    indexName: string,
    recordId: string,
    content: string,
    metadata?: string
  ): Promise<any> {
    try {
      return await KuikaAppManager.ApiRequest(
        screen,
        "search/index",
        { indexName, recordId, content, metadata },
        "post"
      );
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return null;
    }
  }

  public static async searchRecords(
    screen: any,
    indexName: string,
    query: string,
    page?: number,
    pageSize?: number,
    filters?: string,
    sortBy?: string,
    sortDescending?: boolean
  ): Promise<any> {
    try {
      return await KuikaAppManager.ApiRequest(
        screen,
        "search/query",
        { indexName, query, page, pageSize, filters, sortBy, sortDescending },
        "post"
      );
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return null;
    }
  }

  public static async deleteSearchRecord(screen: any, indexName: string, recordId: string): Promise<boolean> {
    try {
      await KuikaAppManager.ApiRequest(
        screen,
        `search/${encodeURIComponent(indexName)}/${encodeURIComponent(recordId)}`,
        undefined,
        "delete"
      );
      return true;
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return false;
    }
  }

  public static async deleteSearchIndex(screen: any, indexName: string): Promise<boolean> {
    try {
      await KuikaAppManager.ApiRequest(screen, `search/${encodeURIComponent(indexName)}`, undefined, "delete");
      return true;
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return false;
    }
  }

  public static async getSearchIndexStats(screen: any, indexName: string): Promise<any> {
    try {
      return await KuikaAppManager.ApiRequest(
        screen,
        `search/${encodeURIComponent(indexName)}/stats`,
        undefined,
        "get"
      );
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return null;
    }
  }

  public static async getSearchEngineHealth(screen: any): Promise<any> {
    try {
      return await KuikaAppManager.ApiRequest(screen, "search/health", undefined, "get");
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return { healthy: false };
    }
  }

  public static async bulkIndexSearchRecords(screen: any, indexName: string, records: string): Promise<any> {
    try {
      return (await KuikaAppManager.ApiRequest(screen, "search/bulk-index", { indexName, records }, "post"))?.data;
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return null;
    }
  }

  public static async unifiedSearch(
    screen: any,
    query: string,
    indexNames: string,
    page?: number,
    pageSize?: number
  ): Promise<any> {
    try {
      return await KuikaAppManager.ApiRequest(screen, "search/unified", { query, indexNames, page, pageSize }, "post");
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return null;
    }
  }

  // ── Rollback ──────────────────────────────────────────────────────

  public static async rollbackToVersion(screen: any, versionId: string): Promise<any> {
    try {
      return await KuikaAppManager.ApiRequest(
        screen,
        `documentmanagement/versions/${versionId}/rollback`,
        undefined,
        "post"
      );
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return null;
    }
  }

  // ── Base64 Content ────────────────────────────────────────────────

  /** Returns document content as base64 JSON: { base64Content, mimeType, fileName, contentSize } */
  public static async getDocumentAsBase64(screen: any, documentId: string, language?: string): Promise<any> {
    try {
      const params = new URLSearchParams();
      if (language) params.set("language", language);
      const qs = params.toString();
      const url = qs ? `documentmanagement/${documentId}/base64?${qs}` : `documentmanagement/${documentId}/base64`;
      return await KuikaAppManager.ApiRequest(screen, url, undefined, "get");
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return null;
    }
  }

  /** Returns specific version content as base64 JSON: { base64Content, mimeType, fileName, versionId, version, language, contentSize } */
  public static async getVersionBase64(screen: any, versionId: string): Promise<any> {
    try {
      return await KuikaAppManager.ApiRequest(
        screen,
        `documentmanagement/versions/${versionId}/base64`,
        undefined,
        "get"
      );
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return null;
    }
  }

  // ── Trash / Recycle Bin ──────────────────────────────────────────

  public static async getDeletedDocuments(
    screen: any,
    page?: number,
    pageSize?: number,
    maxResults?: number
  ): Promise<any> {
    try {
      const params = new URLSearchParams();
      if (page) params.set("page", String(page));
      if (pageSize) params.set("pageSize", String(pageSize));
      if (maxResults) params.set("maxResults", String(maxResults));
      const qs = params.toString();
      return await KuikaAppManager.ApiRequest(
        screen,
        qs ? `documentmanagement/trash?${qs}` : "documentmanagement/trash",
        undefined,
        "get"
      );
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return { data: [] };
    }
  }

  public static async permanentDeleteDocument(screen: any, documentId: string): Promise<boolean> {
    try {
      const params = new URLSearchParams();
      const qs = params.toString();
      await KuikaAppManager.ApiRequest(
        screen,
        `documentmanagement/${documentId}/permanent${qs ? `?${qs}` : ""}`,
        undefined,
        "delete"
      );
      return true;
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return false;
    }
  }

  // ── Bulk Download ────────────────────────────────────────────────

  /** Downloads all documents in folderId (and subfolders) as a ZIP. */
  public static async bulkDownloadDocuments(screen: any, folderId: string, language?: string): Promise<void> {
    try {
      const base = KuikaAppManager.GetBackendUrl().replace(/\/$/, "");
      const reqBody: any = { folderId };
      if (language) reqBody.language = language;
      const response = await fetch(`${base}/documentmanagement/bulk/download`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify(reqBody)
      });
      if (!response.ok) throw new Error(`Download failed: ${response.status}`);
      const blob = await response.blob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "documents.zip";
      a.click();
      URL.revokeObjectURL(url);
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
    }
  }

  // ── Format Conversion ────────────────────────────────────────────

  public static async convertDocument(
    screen: any,
    documentId: string,
    versionId?: string,
    targetFormat: string = "pdf",
    language?: string,
    returnAsBase64?: boolean
  ): Promise<void> {
    try {
      const base = KuikaAppManager.GetBackendUrl().replace(/\/$/, "");
      const params = new URLSearchParams();
      params.set("targetFormat", targetFormat);
      if (returnAsBase64 !== undefined) params.set("returnAsBase64", String(returnAsBase64));
      const response = await fetch(`${base}/documentmanagement/${documentId}/convert?${params.toString()}`);
      if (!response.ok) throw new Error(`Conversion failed: ${response.status}`);
      const blob = await response.blob();
      const disposition = response.headers.get("content-disposition");
      const filename = disposition?.match(/filename="?([^"]+)"?/)?.[1] || `document.${targetFormat}`;
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = filename;
      a.click();
      URL.revokeObjectURL(url);
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
    }
  }

  // ── Auto Document Number ─────────────────────────────────────────

  public static async generateDocumentNumber(screen: any, pattern: string): Promise<any> {
    try {
      return (await KuikaAppManager.ApiRequest(screen, "documentmanagement/generate-number", { pattern }, "post"))
        ?.data;
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return null;
    }
  }

  // ── Dashboard / Reporting ────────────────────────────────────────

  public static async getDocumentStatusSummary(screen: any): Promise<any> {
    try {
      return await KuikaAppManager.ApiRequest(screen, "documentmanagement/dashboard/status-summary", undefined, "get");
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return null;
    }
  }

  public static async getStorageGrowth(screen: any, period?: string, from?: string, to?: string): Promise<any> {
    try {
      const params = new URLSearchParams();
      if (period) params.append("period", period);
      if (from) params.append("from", from);
      if (to) params.append("to", to);
      const qs = params.toString() ? `?${params.toString()}` : "";
      return await KuikaAppManager.ApiRequest(
        screen,
        `documentmanagement/dashboard/storage-growth${qs}`,
        undefined,
        "get"
      );
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return null;
    }
  }

  public static async getStorageByMimeType(screen: any, limit?: number): Promise<any> {
    try {
      const params = new URLSearchParams();
      if (limit) params.append("limit", String(limit));
      const qs = params.toString() ? `?${params.toString()}` : "";
      return await KuikaAppManager.ApiRequest(
        screen,
        `documentmanagement/dashboard/storage-by-mimetype${qs}`,
        undefined,
        "get"
      );
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return null;
    }
  }

  public static async getActivityTimeline(
    screen: any,
    period?: string,
    from?: string,
    to?: string,
    action?: string
  ): Promise<any> {
    try {
      const params = new URLSearchParams();
      if (period) params.append("period", period);
      if (from) params.append("from", from);
      if (to) params.append("to", to);
      if (action) params.append("action", action);
      const qs = params.toString() ? `?${params.toString()}` : "";
      return await KuikaAppManager.ApiRequest(
        screen,
        `documentmanagement/dashboard/activity-timeline${qs}`,
        undefined,
        "get"
      );
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return null;
    }
  }

  public static async getGlobalActivitySummary(screen: any, from?: string, to?: string): Promise<any> {
    try {
      const params = new URLSearchParams();
      if (from) params.append("from", from);
      if (to) params.append("to", to);
      const qs = params.toString() ? `?${params.toString()}` : "";
      return await KuikaAppManager.ApiRequest(
        screen,
        `documentmanagement/dashboard/activity-summary${qs}`,
        undefined,
        "get"
      );
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return null;
    }
  }

  public static async getTopActiveUsers(
    screen: any,
    limit?: number,
    from?: string,
    to?: string,
    action?: string
  ): Promise<any> {
    try {
      const params = new URLSearchParams();
      if (limit) params.append("limit", String(limit));
      if (from) params.append("from", from);
      if (to) params.append("to", to);
      if (action) params.append("action", action);
      const qs = params.toString() ? `?${params.toString()}` : "";
      return await KuikaAppManager.ApiRequest(
        screen,
        `documentmanagement/dashboard/top-active-users${qs}`,
        undefined,
        "get"
      );
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return null;
    }
  }

  public static async getAllDraftDocuments(
    screen: any,
    page?: number,
    pageSize?: number,
    maxResults?: number
  ): Promise<any> {
    try {
      const params = new URLSearchParams();
      if (page) params.append("page", String(page));
      if (pageSize) params.append("pageSize", String(pageSize));
      if (maxResults) params.append("maxResults", String(maxResults));
      const qs = params.toString() ? `?${params.toString()}` : "";
      return await KuikaAppManager.ApiRequest(screen, `documentmanagement/dashboard/all-drafts${qs}`, undefined, "get");
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return null;
    }
  }

  public static async getAllCheckedOutDocuments(
    screen: any,
    page?: number,
    pageSize?: number,
    maxResults?: number
  ): Promise<any> {
    try {
      const params = new URLSearchParams();
      if (page) params.append("page", String(page));
      if (pageSize) params.append("pageSize", String(pageSize));
      if (maxResults) params.append("maxResults", String(maxResults));
      const qs = params.toString() ? `?${params.toString()}` : "";
      return await KuikaAppManager.ApiRequest(
        screen,
        `documentmanagement/dashboard/all-checked-out${qs}`,
        undefined,
        "get"
      );
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return null;
    }
  }

  public static async getExpiringShareLinks(
    screen: any,
    daysUntilExpiry?: number,
    page?: number,
    pageSize?: number,
    maxResults?: number
  ): Promise<any> {
    try {
      const params = new URLSearchParams();
      if (daysUntilExpiry) params.append("daysUntilExpiry", String(daysUntilExpiry));
      if (page) params.append("page", String(page));
      if (pageSize) params.append("pageSize", String(pageSize));
      if (maxResults) params.append("maxResults", String(maxResults));
      const qs = params.toString() ? `?${params.toString()}` : "";
      return await KuikaAppManager.ApiRequest(
        screen,
        `documentmanagement/dashboard/expiring-shares${qs}`,
        undefined,
        "get"
      );
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return null;
    }
  }

  public static async getVersionStatistics(screen: any): Promise<any> {
    try {
      return await KuikaAppManager.ApiRequest(
        screen,
        "documentmanagement/dashboard/version-statistics",
        undefined,
        "get"
      );
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return null;
    }
  }

  public static async getDocumentIndexingStatus(screen: any): Promise<any> {
    try {
      return await KuikaAppManager.ApiRequest(screen, "documentmanagement/dashboard/indexing-status", undefined, "get");
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return null;
    }
  }

  public static async getLargestDocuments(
    screen: any,
    limit?: number,
    includeArchived?: boolean,
    draftFilter?: string,
    language?: string
  ): Promise<any> {
    try {
      const params = new URLSearchParams();
      if (limit) params.append("limit", String(limit));
      if (includeArchived != null) params.append("includeArchived", String(includeArchived));
      if (draftFilter) params.append("draftFilter", draftFilter);
      if (language) params.append("language", language);
      const qs = params.toString() ? `?${params.toString()}` : "";
      return await KuikaAppManager.ApiRequest(
        screen,
        `documentmanagement/dashboard/largest-documents${qs}`,
        undefined,
        "get"
      );
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return null;
    }
  }

  public static async getOldestUnmodifiedDocuments(
    screen: any,
    limit?: number,
    minAgeDays?: number,
    draftFilter?: string,
    language?: string
  ): Promise<any> {
    try {
      const params = new URLSearchParams();
      if (limit) params.append("limit", String(limit));
      if (minAgeDays) params.append("minAgeDays", String(minAgeDays));
      if (draftFilter) params.append("draftFilter", draftFilter);
      if (language) params.append("language", language);
      const qs = params.toString() ? `?${params.toString()}` : "";
      return await KuikaAppManager.ApiRequest(
        screen,
        `documentmanagement/dashboard/oldest-unmodified${qs}`,
        undefined,
        "get"
      );
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return null;
    }
  }

  // ── Compliance & Security Reports ────────────────────────────────

  public static async getPermissionReport(
    screen: any,
    documentId?: string,
    principalType?: string,
    page?: number,
    pageSize?: number,
    maxResults?: number
  ): Promise<any> {
    try {
      const params = new URLSearchParams();
      if (documentId) params.append("documentId", documentId);
      if (principalType) params.append("principalType", principalType);
      if (page) params.append("page", String(page));
      if (pageSize) params.append("pageSize", String(pageSize));
      if (maxResults) params.append("maxResults", String(maxResults));
      const qs = params.toString() ? `?${params.toString()}` : "";
      return await KuikaAppManager.ApiRequest(
        screen,
        `documentmanagement/dashboard/permission-report${qs}`,
        undefined,
        "get"
      );
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return null;
    }
  }

  public static async getAnonymousAccessReport(
    screen: any,
    from?: string,
    to?: string,
    page?: number,
    pageSize?: number,
    maxResults?: number
  ): Promise<any> {
    try {
      const params = new URLSearchParams();
      if (from) params.append("from", from);
      if (to) params.append("to", to);
      if (page) params.append("page", String(page));
      if (pageSize) params.append("pageSize", String(pageSize));
      if (maxResults) params.append("maxResults", String(maxResults));
      const qs = params.toString() ? `?${params.toString()}` : "";
      return await KuikaAppManager.ApiRequest(
        screen,
        `documentmanagement/dashboard/anonymous-access${qs}`,
        undefined,
        "get"
      );
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return null;
    }
  }

  public static async getFailedAccessAttempts(
    screen: any,
    from?: string,
    to?: string,
    page?: number,
    pageSize?: number,
    maxResults?: number
  ): Promise<any> {
    try {
      const params = new URLSearchParams();
      if (from) params.append("from", from);
      if (to) params.append("to", to);
      if (page) params.append("page", String(page));
      if (pageSize) params.append("pageSize", String(pageSize));
      if (maxResults) params.append("maxResults", String(maxResults));
      const qs = params.toString() ? `?${params.toString()}` : "";
      return await KuikaAppManager.ApiRequest(
        screen,
        `documentmanagement/dashboard/failed-access${qs}`,
        undefined,
        "get"
      );
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return null;
    }
  }

  // ── User & Folder Reports ──────────────────────────────────────

  public static async getUserStorageReport(screen: any, limit?: number): Promise<any> {
    try {
      const params = new URLSearchParams();
      if (limit) params.append("limit", String(limit));
      const qs = params.toString() ? `?${params.toString()}` : "";
      return await KuikaAppManager.ApiRequest(
        screen,
        `documentmanagement/dashboard/user-storage${qs}`,
        undefined,
        "get"
      );
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return null;
    }
  }

  public static async getMyActivitySummary(screen: any, from?: string, to?: string): Promise<any> {
    try {
      const params = new URLSearchParams();
      if (from) params.append("from", from);
      if (to) params.append("to", to);
      const qs = params.toString() ? `?${params.toString()}` : "";
      return await KuikaAppManager.ApiRequest(
        screen,
        `documentmanagement/dashboard/my-activity${qs}`,
        undefined,
        "get"
      );
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return null;
    }
  }

  public static async getEmptyFolders(
    screen: any,
    page?: number,
    pageSize?: number,
    maxResults?: number
  ): Promise<any> {
    try {
      const params = new URLSearchParams();
      if (page) params.append("page", String(page));
      if (pageSize) params.append("pageSize", String(pageSize));
      if (maxResults) params.append("maxResults", String(maxResults));
      const qs = params.toString() ? `?${params.toString()}` : "";
      return await KuikaAppManager.ApiRequest(
        screen,
        `documentmanagement/dashboard/empty-folders${qs}`,
        undefined,
        "get"
      );
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return null;
    }
  }

  // ── Tag & Type Reports ─────────────────────────────────────────

  public static async getTagCloud(screen: any, limit?: number, tagGroup?: string): Promise<any> {
    try {
      const params = new URLSearchParams();
      if (limit) params.append("limit", String(limit));
      if (tagGroup) params.append("tagGroup", tagGroup);
      const qs = params.toString() ? `?${params.toString()}` : "";
      return await KuikaAppManager.ApiRequest(screen, `documentmanagement/dashboard/tag-cloud${qs}`, undefined, "get");
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return null;
    }
  }

  public static async getDocumentsByType(screen: any): Promise<any> {
    try {
      return await KuikaAppManager.ApiRequest(
        screen,
        "documentmanagement/dashboard/documents-by-type",
        undefined,
        "get"
      );
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return null;
    }
  }

  // ── Temp (Auto-Save Buffer) ─────────────────────────────────────

  // ── Temp Actions — all versionId-first ───────────────────────

  /** Save base64 content to temp buffer. For custom editors or programmatic content. */
  public static async saveBase64ToTemp(screen: any, versionId: string, base64Content: string): Promise<any> {
    try {
      return (
        await KuikaAppManager.ApiRequest(
          screen,
          "documentmanagement/temp/save-base64",
          { versionId, base64Content },
          "post"
        )
      )?.data;
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return null;
    }
  }

  /** Trigger OnlyOffice to save current editor content to temp via Command Service. */
  public static async saveEditorToTemp(screen: any, versionId: string): Promise<any> {
    try {
      return await KuikaAppManager.ApiRequest(
        screen,
        "documentmanagement/temp/save-from-editor",
        { versionId },
        "post"
      );
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return null;
    }
  }

  /** Check if a temp buffer exists for a version. Returns { exists, tempId, lastSavedAt, ... } */
  public static async getTempStatus(screen: any, versionId: string): Promise<any> {
    try {
      return await KuikaAppManager.ApiRequest(
        screen,
        `documentmanagement/temp/status?versionId=${versionId}`,
        undefined,
        "get"
      );
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return null;
    }
  }

  /** Get temp content as base64. Returns { base64Content, sourceVersionId, lastSavedAt } */
  public static async getTempContent(screen: any, versionId: string): Promise<any> {
    try {
      return await KuikaAppManager.ApiRequest(
        screen,
        `documentmanagement/temp/recover?versionId=${versionId}`,
        undefined,
        "post"
      );
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return null;
    }
  }

  /** Discard (delete) temp buffer for a version. */
  public static async discardTemp(screen: any, versionId: string): Promise<any> {
    try {
      return (
        await KuikaAppManager.ApiRequest(
          screen,
          `documentmanagement/temp/discard?versionId=${versionId}`,
          undefined,
          "delete"
        )
      )?.data;
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return null;
    }
  }

  /** Publish temp as a new version. Returns { versionId } */
  public static async publishTempAsNewVersion(
    screen: any,
    versionId: string,
    changeNote?: string,
    discardExistingDraft?: boolean,
    keepTemp?: boolean
  ): Promise<any> {
    try {
      const params = new URLSearchParams({ versionId });
      if (changeNote) params.append("changeNote", changeNote);
      if (discardExistingDraft) params.append("discardExistingDraft", "true");
      if (keepTemp) params.append("keepTemp", "true");
      return await KuikaAppManager.ApiRequest(
        screen,
        `documentmanagement/temp/save-to-version?${params.toString()}`,
        undefined,
        "post"
      );
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return null;
    }
  }

  /** Save temp as draft. Returns { draftId } */
  public static async saveTempAsDraft(
    screen: any,
    versionId: string,
    changeNote?: string,
    discardExistingDraft?: boolean,
    keepTemp?: boolean
  ): Promise<any> {
    try {
      const params = new URLSearchParams({ versionId });
      if (changeNote) params.append("changeNote", changeNote);
      if (discardExistingDraft) params.append("discardExistingDraft", "true");
      if (keepTemp) params.append("keepTemp", "true");
      return await KuikaAppManager.ApiRequest(
        screen,
        `documentmanagement/temp/save-to-draft?${params.toString()}`,
        undefined,
        "post"
      );
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return null;
    }
  }

  // ── Version-first operations (resolve documentId from versionId) ──

  /** Check out document by versionId. Backend resolves documentId. */
  public static async checkOut(screen: any, versionId: string, expiryHours?: number): Promise<any> {
    try {
      const qs = expiryHours ? `?expiryHours=${expiryHours}` : "";
      return await KuikaAppManager.ApiRequest(
        screen,
        `documentmanagement/versions/${versionId}/checkout${qs}`,
        undefined,
        "post"
      );
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return null;
    }
  }

  /** Undo check out by versionId. */
  public static async undoCheckOut(screen: any, versionId: string): Promise<boolean> {
    try {
      await KuikaAppManager.ApiRequest(
        screen,
        `documentmanagement/versions/${versionId}/undo-checkout`,
        undefined,
        "post"
      );
      return true;
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return false;
    }
  }

  /** Get checkout status by versionId. Returns { isCheckedOut, checkedOutBy, expiresAt } */
  public static async getCheckOutStatus(screen: any, versionId: string): Promise<any> {
    try {
      return await KuikaAppManager.ApiRequest(
        screen,
        `documentmanagement/versions/${versionId}/checkout-status`,
        undefined,
        "get"
      );
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return null;
    }
  }

  /** Convert version to target format. Returns { base64Content, mimeType, fileName } or triggers download. */
  // convertVersion removed — unreliable format conversion, use platform's existing PDF/print tools instead

  /** Print version — fetches file and opens browser print dialog. */
  public static async printVersion(screen: any, versionId: string, convertTo?: string): Promise<void> {
    try {
      const base = KuikaAppManager.GetBackendUrl().replace(/\/$/, "");
      const qs = convertTo ? `?convertTo=${convertTo}` : "";
      const resp = await axios.get(`${base}/documentmanagement/versions/${versionId}/print${qs}`, {
        responseType: "blob"
      });
      const blobUrl = URL.createObjectURL(resp.data);
      const iframe = document.createElement("iframe");
      iframe.style.display = "none";
      iframe.src = blobUrl;
      document.body.appendChild(iframe);
      iframe.onload = () => {
        iframe.contentWindow?.print();
        setTimeout(() => {
          document.body.removeChild(iframe);
          URL.revokeObjectURL(blobUrl);
        }, 5000);
      };
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
    }
  }

  /** Download controlled copy (watermarked) by versionId. */
  public static async downloadWatermarked(
    screen: any,
    versionId: string,
    watermarkText?: string,
    watermarkFontSize?: number,
    watermarkColor?: string,
    watermarkOpacity?: number,
    watermarkPosition?: string,
    watermarkOrientation?: string,
    watermarkDensity?: string
  ): Promise<void> {
    try {
      const base = KuikaAppManager.GetBackendUrl().replace(/\/$/, "");
      const resp = await axios.post(
        `${base}/documentmanagement/versions/${versionId}/controlled-copy/download`,
        {
          watermarkText,
          watermarkFontSize,
          watermarkColor,
          watermarkOpacity,
          watermarkPosition,
          watermarkOrientation,
          watermarkDensity
        },
        { responseType: "blob" }
      );
      const cd: string = resp.headers?.["content-disposition"] ?? "";
      const nameMatch = /filename=["']?([^;"'\r\n]+)["']?/i.exec(cd);
      KMainFunctions.downloadFile(resp.data, nameMatch?.[1] || "controlled-copy.pdf");
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
    }
  }

  /** Get controlled copy as base64 by versionId. Returns { base64, mimeType, fileName } */
  public static async getWatermarkedBase64(
    screen: any,
    versionId: string,
    watermarkText?: string,
    watermarkFontSize?: number,
    watermarkColor?: string,
    watermarkOpacity?: number,
    watermarkPosition?: string,
    watermarkOrientation?: string,
    watermarkDensity?: string
  ): Promise<any> {
    try {
      return await KuikaAppManager.ApiRequest(
        screen,
        `documentmanagement/versions/${versionId}/controlled-copy/base64`,
        {
          watermarkText,
          watermarkFontSize,
          watermarkColor,
          watermarkOpacity,
          watermarkPosition,
          watermarkOrientation,
          watermarkDensity
        },
        "post"
      );
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return null;
    }
  }

  // ── Checkout (versionId-first) ────────────────────────────────────

  /** Renew checkout lock. Only the user who checked out can renew. */
  public static async renewCheckOut(screen: any, versionId: string, expiryHours?: number): Promise<any> {
    try {
      const qs = expiryHours ? `?expiryHours=${expiryHours}` : "";
      return await KuikaAppManager.ApiRequest(
        screen,
        `documentmanagement/versions/${versionId}/renew-checkout${qs}`,
        undefined,
        "post"
      );
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return null;
    }
  }

  /** ADMIN: Force release checkout lock regardless of who checked out. */
  public static async forceUndoCheckOut(screen: any, versionId: string): Promise<boolean> {
    try {
      await KuikaAppManager.ApiRequest(
        screen,
        `documentmanagement/versions/${versionId}/force-undo-checkout`,
        undefined,
        "post"
      );
      return true;
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return false;
    }
  }

  /** Check in document with new content. Releases lock, creates version or draft. */
  public static async checkIn(
    screen: any,
    versionId: string,
    base64Content: string,
    changeNote?: string,
    publishImmediately?: boolean
  ): Promise<any> {
    try {
      return await KuikaAppManager.ApiRequest(
        screen,
        `documentmanagement/versions/${versionId}/checkin`,
        { base64Content, changeNote, publishImmediately },
        "post"
      );
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return null;
    }
  }

  // ── Combined Actions (forcesave + commit in one call) ────────────

  /** Editor → temp → new version. Returns { versionId } */
  public static async publishEditorAsNewVersion(
    screen: any,
    versionId: string,
    changeNote?: string,
    discardExistingDraft?: boolean,
    keepTemp?: boolean
  ): Promise<any> {
    try {
      return await KuikaAppManager.ApiRequest(
        screen,
        "documentmanagement/editor/publish",
        { versionId, changeNote, discardExistingDraft, keepTemp },
        "post"
      );
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return null;
    }
  }

  /** Editor → temp → draft. Returns { draftId } */
  public static async saveEditorAsDraft(
    screen: any,
    versionId: string,
    changeNote?: string,
    discardExistingDraft?: boolean,
    keepTemp?: boolean
  ): Promise<any> {
    try {
      return await KuikaAppManager.ApiRequest(
        screen,
        "documentmanagement/editor/save-as-draft",
        { versionId, changeNote, discardExistingDraft, keepTemp },
        "post"
      );
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return null;
    }
  }

  /** Editor → overwrite same version (ADMIN ONLY). Returns { versionId, overwritten } */
  public static async overwriteVersionFromEditor(
    screen: any,
    versionId: string,
    changeNote?: string,
    discardExistingDraft?: boolean,
    keepTemp?: boolean
  ): Promise<any> {
    try {
      return await KuikaAppManager.ApiRequest(
        screen,
        "documentmanagement/editor/overwrite",
        { versionId, changeNote, discardExistingDraft, keepTemp },
        "post"
      );
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return null;
    }
  }

  /** Base64 → new version. Returns { versionId } */
  public static async publishBase64AsNewVersion(
    screen: any,
    versionId: string,
    base64Content: string,
    changeNote?: string,
    discardExistingDraft?: boolean,
    keepTemp?: boolean
  ): Promise<any> {
    try {
      return await KuikaAppManager.ApiRequest(
        screen,
        "documentmanagement/base64/publish",
        { versionId, base64Content, changeNote, discardExistingDraft, keepTemp },
        "post"
      );
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return null;
    }
  }

  /** Base64 → draft. Returns { draftId } */
  public static async saveBase64AsDraft(
    screen: any,
    versionId: string,
    base64Content: string,
    changeNote?: string,
    discardExistingDraft?: boolean,
    keepTemp?: boolean
  ): Promise<any> {
    try {
      return await KuikaAppManager.ApiRequest(
        screen,
        "documentmanagement/base64/save-as-draft",
        { versionId, base64Content, changeNote, discardExistingDraft, keepTemp },
        "post"
      );
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return null;
    }
  }

  /** Base64 → overwrite same version (ADMIN ONLY). Returns { versionId, overwritten } */
  public static async overwriteVersionFromBase64(
    screen: any,
    versionId: string,
    base64Content: string,
    changeNote?: string,
    discardExistingDraft?: boolean,
    keepTemp?: boolean
  ): Promise<any> {
    try {
      return await KuikaAppManager.ApiRequest(
        screen,
        "documentmanagement/base64/overwrite",
        { versionId, base64Content, changeNote, discardExistingDraft, keepTemp },
        "post"
      );
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return null;
    }
  }

  /** Compare temp content with original version. Returns { originalSize, tempSize, hasChanges } */
  public static async compareWithTemp(screen: any, versionId: string): Promise<any> {
    try {
      return await KuikaAppManager.ApiRequest(
        screen,
        `documentmanagement/temp/compare?versionId=${versionId}`,
        undefined,
        "post"
      );
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return null;
    }
  }

  // ── Audit Admin ─────────────────────────────────────────────────

  public static async getAuditLogStats(screen: any): Promise<any> {
    try {
      return await KuikaAppManager.ApiRequest(screen, "documentmanagement/audit/stats", undefined, "get");
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return null;
    }
  }

  public static async exportAuditLogsCsv(screen: any, from: string, to: string): Promise<any> {
    try {
      return (
        await KuikaAppManager.ApiRequest(
          screen,
          `documentmanagement/audit/export-csv?from=${encodeURIComponent(from)}&to=${encodeURIComponent(to)}`,
          undefined,
          "post"
        )
      )?.data;
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return null;
    }
  }

  public static async purgeAuditLogs(screen: any, from: string, to: string): Promise<any> {
    try {
      return await KuikaAppManager.ApiRequest(
        screen,
        `documentmanagement/audit/purge?from=${encodeURIComponent(from)}&to=${encodeURIComponent(to)}`,
        undefined,
        "delete"
      );
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return null;
    }
  }

  // ── Force / Admin Operations ────────────────────────��───────────

  public static async transferOwnership(screen: any, documentId: string, newOwnerId?: string): Promise<any> {
    try {
      const body: any = { newOwnerId };
      return (
        await KuikaAppManager.ApiRequest(screen, `documentmanagement/${documentId}/transfer-ownership`, body, "post")
      )?.data;
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return null;
    }
  }

  public static async permanentDeleteDraft(screen: any, versionId: string): Promise<any> {
    try {
      return (
        await KuikaAppManager.ApiRequest(
          screen,
          `documentmanagement/versions/${versionId}/force-delete-draft`,
          undefined,
          "delete"
        )
      )?.data;
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return null;
    }
  }

  /** Force-releases checkout locks on all documents in folderId (and subfolders). Returns affected count. */
  public static async bulkForceUndoCheckOut(screen: any, folderId: string): Promise<any> {
    try {
      const body: any = { folderId };
      return (await KuikaAppManager.ApiRequest(screen, "documentmanagement/bulk/force-undo-checkout", body, "post"))
        ?.data;
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return null;
    }
  }

  /** Permanently deletes all documents in folderId (and subfolders). Returns affected count. */
  public static async bulkPermanentDelete(screen: any, folderId: string): Promise<any> {
    try {
      const body: any = { folderId };
      return (await KuikaAppManager.ApiRequest(screen, "documentmanagement/bulk/permanent-delete", body, "post"))?.data;
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return null;
    }
  }

  /** Unarchives all documents in folderId (and subfolders). Returns affected count. */
  public static async bulkUnarchiveDocuments(screen: any, folderId: string): Promise<any> {
    try {
      const body: any = { folderId };
      return (await KuikaAppManager.ApiRequest(screen, "documentmanagement/bulk/unarchive", body, "post"))?.data;
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return null;
    }
  }

  /** Restores all soft-deleted documents in folderId (and subfolders). Returns affected count. */
  public static async bulkRestoreDocuments(screen: any, folderId: string): Promise<any> {
    try {
      const body: any = { folderId };
      return (await KuikaAppManager.ApiRequest(screen, "documentmanagement/bulk/restore", body, "post"))?.data;
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return null;
    }
  }

  /** Removes a tag from all documents in folderId (and subfolders). Returns affected count. */
  public static async bulkRemoveTag(screen: any, folderId: string, tagName: string): Promise<any> {
    try {
      const body: any = { folderId, tagName };
      return (await KuikaAppManager.ApiRequest(screen, "documentmanagement/bulk/remove-tag", body, "post"))?.data;
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return null;
    }
  }

  /** Sets a single metadata key-value pair on all documents in folderId (and subfolders). Returns affected count. */
  public static async bulkSetMetadata(
    screen: any,
    folderId: string,
    metadataKey: string,
    metadataValue?: string
  ): Promise<any> {
    try {
      const body: any = { folderId, metadataKey, metadataValue };
      return (await KuikaAppManager.ApiRequest(screen, "documentmanagement/bulk/set-metadata", body, "post"))?.data;
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return null;
    }
  }

  /** Sets the document type on all documents in folderId (and subfolders). Returns affected count. */
  public static async bulkSetDocumentType(screen: any, folderId: string, documentType: string): Promise<any> {
    try {
      const body: any = { folderId, documentType };
      return (await KuikaAppManager.ApiRequest(screen, "documentmanagement/bulk/set-document-type", body, "post"))
        ?.data;
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return null;
    }
  }

  /** Transfers ownership of all documents in folderId (and subfolders) to newOwnerId. Returns affected count. */
  public static async bulkTransferOwnership(screen: any, folderId: string, newOwnerId: string): Promise<any> {
    try {
      const body: any = { folderId, newOwnerId };
      return (await KuikaAppManager.ApiRequest(screen, "documentmanagement/bulk/transfer-ownership", body, "post"))
        ?.data;
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return null;
    }
  }

  public static async restoreFolder(screen: any, folderId: string): Promise<any> {
    try {
      return (
        await KuikaAppManager.ApiRequest(screen, `documentmanagement/folders/${folderId}/restore`, undefined, "post")
      )?.data;
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return null;
    }
  }

  /**
   * Creates a new blank document with a valid skeleton file for the given MIME type.
   * Office formats (docx/xlsx/pptx) get minimal valid OOXML so they open correctly in editors.
   * @param mimeType - MIME type (default: docx). Supported: docx, xlsx, pptx, txt, md, html, json, xml.
   * @param isDraft - true (default) = draft, false = published.
   */
  public static async createBlankDocument(
    screen: any,
    documentName: string,
    folderId?: string,
    language?: string,
    documentNumber?: string,
    documentType?: string,
    mimeType?: string,
    isDraft?: boolean
  ): Promise<any> {
    try {
      return await KuikaAppManager.ApiRequest(
        screen,
        "documentmanagement/create-blank",
        {
          documentName,
          folderId: folderId || null,
          language: language || null,
          documentNumber: documentNumber || null,
          documentType: documentType || null,
          mimeType: mimeType || "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
          isDraft: isDraft !== undefined ? isDraft : true
        },
        "post"
      );
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return null;
    }
  }

  public static async emptyTrash(screen: any): Promise<any> {
    try {
      return (await KuikaAppManager.ApiRequest(screen, "documentmanagement/trash/empty", undefined, "delete"))?.data;
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return null;
    }
  }

  // ── My Checked Out ─────────────────────────────────────────────

  public static async getMyCheckedOutDocuments(
    screen: any,
    page?: number,
    pageSize?: number,
    maxResults?: number
  ): Promise<any> {
    try {
      const params = new URLSearchParams();
      if (page) params.append("page", String(page));
      if (pageSize) params.append("pageSize", String(pageSize));
      if (maxResults) params.append("maxResults", String(maxResults));
      const qs = params.toString() ? `?${params.toString()}` : "";
      return await KuikaAppManager.ApiRequest(screen, `documentmanagement/my-checked-out${qs}`, undefined, "get");
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return null;
    }
  }

  /**
   * GET /v1/api/documentmanagement/versions/{versionId}/document-info
   * Resolves a versionId to its parent document and returns document metadata.
   */
  public static async getDocumentByVersionId(screen: any, versionId: string): Promise<any> {
    try {
      return await KuikaAppManager.ApiRequest(
        screen,
        `documentmanagement/versions/${versionId}/document-info`,
        undefined,
        "get"
      );
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return null;
    }
  }

  // ── Navigation / Lookup ─────────────────────────────────────────

  public static async getParentFolderId(screen: any, folderId: string): Promise<any> {
    try {
      return (
        await KuikaAppManager.ApiRequest(screen, `documentmanagement/folders/${folderId}/parent-id`, undefined, "get")
      )?.data;
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return null;
    }
  }

  public static async getDocumentFolderId(screen: any, documentId: string): Promise<any> {
    try {
      const params = new URLSearchParams();
      const qs = params.toString();
      return (
        await KuikaAppManager.ApiRequest(
          screen,
          `documentmanagement/${documentId}/folder-id${qs ? `?${qs}` : ""}`,
          undefined,
          "get"
        )
      )?.data;
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return null;
    }
  }

  /**
   * GET /v1/api/documentmanagement/{documentId}/current-version-id[?language=tr]
   * Returns the versionId of the latest published version. When language is provided,
   * returns the specific language variant. Use to resolve a versionId before SetValueOf on Document element.
   */
  public static async getLatestVersionId(screen: any, documentId: string, language?: string): Promise<any> {
    try {
      const params = new URLSearchParams();
      if (language) params.set("language", language);
      const qs = params.toString();
      return (
        await KuikaAppManager.ApiRequest(
          screen,
          `documentmanagement/${documentId}/current-version-id${qs ? `?${qs}` : ""}`,
          undefined,
          "get"
        )
      )?.data;
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return null;
    }
  }

  public static async getFolderPath(screen: any, folderId: string): Promise<any> {
    try {
      return await KuikaAppManager.ApiRequest(screen, `documentmanagement/folders/${folderId}/path`, undefined, "get");
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return null;
    }
  }

  public static async getFolderById(screen: any, folderId: string): Promise<any> {
    try {
      return await KuikaAppManager.ApiRequest(
        screen,
        `documentmanagement/folders/${folderId}/details`,
        undefined,
        "get"
      );
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return null;
    }
  }

  public static async getDocumentCount(
    screen: any,
    folderId?: string,
    includeSubfolders?: boolean,
    includeArchived?: boolean
  ): Promise<any> {
    try {
      const params = new URLSearchParams();
      if (folderId) params.append("folderId", folderId);
      if (includeSubfolders != null) params.append("includeSubfolders", String(includeSubfolders));
      if (includeArchived != null) params.append("includeArchived", String(includeArchived));
      const qs = params.toString() ? `?${params.toString()}` : "";
      return (await KuikaAppManager.ApiRequest(screen, `documentmanagement/count/documents${qs}`, undefined, "get"))
        ?.data;
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return null;
    }
  }

  public static async getFolderCount(screen: any, parentFolderId?: string, includeSubfolders?: boolean): Promise<any> {
    try {
      const params = new URLSearchParams();
      if (parentFolderId) params.append("parentFolderId", parentFolderId);
      if (includeSubfolders != null) params.append("includeSubfolders", String(includeSubfolders));
      const qs = params.toString() ? `?${params.toString()}` : "";
      return (await KuikaAppManager.ApiRequest(screen, `documentmanagement/count/folders${qs}`, undefined, "get"))
        ?.data;
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return null;
    }
  }

  public static async documentExists(screen: any, documentId: string): Promise<any> {
    try {
      const params = new URLSearchParams();
      const qs = params.toString();
      return (
        await KuikaAppManager.ApiRequest(
          screen,
          `documentmanagement/${documentId}/exists${qs ? `?${qs}` : ""}`,
          undefined,
          "get"
        )
      )?.data;
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return null;
    }
  }

  public static async folderExists(screen: any, folderId: string): Promise<any> {
    try {
      return (
        await KuikaAppManager.ApiRequest(screen, `documentmanagement/folders/${folderId}/exists`, undefined, "get")
      )?.data;
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return null;
    }
  }

  public static async getDocumentIdByNumber(screen: any, documentNumber: string): Promise<any> {
    try {
      return await KuikaAppManager.ApiRequest(
        screen,
        `documentmanagement/by-number/${encodeURIComponent(documentNumber)}`,
        undefined,
        "get"
      );
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return null;
    }
  }

  // ── Print & Controlled Copy ──────────────────────────────────────

  /**
   * GET document as blob and open the browser print dialog via a hidden iframe.
   * Optionally convert to another format, apply watermark, or select a specific version/language.
   */
  public static async printDocument(
    screen: any,
    documentId: string,
    versionId?: string,
    language?: string,
    convertTo?: string,
    watermark?: boolean
  ): Promise<void> {
    try {
      const base = KuikaAppManager.GetBackendUrl().replace(/\/$/, "");
      const params = new URLSearchParams();
      if (convertTo) params.set("convertTo", convertTo);
      if (watermark) params.set("watermark", "true");
      const qs = params.toString();
      const pathSegment = versionId
        ? `documentmanagement/versions/${versionId}/file`
        : `documentmanagement/${documentId}/file`;
      const resp = await axios.get(`${base}/${pathSegment}${qs ? `?${qs}` : ""}`, {
        responseType: "blob"
      });

      const blob: Blob = resp.data;
      const blobUrl = URL.createObjectURL(blob);
      const iframe = document.createElement("iframe");
      iframe.style.display = "none";
      iframe.src = blobUrl;
      document.body.appendChild(iframe);
      iframe.onload = () => {
        try {
          iframe.contentWindow?.print();
        } finally {
          setTimeout(() => {
            document.body.removeChild(iframe);
            URL.revokeObjectURL(blobUrl);
          }, 1000);
        }
      };
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
    }
  }

  /**
   * POST watermark params, download the controlled copy as a file.
   * Endpoint: /documentmanagement/{documentId}/watermark/download
   */
  public static async downloadControlledCopy(
    screen: any,
    documentId: string,
    versionId?: string,
    language?: string,
    watermarkText: string = "",
    watermarkFontSize?: number,
    watermarkColor?: string,
    watermarkOpacity?: number,
    watermarkPosition?: string,
    watermarkOrientation?: string,
    watermarkDensity?: string
  ): Promise<void> {
    try {
      const base = KuikaAppManager.GetBackendUrl().replace(/\/$/, "");
      const body: any = { watermarkText };
      if (watermarkFontSize != null) body.watermarkFontSize = watermarkFontSize;
      if (watermarkColor) body.watermarkColor = watermarkColor;
      if (watermarkOpacity != null) body.watermarkOpacity = watermarkOpacity;
      if (watermarkPosition) body.watermarkPosition = watermarkPosition;
      if (watermarkOrientation) body.watermarkOrientation = watermarkOrientation;
      if (watermarkDensity) body.watermarkDensity = watermarkDensity;

      const resp = await axios.post(`${base}/documentmanagement/${documentId}/watermark/download`, body, {
        responseType: "blob"
      });

      // Resolve filename from Content-Disposition header
      const cd: string = resp.headers?.["content-disposition"] ?? "";
      const extMatch = /filename\*=UTF-8''([^;"'\r\n]+)/i.exec(cd);
      const basicMatch = /filename=["']?([^;"'\r\n]+)["']?/i.exec(cd);
      const raw = extMatch?.[1] ?? basicMatch?.[1];
      const resolvedName = raw ? decodeURIComponent(raw.trim().replace(/['"]/g, "")) : "controlled-copy.pdf";

      KMainFunctions.downloadFile(resp.data, resolvedName);
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
    }
  }

  /**
   * POST watermark params, return the controlled copy as base64.
   * Endpoint: /documentmanagement/{documentId}/watermark/base64
   * @returns { base64: string, mimeType: string, fileName: string } | null
   */
  public static async getControlledCopyAsBase64(
    screen: any,
    documentId: string,
    versionId?: string,
    language?: string,
    watermarkText: string = "",
    watermarkFontSize?: number,
    watermarkColor?: string,
    watermarkOpacity?: number,
    watermarkPosition?: string,
    watermarkOrientation?: string,
    watermarkDensity?: string
  ): Promise<{ base64: string; mimeType: string; fileName: string } | null> {
    try {
      const base = KuikaAppManager.GetBackendUrl().replace(/\/$/, "");
      const body: any = { watermarkText };
      if (watermarkFontSize != null) body.watermarkFontSize = watermarkFontSize;
      if (watermarkColor) body.watermarkColor = watermarkColor;
      if (watermarkOpacity != null) body.watermarkOpacity = watermarkOpacity;
      if (watermarkPosition) body.watermarkPosition = watermarkPosition;
      if (watermarkOrientation) body.watermarkOrientation = watermarkOrientation;
      if (watermarkDensity) body.watermarkDensity = watermarkDensity;

      const resp = await axios.post(`${base}/documentmanagement/${documentId}/watermark/base64`, body);

      return resp.data ?? null;
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return null;
    }
  }

  /**
   * POST watermark params, get blob, open browser print dialog via hidden iframe.
   * Endpoint: /documentmanagement/{documentId}/watermark/print-data
   */
  public static async printControlledCopy(
    screen: any,
    documentId: string,
    versionId?: string,
    language?: string,
    watermarkText: string = "",
    watermarkFontSize?: number,
    watermarkColor?: string,
    watermarkOpacity?: number,
    watermarkPosition?: string,
    watermarkOrientation?: string,
    watermarkDensity?: string
  ): Promise<void> {
    try {
      const base = KuikaAppManager.GetBackendUrl().replace(/\/$/, "");
      const body: any = { watermarkText };
      if (watermarkFontSize != null) body.watermarkFontSize = watermarkFontSize;
      if (watermarkColor) body.watermarkColor = watermarkColor;
      if (watermarkOpacity != null) body.watermarkOpacity = watermarkOpacity;
      if (watermarkPosition) body.watermarkPosition = watermarkPosition;
      if (watermarkOrientation) body.watermarkOrientation = watermarkOrientation;
      if (watermarkDensity) body.watermarkDensity = watermarkDensity;

      const resp = await axios.post(`${base}/documentmanagement/${documentId}/watermark/print-data`, body, {
        responseType: "blob"
      });

      const blob: Blob = resp.data;
      const blobUrl = URL.createObjectURL(blob);
      const iframe = document.createElement("iframe");
      iframe.style.display = "none";
      iframe.src = blobUrl;
      document.body.appendChild(iframe);
      iframe.onload = () => {
        try {
          iframe.contentWindow?.print();
        } finally {
          setTimeout(() => {
            document.body.removeChild(iframe);
            URL.revokeObjectURL(blobUrl);
          }, 1000);
        }
      };
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
    }
  }

  // ── End Document Management ───────────────────────────────────────

  public static getCurrentUrl = () => {
    return window.location.href;
  };

  public static printTcpl(value: any, printName: any) {
    return false;
  }

  private static getParentOfBaseTableElementRef = (screen, refValue: string) => {
    return (
      screen[`${refValue}_kuikaTableRef`] ||
      screen[`${refValue}_kuikaGalleryViewRef`] ||
      screen[`${refValue}_kuikaCarouselRef`] ||
      screen[`${refValue}_kuikaFlexGridRef`]
    );
  };
}
